/* global window, document, Muuri */
(function (window, document) {
    var root = document.getElementById('vg-kanban-root');
    if (!root) return;
    // Guard: avoid double init if script is included twice (e.g. template + code injection),
    // which would attach duplicate click handlers and make toggles appear broken.
    if (root.getAttribute('data-vg-kanban-init') === '1') return;
    root.setAttribute('data-vg-kanban-init', '1');
    var SHOW_ARCHIVED_KEY = 'vg-kanban-show-archived';
    var KIND_FILTER_KEY = 'vg-kanban-kind-filter';
    var PROFILE_MODAL_KEY = 'vg-kanban-profile-modal';
    var _vgFocusRefreshDocsCb = null;

    function setStatusEarly(msg) {
        var el = root.querySelector('[data-kanban-status]');
        if (el) el.textContent = msg || '';
    }

    function injectNoIndexIfMissing() {
        var list = document.querySelectorAll('meta[name="robots"]');
        for (var i = 0; i < list.length; i++) {
            var c = (list[i].getAttribute('content') || '').toLowerCase();
            if (c.indexOf('noindex') !== -1) return;
        }
        var m = document.createElement('meta');
        m.name = 'robots';
        m.content = 'noindex,nofollow';
        m.setAttribute('data-vg-kanban', 'robots');
        var head = document.head || document.getElementsByTagName('head')[0];
        if (head) head.insertBefore(m, head.firstChild);
    }

    /** Muuri + CSS serviti dal tema (page-kanban / custom-kanban); fallback link in head. */
    function ensureMuuriThen(done) {
        function injectCssIfMissing() {
            var href = (root.getAttribute('data-muuri-css') || '').trim();
            if (!href || document.querySelector('link[data-vg-kanban-muuri-css]')) return;
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.setAttribute('data-vg-kanban-muuri-css', '1');
            (document.head || document.documentElement).appendChild(link);
        }
        injectCssIfMissing();
        if (typeof Muuri !== 'undefined') {
            done(null);
            return;
        }
        var n = 0;
        var iv = setInterval(function () {
            n += 1;
            if (typeof Muuri !== 'undefined') {
                clearInterval(iv);
                done(null);
            } else if (n > 400) {
                clearInterval(iv);
                done(new Error('Timeout: script Muuri del tema non eseguito'));
            }
        }, 50);
    }

    function initBoard() {
    function qs(sel, el) {
        return (el || document).querySelector(sel);
    }

    function setStatus(msg) {
        var el = qs('[data-kanban-status]', root);
        if (el) el.textContent = msg || '';
    }

    function ensureProfileModal() {
        var existing = document.getElementById(PROFILE_MODAL_KEY);
        if (existing) return existing;
        var wrap = document.createElement('div');
        wrap.id = PROFILE_MODAL_KEY;
        wrap.className = 'vg-kanban-modal';
        wrap.setAttribute('hidden', 'hidden');
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel" role="document">' +
            '  <h2 class="vg-kanban-modal__title">Company profile incompleto</h2>' +
            '  <p class="vg-kanban-modal__message">Per avviare l’analisi AI devi completare questi dati minimi:</p>' +
            '  <ul class="vg-kanban-modal__checklist" data-checklist></ul>' +
            '  <div class="vg-kanban-modal__actions">' +
            '    <button type="button" class="vg-kanban-modal__btn" data-close><span aria-hidden="true">✖️</span> Chiudi</button>' +
            '    <a class="vg-kanban-modal__btn vg-kanban-modal__btn--danger" href="/company-profile/" target="_blank" rel="noopener" data-goto><span aria-hidden="true">📇</span> Vai al Company Profile</a>' +
            '  </div>' +
            '</div>';
        (document.body || document.documentElement).appendChild(wrap);
        return wrap;
    }

    function profileRequirementList() {
        return [
            { key: 'company_profile', label: 'Creare il Company Profile' },
            { key: 'organization_name', label: 'Ragione sociale' },
            { key: 'vat_or_tax_code', label: 'Partita IVA oppure Codice fiscale' },
            { key: 'cpv', label: 'Almeno 1 CPV di interesse' }
        ];
    }

    function openProfileModal(missingKeys) {
        var missing = Array.isArray(missingKeys) ? missingKeys.map(function (x) { return String(x || '').trim(); }) : [];
        var modal = ensureProfileModal();
        var list = modal.querySelector('[data-checklist]');
        if (list) {
            list.innerHTML = '';
            var reqs = profileRequirementList();
            var hasProfile = missing.indexOf('company_profile') === -1;
            reqs.forEach(function (r) {
                var isMissing = missing.indexOf(r.key) !== -1;
                // If profile itself is missing, everything is effectively missing.
                if (!hasProfile && r.key !== 'company_profile') isMissing = true;
                var li = document.createElement('li');
                li.className = 'vg-kanban-modal__checkitem ' + (isMissing ? 'is-missing' : 'is-ok');
                li.innerHTML =
                    '<span class="vg-kanban-modal__checkicon" aria-hidden="true">' + (isMissing ? '❌' : '✅') + '</span>' +
                    '<span class="vg-kanban-modal__checklabel">' + escapeHtml(r.label) + '</span>';
                list.appendChild(li);
            });
        }

        modal.removeAttribute('hidden');
        var btnClose = modal.querySelector('[data-close]');
        var prev = document.activeElement;
        try { (btnClose || modal).focus(); } catch (e) {}

        function close() {
            cleanup();
            modal.setAttribute('hidden', 'hidden');
            try { if (prev && prev.focus) prev.focus(); } catch (e) {}
        }
        function onKey(e) { if (e.key === 'Escape') close(); }
        function onBackdrop(e) { if (e.target === modal) close(); }
        function onClose() { close(); }
        function cleanup() {
            document.removeEventListener('keydown', onKey);
            modal.removeEventListener('click', onBackdrop);
            if (btnClose) btnClose.removeEventListener('click', onClose);
        }
        document.addEventListener('keydown', onKey);
        modal.addEventListener('click', onBackdrop);
        if (btnClose) btnClose.addEventListener('click', onClose);
    }

    function maybeShowProfileIncompleteDialog(err) {
        if (!err || err.status !== 422) return false;
        var d = err.data && err.data.detail ? err.data.detail : null;
        var miss = d && d.missing_profile_data ? d.missing_profile_data : null;
        if (!miss) return false;
        setStatus('');
        openProfileModal(miss);
        return true;
    }

    function apiBase() {
        var base = (root.getAttribute('data-api-base') || '').trim();
        if (!base) return '/api';
        return base.replace(/\/+$/, '');
    }

    async function fetchGhostSessionToken() {
        var r = await fetch('/members/api/session/', { method: 'GET', credentials: 'include' });
        if (r.status === 204) return null;
        if (!r.ok) throw new Error('Ghost session ' + r.status);
        var token = (await r.text()).trim();
        return token || null;
    }

    async function loginOnGateway(sessionToken) {
        var url = apiBase() + '/auth/ghost/session/login';
        var r = await fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ session_token: sessionToken })
        });
        var data = await r.json().catch(function () { return {}; });
        if (!r.ok) throw new Error(data.detail || ('HTTP ' + r.status));
        return data;
    }

    async function apiJson(path, opts) {
        opts = opts || {};
        var url = apiBase() + path;
        var r;
        try {
            r = await fetch(url, {
                method: opts.method || 'GET',
                credentials: 'include',
                headers: Object.assign(
                    { Accept: 'application/json', 'Content-Type': 'application/json' },
                    opts.headers || {}
                ),
                body: opts.body != null ? JSON.stringify(opts.body) : undefined
            });
        } catch (netErr) {
            var nerr = new Error((netErr && netErr.message) ? netErr.message : 'Errore di rete');
            nerr.status = 0;
            nerr.path = path;
            nerr.url = url;
            nerr.cause = 'network';
            throw nerr;
        }
        var ct = String(r.headers.get('content-type') || '').toLowerCase();
        var data = {};
        if (ct.indexOf('application/json') >= 0) {
            data = await r.json().catch(function () { return {}; });
        } else {
            var raw = await r.text().catch(function () { return ''; });
            data = { _raw: String(raw || '').slice(0, 1200) };
        }
        if (!r.ok) {
            var d = data && data.detail;
            var msg =
                typeof d === 'string'
                    ? d
                    : Array.isArray(d)
                        ? d.map(function (x) {
                            if (!x || typeof x !== 'object') return String(x);
                            var loc = Array.isArray(x.loc) ? x.loc.join('.') : '';
                            return (loc ? loc + ': ' : '') + String(x.msg || x.type || JSON.stringify(x));
                        }).join('\n')
                    : d && typeof d.message === 'string'
                        ? d.message
                        : d
                            ? JSON.stringify(d)
                            : (data && data._raw)
                                ? String(data._raw).trim().slice(0, 400)
                                : (r.statusText || ('HTTP ' + r.status));
            var err = new Error(msg);
            err.status = r.status;
            err.statusText = r.statusText || '';
            err.data = data;
            err.path = path;
            err.url = url;
            throw err;
        }
        return data;
    }

    function formatCompileApiError(err, context) {
        context = context || {};
        var lines = [];
        var st = err && typeof err.status === 'number' ? err.status : 0;
        if (st) {
            lines.push('Codice HTTP: ' + st + (err.statusText ? ' (' + err.statusText + ')' : ''));
        } else if (err && err.cause === 'network') {
            lines.push('Codice HTTP: rete non disponibile (fetch fallita)');
        }
        if (context.action) lines.push('Operazione: ' + context.action);
        if (context.filename) lines.push('File: ' + context.filename);
        if (context.path) lines.push('Endpoint: ' + context.path);
        if (st === 504 || st === 502) {
            lines.push('');
            lines.push('Il proxy/API non ha risposto in tempo. Possibili cause:');
            var fn = String(context.filename || '').toLowerCase();
            var isDocx = fn.slice(-5) === '.docx' || String(context.contentType || '').indexOf('wordprocessingml') >= 0;
            if (isDocx) {
                lines.push('• gateway API non aggiornato (cerca handler_build "2026-05-14e" nella risposta);');
                lines.push('• prova GET …/compile-probe sullo stesso file (diagnostica veloce);');
                lines.push('• worker API non raggiungibile da nginx (504 HTML = timeout proxy);');
                lines.push('• fallback OpenAI solo se il modulo non ha placeholder né SDT.');
            } else {
                lines.push('• documento molto grande o senza moduli AcroForm (estrazione lenta);');
                lines.push('• chiamata OpenAI per schema GPT ancora in corso;');
                lines.push('• gateway API sovraccarico o in riavvio.');
                lines.push('Riprova tra poco; per PDF piatti usa la modalità editor libero dopo deploy API aggiornato.');
            }
        } else if (st === 401 || st === 403) {
            lines.push('');
            lines.push('Sessione scaduta o permessi insufficienti: ricarica la pagina e riprova.');
        } else if (st === 422) {
            lines.push('');
            lines.push('Il server ha rifiutato la richiesta (dati/documento non validi per la compilazione).');
        } else if (st >= 500) {
            lines.push('');
            lines.push('Errore interno del gateway API: verifica che il servizio sia attivo e aggiornato.');
        }
        var detail = (err && err.message) ? String(err.message).trim() : '';
        if (detail && detail !== 'HTTP ' + st) {
            lines.push('');
            lines.push('Dettaglio server:');
            lines.push(detail);
        }
        if (err && err.data && err.data._raw && (!detail || detail.length < 8)) {
            lines.push('');
            lines.push('Risposta grezza:');
            lines.push(String(err.data._raw).trim().slice(0, 500));
        }
        return lines.join('\n');
    }

    function showCompileError(mountEl, err, context) {
        if (!mountEl) return;
        var body = formatCompileApiError(err, context);
        mountEl.innerHTML =
            '<div class="vg-kanban-compila__error"><strong>Impossibile generare il modulo</strong>' +
            '<pre class="vg-kanban-compila__error-detail">' + escapeHtml(body) + '</pre></div>';
    }

    function zoneForState(state) {
        if (state === 'to_evaluate') return 'to_evaluate';
        if (state === 'ai_queued' || state === 'ai_processing' || state === 'ai_ready' || state === 'ai_failed') {
            return 'ai';
        }
        if (state === 'decision') return 'decision';
        if (state === 'in_progress') return 'in_progress';
        if (state === 'archived') return 'archived';
        return 'to_evaluate';
    }

    /** Etichetta colonna Kanban (data-zone), allineata ai titoli in page-kanban.hbs. */
    function zoneTitleIt(zone) {
        switch (String(zone || '')) {
            case 'to_evaluate': return 'Da valutare';
            case 'ai': return 'Decisione';
            case 'decision': return 'In preparazione';
            case 'in_progress': return 'In consegna';
            case 'archived': return 'Archiviate';
            default: return String(zone || '').replace(/_/g, ' ');
        }
    }

    function inferTargetState(fromState, newZone) {
        if (newZone === 'to_evaluate') {
            // Un-archive is always allowed.
            if (fromState === 'archived') return 'to_evaluate';
            if (fromState === 'in_progress') return 'to_evaluate';
            if (fromState === 'decision') return 'to_evaluate';
            return null;
        }
        if (newZone === 'ai') {
            if (fromState === 'to_evaluate') return 'ai_queued';
            if (fromState === 'ai_failed') return 'ai_queued';
            if (fromState === 'decision') return 'ai_queued';
            return null;
        }
        if (newZone === 'decision') {
            if (fromState === 'ai_ready') return 'decision';
            // Allow skipping AI from "Da valutare" with explicit confirmation in UI.
            if (fromState === 'to_evaluate') return 'decision';
            return null;
        }
        if (newZone === 'in_progress') {
            if (fromState === 'decision') return 'in_progress';
            return null;
        }
        if (newZone === 'archived') {
            if (fromState === 'archived') return null;
            return 'archived';
        }
        return null;
    }

    function ensureManualCreateModal() {
        var existing = document.getElementById('vg-kanban-manual-create');
        if (existing) return existing;
        var wrap = document.createElement('div');
        wrap.id = 'vg-kanban-manual-create';
        wrap.className = 'vg-kanban-modal';
        wrap.setAttribute('hidden', 'hidden');
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel" role="document">' +
            '  <h2 class="vg-kanban-modal__title">Nuova gara (manuale)</h2>' +
            '  <p class="vg-kanban-modal__message">Crea una scheda privata nel tuo workspace. Poi potrai caricare i documenti nella scheda.</p>' +
            '  <div class="vg-kanban-modal__form" data-form>' +
            '    <div id="vg-kanban-manual-create-survey"></div>' +
            '  </div>' +
            '  <div class="vg-kanban-modal__actions">' +
            '    <button type="button" class="vg-kanban-modal__btn" data-prev hidden><span aria-hidden="true">◀️</span> Indietro</button>' +
            '    <button type="button" class="vg-kanban-modal__btn" data-next><span aria-hidden="true">➡️</span> Avanti</button>' +
            '    <button type="button" class="vg-kanban-modal__btn" data-cancel><span aria-hidden="true">✖️</span> Annulla</button>' +
            '    <button type="button" class="vg-kanban-modal__btn vg-kanban-modal__btn--danger" data-submit><span aria-hidden="true">➕</span> Crea</button>' +
            '  </div>' +
            '</div>';
        (document.body || document.documentElement).appendChild(wrap);
        return wrap;
    }

    function ensureSurveyAvailable() {
        if (!window.Survey || !window.Survey.Model) {
            throw new Error('SurveyJS non caricato (bundle casper.js).');
        }
    }

    function manualCreateSurveyJson() {
        return {
            css: {
                root: 'sv_root sv_default_css',
                navigation: { complete: 'vg-kanban-modal__btn vg-kanban-modal__btn--danger', next: 'vg-kanban-modal__btn', prev: 'vg-kanban-modal__btn' }
            },
            checkErrorsMode: 'onValueChanged',
            textUpdateMode: 'onBlur',
            showNavigationButtons: false,
            showProgressBar: 'top',
            progressBarType: 'pages',
            progressBarShowPageTitles: true,
            progressBarShowPageNumbers: false,
            pages: [
                {
                    name: 'base',
                    title: 'Dati essenziali',
                    elements: [
                        { type: 'text', name: 'title', title: 'Titolo', isRequired: true, maxLength: 400, placeholder: 'Titolo gara…' },
                        { type: 'text', name: 'buyer_name', title: 'Ente / Stazione appaltante', maxLength: 400 },
                        { type: 'text', name: 'cpv', visible: false },
                        {
                            type: 'html',
                            name: 'cpv_widget',
                            html: '' +
                                '<div class="appaltimap-cpv-wrap" aria-label="Filtro CPV">' +
                                '  <div class="appaltimap-cpv-search">' +
                                '    <input type="text" data-vg-cpv-query placeholder="cerca per descrizione o numero (es. 45 o 71631400)" maxlength="120" autocomplete="off" />' +
                                '    <button type="button" data-vg-cpv-clear class="appaltimap-cpv-clear" aria-label="Reset CPV" title="Reset CPV" disabled>X</button>' +
                                '    <input type="hidden" data-vg-cpv-prefix value="" />' +
                                '    <datalist data-vg-cpv-list></datalist>' +
                                '  </div>' +
                                '</div>'
                        }
                    ]
                },
                {
                    name: 'procedure',
                    title: 'Procedura',
                    elements: [
                        {
                            type: 'dropdown',
                            name: 'category',
                            title: 'Categoria',
                            choices: [
                                { value: '', text: '—' },
                                { value: 'works', text: 'Lavori' },
                                { value: 'services', text: 'Servizi' },
                                { value: 'supplies', text: 'Forniture' }
                            ]
                        },
                        { type: 'text', name: 'procedure_type', title: 'Procedura', maxLength: 200, placeholder: 'es. Aperta' },
                        { type: 'text', name: 'award_criteria', title: 'Criterio aggiudicazione', maxLength: 200, placeholder: 'es. OEPV' }
                    ]
                },
                {
                    name: 'economics',
                    title: 'Valori e scadenze',
                    elements: [
                        { type: 'text', name: 'amount_estimated', title: 'Importo stimato (EUR)', inputType: 'number', placeholder: 'EUR' },
                        { type: 'text', name: 'currency', title: 'Valuta', maxLength: 3, defaultValue: 'EUR' },
                        { type: 'text', name: 'deadline_local', title: 'Scadenza', inputType: 'datetime-local' }
                    ]
                },
                {
                    name: 'notes',
                    title: 'Link e note',
                    elements: [
                        { type: 'text', name: 'external_url', title: 'Link esterno', inputType: 'url', maxLength: 2048, placeholder: 'https://…' },
                        { type: 'comment', name: 'description', title: 'Descrizione', maxLength: 200000, placeholder: 'Testo libero…' }
                    ]
                }
            ]
        };
    }

    function openManualCreateModal() {
        var modal = ensureManualCreateModal();
        var btnPrev = modal.querySelector('[data-prev]');
        var btnNext = modal.querySelector('[data-next]');
        var btnCancel = modal.querySelector('[data-cancel]');
        var btnSubmit = modal.querySelector('[data-submit]');
        var prev = document.activeElement;
        modal.removeAttribute('hidden');
        try { document.documentElement.classList.add('vg-kanban-modal-lock'); } catch (eL) {}
        var survey = null;
        try {
            ensureSurveyAvailable();
            var mount = modal.querySelector('#vg-kanban-manual-create-survey');
            if (mount) {
                mount.innerHTML = '';
                survey = new Survey.Model(manualCreateSurveyJson());
                survey.onAfterRenderQuestion.add(function (_sender, options) {
                    var q = options && options.question ? options.question : null;
                    if (!q || q.name !== 'cpv_widget') return;
                    var rootEl = options && options.htmlElement ? options.htmlElement : null;
                    if (!rootEl) return;

                    var cpvInput = rootEl.querySelector('[data-vg-cpv-query]');
                    var cpvPrefixEl = rootEl.querySelector('[data-vg-cpv-prefix]');
                    var cpvClearBtn = rootEl.querySelector('[data-vg-cpv-clear]');
                    var cpvList = rootEl.querySelector('[data-vg-cpv-list]');
                    if (!cpvInput || !cpvPrefixEl || !cpvList) return;

                    var dlId = 'vg-kanban-cpv-dl';
                    try { cpvList.id = dlId; } catch (eId) {}
                    try { cpvInput.setAttribute('list', dlId); } catch (eLi) {}

                    var lastFetch = 0;
                    var pendingSuggest = null;
                    var lastResolvedPrefix = '';

                    function syncClearState() {
                        var has = !!String(cpvPrefixEl.value || '').trim() || !!String(cpvInput.value || '').trim();
                        if (cpvClearBtn) cpvClearBtn.disabled = !has;
                    }

                    function render(items) {
                        while (cpvList.firstChild) cpvList.removeChild(cpvList.firstChild);
                        (items || []).forEach(function (it) {
                            var opt = document.createElement('option');
                            var code = it.code_main || '';
                            var label = it.label_it || '';
                            opt.value = code + (label ? ' — ' + label : '');
                            cpvList.appendChild(opt);
                        });
                    }

                    function setPrefixFromInput() {
                        var raw = String(cpvInput.value || '').trim();
                        var digits = raw.replace(/\D/g, '');
                        if (!digits) {
                            cpvPrefixEl.value = '';
                            survey.setValue('cpv', '');
                            syncClearState();
                            return '';
                        }
                        if (digits.length > 8) digits = digits.slice(0, 8);
                        var prefix = digits.replace(/0+$/g, '');
                        if (!prefix) prefix = digits;
                        if (prefix === '0') prefix = '';
                        cpvPrefixEl.value = prefix;
                        survey.setValue('cpv', prefix);
                        syncClearState();
                        return prefix;
                    }

                    function fetchSuggest(q2) {
                        var now = Date.now();
                        lastFetch = now;
                        var url = apiBase() + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(q2) + '&limit=15';
                        return fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } })
                            .then(function (r) { return r.ok ? r.json() : {}; })
                            .then(function (data) {
                                if (lastFetch !== now) return;
                                render((data && data.items) || []);
                            })
                            .catch(function () {});
                    }

                    function resolveAndShowLabel(prefix2) {
                        var p = String(prefix2 || '').trim();
                        if (!p || p === lastResolvedPrefix) return Promise.resolve();
                        lastResolvedPrefix = p;
                        var url = apiBase() + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(p) + '&limit=1';
                        return fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } })
                            .then(function (r) { return r.ok ? r.json() : {}; })
                            .then(function (data) {
                                var it = data && data.items && data.items[0];
                                if (!it) return;
                                var code = String(it.code_main || '').trim();
                                var label = String(it.label_it || '').trim();
                                if (!code) return;
                                cpvInput.value = code + (label ? ' — ' + label : '');
                            })
                            .catch(function () {});
                    }

                    cpvInput.addEventListener('input', function () {
                        setPrefixFromInput();
                        var q2 = String(cpvInput.value || '').trim();
                        if (pendingSuggest) window.clearTimeout(pendingSuggest);
                        if (q2.length < 2 && !/\d/.test(q2)) return;
                        pendingSuggest = window.setTimeout(function () {
                            fetchSuggest(q2);
                        }, 180);
                    });
                    cpvInput.addEventListener('blur', function () {
                        var p = setPrefixFromInput();
                        resolveAndShowLabel(p);
                    });
                    if (cpvClearBtn) {
                        cpvClearBtn.addEventListener('click', function () {
                            cpvInput.value = '';
                            cpvPrefixEl.value = '';
                            lastResolvedPrefix = '';
                            survey.setValue('cpv', '');
                            syncClearState();
                            try { cpvInput.focus(); } catch (eF2) {}
                        });
                    }
                    syncClearState();
                });

                survey.render(mount);
            }
        } catch (eS) {
            setStatus((eS && eS.message) ? eS.message : 'Errore UI');
        }

        function syncNav() {
            if (!survey) return;
            var isFirst = !!survey.isFirstPage;
            var isLast = !!survey.isLastPage;
            if (btnPrev) btnPrev.hidden = isFirst;
            if (btnNext) btnNext.hidden = isLast;
            if (btnSubmit) btnSubmit.hidden = !isLast;
        }
        try { syncNav(); } catch (eSN) {}
        try {
            var ti = modal.querySelector('input') || modal.querySelector('textarea');
            if (ti && ti.focus) ti.focus();
        } catch (eF) {}

        function close() {
            cleanup();
            modal.setAttribute('hidden', 'hidden');
            try { document.documentElement.classList.remove('vg-kanban-modal-lock'); } catch (eL2) {}
            try { if (prev && prev.focus) prev.focus(); } catch (eP) {}
        }

        function onKey(e) { if (e.key === 'Escape') close(); }
        function onBackdrop(e) { if (e.target === modal) close(); }
        function onCancel() { close(); }
        function onPrev() {
            if (!survey) return;
            try { survey.prevPage(); } catch (e) {}
            syncNav();
        }
        function pageHasErrors() {
            try {
                if (survey && survey.currentPage && typeof survey.currentPage.hasErrors === 'function') {
                    return !!survey.currentPage.hasErrors(true);
                }
            } catch (e) {}
            return false;
        }
        function onNext() {
            if (!survey) return;
            if (pageHasErrors()) { setStatus('Controlla i campi evidenziati.'); return; }
            setStatus('');
            try { survey.nextPage(); } catch (e) {}
            syncNav();
        }

        function toIsoFromLocal(dtLocal) {
            var s = String(dtLocal || '').trim();
            if (!s) return null;
            var d = new Date(s);
            if (isNaN(d.getTime())) return null;
            return d.toISOString();
        }

        function onSubmit() {
            if (!survey) { setStatus('UI non pronta.'); return; }
            if (!survey.isLastPage) { onNext(); return; }
            try {
                var ok = survey.validate ? survey.validate() : true;
                if (!ok) { setStatus('Controlla i campi evidenziati.'); return; }
            } catch (eV) {}
            setStatus('Creazione scheda…');
            var data = survey.data || {};
            var title = String(data.title || '').trim();
            if (!title || title.length < 3) { setStatus('Titolo obbligatorio.'); return; }
            var payload = {
                title: title,
                buyer_name: String(data.buyer_name || '').trim() || null,
                cpv: String(data.cpv || '').trim() || null,
                category: String(data.category || '').trim() || null,
                procedure_type: String(data.procedure_type || '').trim() || null,
                award_criteria: String(data.award_criteria || '').trim() || null,
                amount_estimated: (function () {
                    var raw = String(data.amount_estimated || '').trim();
                    if (!raw) return null;
                    var n = Number(raw);
                    return isNaN(n) ? null : n;
                })(),
                currency: (String(data.currency || 'EUR') || 'EUR').slice(0, 3).toUpperCase(),
                deadline_date: toIsoFromLocal(String(data.deadline_local || '').trim()),
                external_url: String(data.external_url || '').trim() || null,
                description: String(data.description || '').trim() || null
            };
            apiJson('/kanban/manual-procedures', { method: 'POST', body: payload })
                .then(function () {
                    setStatus('');
                    close();
                    return refresh();
                })
                .catch(function (err) {
                    setStatus((err && err.message) ? err.message : 'Errore creazione');
                });
        }

        function cleanup() {
            document.removeEventListener('keydown', onKey);
            modal.removeEventListener('click', onBackdrop);
            if (survey) {
                try { survey.onCurrentPageChanged.remove(syncNav); } catch (e) {}
            }
            if (btnPrev) btnPrev.removeEventListener('click', onPrev);
            if (btnNext) btnNext.removeEventListener('click', onNext);
            if (btnCancel) btnCancel.removeEventListener('click', onCancel);
            if (btnSubmit) btnSubmit.removeEventListener('click', onSubmit);
        }

        document.addEventListener('keydown', onKey);
        modal.addEventListener('click', onBackdrop);
        if (survey) {
            try { survey.onCurrentPageChanged.add(syncNav); } catch (e) {}
        }
        if (btnPrev) btnPrev.addEventListener('click', onPrev);
        if (btnNext) btnNext.addEventListener('click', onNext);
        if (btnCancel) btnCancel.addEventListener('click', onCancel);
        if (btnSubmit) btnSubmit.addEventListener('click', onSubmit);
    }

    function openConfirmModal(opts) {
        return window.VistaGareUi.confirm(opts || {});
    }

    function ensureDocboxModal() {
        var existing = document.getElementById('vg-kanban-docbox');
        if (existing) return existing;
        var wrap = document.createElement('div');
        wrap.id = 'vg-kanban-docbox';
        wrap.className = 'vg-kanban-modal';
        wrap.setAttribute('hidden', 'hidden');
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel vg-kanban-docbox__panel" role="document">' +
            '  <div class="vg-kanban-docbox__header">' +
            '    <h2 class="vg-kanban-docbox__title" data-title>Documento</h2>' +
            '    <button type="button" class="vg-kanban-docbox__close" data-close aria-label="Chiudi">Chiudi</button>' +
            '  </div>' +
            '  <div class="vg-kanban-docbox__body" data-body></div>' +
            '</div>';
        (document.body || document.documentElement).appendChild(wrap);
        return wrap;
    }

    function pdfJsViewerUrl(fileUrl) {
        // PDF.js viewer vendorizzato nel tema (no CDN).
        // Ghost serve i file tema sotto /assets/...
        var viewer = '/assets/pdf-viewer/web/viewer.html';
        return viewer + '?file=' + encodeURIComponent(String(fileUrl || ''));
    }

    function resolveKanbanApiUrl(url) {
        var href = String(url || '');
        if (href && href.indexOf('/kanban/') === 0) {
            var baseStr = apiBase();
            return baseStr + href;
        }
        return href;
    }

    function downloadKanbanBundleZip(itemId, opts) {
        opts = opts || {};
        var id = parseInt(itemId, 10) || 0;
        if (!id) return Promise.reject(new Error('itemId mancante'));
        var url = resolveKanbanApiUrl('/kanban/items/' + encodeURIComponent(id) + '/downloads-bundle.zip');
        var btn = opts.buttonEl || null;
        if (btn) btn.disabled = true;
        return fetch(url, { credentials: 'include' }).then(function (r) {
            if (!r.ok) {
                return r.json().catch(function () { return {}; }).then(function (j) {
                    var msg = (j && j.detail) ? String(j.detail) : ('HTTP ' + r.status);
                    throw new Error(msg);
                });
            }
            return r.blob();
        }).then(function (blob) {
            var name = 'gara-' + id + '-documenti.zip';
            var objUrl = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = objUrl;
            a.download = name;
            a.rel = 'noopener';
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                try { URL.revokeObjectURL(objUrl); } catch (eRu) {}
                try { a.remove(); } catch (eRm) {}
            }, 4000);
        }).finally(function () {
            if (btn) btn.disabled = false;
        });
    }

    function isHiddenKanbanDownloadFile(f) {
        if (!f) return true;
        if (f.is_compile_working_copy || f.is_compile_template) return true;
        if (String(f.origin || '').toLowerCase() === 'compile_template') return true;
        return false;
    }

    function normalizeKanbanFilename(fn) {
        var s = String(fn || '').trim();
        return s.replace(/\s*\(\d+\/\d+\)\s*(?=\.[^.]+$|$)/, '');
    }

    function dedupeKanbanDownloadFiles(files) {
        var best = {};
        var order = [];
        for (var i = 0; i < (files || []).length; i++) {
            var f = files[i];
            if (!f) continue;
            var key = normalizeKanbanFilename(f.filename).toLowerCase();
            if (!key) {
                key = 'id:' + String(f.file_id || f.upload_id || i);
            } else {
                key = 'fn:' + key;
            }
            if (!best[key]) {
                best[key] = f;
                order.push(key);
                continue;
            }
            var a = best[key];
            var b = f;
            var ia = parseInt(a.doc_importance, 10) || 0;
            var ib = parseInt(b.doc_importance, 10) || 0;
            var pick = b;
            if (ia > ib) pick = a;
            else if (ia === ib) {
                var pa = String(a.doc_provenance || 'originale').toLowerCase();
                var pb = String(b.doc_provenance || 'originale').toLowerCase();
                if (pa === 'originale' && pb !== 'originale') pick = a;
                else if (pb === 'originale' && pa !== 'originale') pick = b;
                else if (a.pipeline_parent_file_id && !b.pipeline_parent_file_id) pick = b;
                else if (b.pipeline_parent_file_id && !a.pipeline_parent_file_id) pick = a;
                else {
                    var ca = parseInt(a.campi_da_compilare, 10) || 0;
                    var cb = parseInt(b.campi_da_compilare, 10) || 0;
                    pick = cb >= ca ? b : a;
                }
            }
            best[key] = pick;
        }
        var out = [];
        for (var j = 0; j < order.length; j++) out.push(best[order[j]]);
        return out;
    }

    function filterKanbanDownloadFiles(files) {
        var visible = [];
        for (var i = 0; i < (files || []).length; i++) {
            var f = files[i];
            if (!f || isHiddenKanbanDownloadFile(f)) continue;
            if (f.stored_relpath) visible.push(f);
        }
        return dedupeKanbanDownloadFiles(visible);
    }

    function compareFilesByFilename(a, b) {
        var an = String(a && a.filename || '').toLowerCase();
        var bn = String(b && b.filename || '').toLowerCase();
        return an < bn ? -1 : an > bn ? 1 : 0;
    }

    function countFocusDownloadableFiles(files) {
        return filterKanbanDownloadFiles(files).length;
    }

    function renderPreviewLoading(bodyEl, label) {
        if (!bodyEl) return;
        bodyEl.innerHTML =
            '<div class="vg-kanban-compila__preview-loading" role="status" aria-live="polite">' +
            '<span class="vg-kanban-compila__spinner" aria-hidden="true"></span>' +
            '<span>' + escapeHtml(label || 'Caricamento anteprima…') + '</span></div>';
    }

    function clearCompilePreviewHighlights(previewEl) {
        if (!previewEl) return;
        var marks = previewEl.querySelectorAll('.vg-kanban-compila__highlight');
        for (var i = 0; i < marks.length; i++) {
            var m = marks[i];
            if (!m || !m.parentNode) continue;
            try {
                var txt = document.createTextNode(m.textContent || '');
                m.parentNode.replaceChild(txt, m);
            } catch (eH) {}
        }
        var slots = previewEl.querySelectorAll('.vg-kanban-compila__slot--focus');
        for (var s = 0; s < slots.length; s++) {
            slots[s].classList.remove('vg-kanban-compila__slot--focus');
        }
    }

    function highlightTextInPreview(root, needle) {
        if (!root || !needle) return false;
        var q = String(needle).trim();
        if (!q) return false;
        var ql = q.toLowerCase();
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
            var txt = node.textContent || '';
            var idx = txt.toLowerCase().indexOf(ql);
            if (idx < 0) continue;
            try {
                var range = document.createRange();
                range.setStart(node, idx);
                range.setEnd(node, Math.min(idx + q.length, txt.length));
                var mark = document.createElement('mark');
                mark.className = 'vg-kanban-compila__highlight';
                range.surroundContents(mark);
                mark.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return true;
            } catch (eR) {
                continue;
            }
        }
        return false;
    }

    function disposeCompileSurvey(modal) {
        if (!modal) return;
        try {
            var s = modal._vgSurvey;
            if (s) {
                if (typeof s.dispose === 'function') s.dispose();
                else if (typeof s.clear === 'function') s.clear(false);
            }
        } catch (eDs) {}
        modal._vgSurvey = null;
    }

    function escapeRegExp(s) {
        return String(s || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    var _DOCX_PLACEHOLDER_RE = /_{2,}|\.{3,}|\.(?:\s*\.){2,}|\u2026{2,}|[\u2026\u2025\u22ef\u00b7]{3,}|[\s\u00a0\u2007\u202f]{8,}|[-–—]{3,}/g;
    var _MIN_DOCX_PH_LEN = 6;
    var _MIN_DOCX_DOT_PH_LEN = 3;

    function isDotPlaceholderChunk(chunk) {
        return /^\.(?:\s*\.){2,}|\.{3,}$/.test(String(chunk || ''));
    }

    function isEllipsisPlaceholderChunk(chunk) {
        var s = String(chunk || '');
        if (s.length < 3) return false;
        var n = (s.match(/[\u2026\u2025\u22ef\u00b7]/g) || []).length;
        return n >= 3;
    }

    function placeholderInParentheses(text, start, end) {
        var before = String(text || '').slice(0, start);
        if (!/\(\s*$/.test(before)) return false;
        var after = String(text || '').slice(end).replace(/^\s+/, '');
        return after.charAt(0) === ')';
    }

    function placeholderSpanUsable(text, start, end) {
        var chunk = String(text || '').slice(start, end);
        var spanLen = end - start;
        if (isDotPlaceholderChunk(chunk) && spanLen >= _MIN_DOCX_DOT_PH_LEN) return true;
        if (isEllipsisPlaceholderChunk(chunk)) return true;
        if (spanLen >= _MIN_DOCX_PH_LEN) return true;
        if (spanLen < 2) return false;
        return placeholderInParentheses(text, start, end);
    }

    function cleanHintAnchor(s) {
        var t = String(s || '').replace(/\[\d+\]/g, '');
        t = t.replace(/_{2,}|\.{3,}|[\s_\u00a0]{6,}/g, ' ');
        return t.replace(/\s+/g, ' ').trim();
    }

    function findAllPlaceholderSpans(html) {
        var spans = [];
        var re = new RegExp(_DOCX_PLACEHOLDER_RE.source, 'g');
        var m;
        while ((m = re.exec(String(html || '')))) {
            if (placeholderSpanUsable(html, m.index, m.index + m[0].length)) {
                spans.push({ start: m.index, end: m.index + m[0].length, text: m[0] });
            }
        }
        return spans;
    }

    function cssEscapeIdent(s) {
        if (typeof window !== 'undefined' && window.CSS && typeof window.CSS.escape === 'function') {
            return window.CSS.escape(String(s));
        }
        return String(s).replace(/["\\]/g, '\\$&');
    }

    function getCompileFieldOrder(modal) {
        var survey = modal && modal._vgSurvey;
        if (survey && typeof survey.getAllQuestions === 'function') {
            var qs = survey.getAllQuestions(false);
            var out = [];
            for (var i = 0; i < qs.length; i++) {
                if (qs[i] && qs[i].name) out.push(String(qs[i].name));
            }
            if (out.length) return out;
        }
        var hints = (modal && modal._vgFieldHints) ? modal._vgFieldHints : {};
        var names = Object.keys(hints);
        names.sort(function (a, b) {
            var ia = hints[a] && hints[a].field_index != null ? parseInt(hints[a].field_index, 10) : 9999;
            var ib = hints[b] && hints[b].field_index != null ? parseInt(hints[b].field_index, 10) : 9999;
            if (isNaN(ia)) ia = 9999;
            if (isNaN(ib)) ib = 9999;
            return ia - ib;
        });
        return names;
    }

    function sortFieldNamesByIndex(fieldNames, hints) {
        var names = (fieldNames || []).slice();
        names.sort(function (a, b) {
            var ha = hints[a] || {};
            var hb = hints[b] || {};
            var ia = ha.field_index != null ? parseInt(ha.field_index, 10) : 9999;
            var ib = hb.field_index != null ? parseInt(hb.field_index, 10) : 9999;
            if (isNaN(ia)) ia = 9999;
            if (isNaN(ib)) ib = 9999;
            return ia - ib;
        });
        return names;
    }

    function splitDocxHtmlParagraphs(html) {
        var text = String(html || '');
        var parts = [];
        var re = /<p\b[^>]*>[\s\S]*?<\/p>/gi;
        var m;
        while ((m = re.exec(text))) {
            parts.push({ html: m[0], start: m.index, end: m.index + m[0].length });
        }
        if (!parts.length) {
            parts.push({ html: text, start: 0, end: text.length });
        }
        return parts;
    }

    function spanOverlaps(a, b) {
        return a.start < b.end && b.start < a.end;
    }

    function findPlaceholderForHint(html, anchor, phIndex, usedSpans) {
        var text = String(html || '');
        var anc = String(anchor || '').trim();
        var idx = phIndex != null && !isNaN(phIndex) ? parseInt(phIndex, 10) : 0;
        if (isNaN(idx)) idx = 0;
        var anchorSearch = 0;

        while (true) {
            var ap = anc ? text.toLowerCase().indexOf(anc.toLowerCase(), anchorSearch) : 0;
            if (anc && ap < 0) return null;
            var subStart = anc ? ap + anc.length : 0;
            var re = new RegExp(_DOCX_PLACEHOLDER_RE.source, 'g');
            var count = 0;
            var m;
            while ((m = re.exec(text))) {
                if (m.index < subStart) continue;
                var cand = { start: m.index, end: m.index + m[0].length, text: m[0] };
                var used = false;
                for (var u = 0; u < usedSpans.length; u++) {
                    if (spanOverlaps(cand, usedSpans[u])) { used = true; break; }
                }
                if (used) continue;
                if (count === idx) return cand;
                count += 1;
            }
            if (!anc) return null;
            anchorSearch = ap + 1;
        }
    }

    function docxTemplateHasSlots(html) {
        var h = String(html || '');
        return h.indexOf('data-vg-field') >= 0 || h.indexOf('vg-kanban-compila__slot') >= 0;
    }

    function docxTemplateIsFaithfulPreview(html) {
        var h = String(html || '');
        return h.indexOf('vg-docx-preview-root') >= 0 || h.indexOf('vg-docx-preview-table') >= 0;
    }

    function docxPreviewHtmlHasMarkers(html) {
        return String(html || '').indexOf('{field-') >= 0;
    }

    function docxTemplateUseServer(html) {
        var h = String(html || '');
        if (docxPreviewHtmlHasMarkers(h)) return false;
        return docxTemplateHasSlots(h) || docxTemplateIsFaithfulPreview(h);
    }

    function docxTemplateMarkerHtml(html) {
        var h = String(html || '');
        return h.indexOf('{field-') >= 0 || docxTemplateHasSlots(h);
    }

    function wrapDocxMarkerSlot(fieldName, hint, markerText) {
        var title = hint && hint.title ? String(hint.title) : fieldName;
        var wrapBr = hint && hint.wrap_value_in_brackets ? ' data-vg-wrap-brackets="1"' : '';
        var fw = hint && hint.marker_len != null ? parseInt(hint.marker_len, 10) : NaN;
        if (isNaN(fw) || fw < 1) {
            var m = String(markerText || '').match(/^\{field-\d+:(\d+)\}$/);
            fw = m ? parseInt(m[1], 10) : 8;
        }
        fw = Math.max(1, Math.min(fw, 120));
        return (
            '<span class="vg-kanban-compila__slot vg-kanban-compila__slot--sized vg-kanban-compila__slot--marker" data-vg-field="' + escapeHtml(fieldName) +
            '" title="' + escapeHtml(title) + '" data-vg-fill-width="' + String(fw) + '" style="--vg-fill-ch:' + String(fw) + '"' + wrapBr + '>' +
            '<span class="vg-kanban-compila__ph">' + escapeHtml(markerText) + '</span>' +
            '<span class="vg-kanban-compila__filled-value" aria-hidden="true"></span></span>'
        );
    }

    function annotateDocxMarkerTemplate(templateHtml, fieldNames, hints) {
        var html = String(templateHtml || '');
        if (!html || !fieldNames || !fieldNames.length) return html;
        hints = hints || {};
        var names = sortFieldNamesByIndex(fieldNames, hints);
        for (var i = 0; i < names.length; i++) {
            var name = names[i];
            var hint = hints[name] || {};
            var marker = String(hint.marker || '').trim();
            if (!marker) {
                var mn = hint.marker_num != null ? parseInt(hint.marker_num, 10) : (i + 1);
                var ml = hint.marker_len != null ? parseInt(hint.marker_len, 10) : 8;
                if (!isNaN(mn)) marker = '{field-' + mn + ':' + (isNaN(ml) ? 8 : ml) + '}';
            }
            if (!marker) continue;
            var esc = marker.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            var re = new RegExp(esc, 'g');
            html = html.replace(re, function () {
                return wrapDocxMarkerSlot(name, hint, marker);
            });
        }
        return html;
    }

    function wrapDocxPlaceholderSlot(html, span, fieldName, hint, fieldNum) {
        var orig = html.slice(span.start, span.end);
        var title = hint && hint.title ? String(hint.title) : fieldName;
        var wrapBr = hint && hint.wrap_value_in_brackets ? ' data-vg-wrap-brackets="1"' : '';
        var wrap =
            '<span class="vg-kanban-compila__slot" data-vg-field="' + escapeHtml(fieldName) +
            '" data-vg-idx="' + String(fieldNum) + '" title="' + escapeHtml(title) + '"' + wrapBr + '>' +
            '<span class="vg-kanban-compila__ph">' + orig + '</span>' +
            '<span class="vg-kanban-compila__filled-value" aria-hidden="true"></span></span>';
        return html.slice(0, span.start) + wrap + html.slice(span.end);
    }

    function hintSearchAnchor(hint) {
        if (!hint) return '';
        var ma = String(hint.match_anchor || '').trim();
        if (ma) return ma;
        return String(hint.anchor || hint.title || '').trim();
    }

    function annotateDocxPreviewTemplate(templateHtml, fieldNames, hints) {
        var html = String(templateHtml || '');
        if (!html || !fieldNames || !fieldNames.length) return html;
        if (html.indexOf('{field-') >= 0) {
            return annotateDocxMarkerTemplate(html, fieldNames, hints);
        }
        hints = hints || {};
        var names = sortFieldNamesByIndex(fieldNames, hints);
        var allPh = findAllPlaceholderSpans(html);
        var usedSpans = [];
        var assignments = [];

        for (var i = 0; i < names.length; i++) {
            var name = names[i];
            var hint = hints[name] || {};
            var phIdx = hint.placeholder_index != null ? parseInt(hint.placeholder_index, 10) : 0;
            if (isNaN(phIdx)) phIdx = 0;
            var fi = hint.field_index != null ? parseInt(hint.field_index, 10) : i;
            if (isNaN(fi)) fi = i;
            var local = null;

            var searchAnchor = cleanHintAnchor(hintSearchAnchor(hint));
            if (searchAnchor) {
                local = findPlaceholderForHint(html, searchAnchor, phIdx, usedSpans);
            }
            if (!local && hint.anchor) {
                local = findPlaceholderForHint(html, cleanHintAnchor(hint.anchor), phIdx, usedSpans);
            }
            if (!local && fi >= 0 && fi < allPh.length) {
                var candOrd = allPh[fi];
                var clashOrd = false;
                for (var co = 0; co < usedSpans.length; co++) {
                    if (spanOverlaps(candOrd, usedSpans[co])) { clashOrd = true; break; }
                }
                if (!clashOrd) local = candOrd;
            }
            if (!local) continue;

            usedSpans.push({ start: local.start, end: local.end });
            var num = fi + 1;
            assignments.push({ span: local, name: name, hint: hint, num: num });
        }

        assignments.sort(function (a, b) { return b.span.start - a.span.start; });
        for (var j = 0; j < assignments.length; j++) {
            var a = assignments[j];
            html = wrapDocxPlaceholderSlot(html, a.span, a.name, a.hint, a.num);
        }
        return html;
    }

    function compilePreviewSlotShouldWrapInBrackets(slot, phEl) {
        if (!slot) return false;
        var a = String(slot.getAttribute('data-vg-wrap-brackets') || '').trim().toLowerCase();
        if (a === '1' || a === 'true' || a === 'yes') return true;
        if (!phEl) return false;
        var raw = String(phEl.textContent || '').replace(/\ufeff/g, '');
        var t = raw.replace(/\uff3b/g, '[').replace(/\uff3d/g, ']').trim();
        // Tight "[]" only (not "[ ]" used by SI/NO rows) — legacy HTML without data-vg-wrap-brackets.
        if (t === '[]') return true;
        if (raw.replace(/\ufeff/g, '').trim() === '\uff3b\uff3d') return true;
        return false;
    }

    function formatCompileOutputDate(rawVal, hint) {
        var s = String(rawVal == null ? '' : rawVal).trim();
        if (!s) return '';
        var t = hint && hint.title ? String(hint.title).toLowerCase() : '';
        var anchor = hint && hint.anchor ? String(hint.anchor).toLowerCase() : '';
        var isDateField = /\bdata\b|nato\s+il|nascita|pubblicazione|scadenza|decorrenza|luogo\s+e\s+data/i.test(t + ' ' + anchor);
        if (isDateField || /^\d{4}-\d{2}-\d{2}/.test(s)) {
            try {
                var dt = new Date(s.indexOf('T') > 0 ? s : (s + 'T12:00:00'));
                if (!isNaN(dt.getTime())) {
                    var dd = String(dt.getDate()).padStart(2, '0');
                    var mm = String(dt.getMonth() + 1).padStart(2, '0');
                    var yy = String(dt.getFullYear());
                    return dd + '/' + mm + '/' + yy;
                }
            } catch (eDt) {}
        }
        return s;
    }

    function compilePreviewDisplayValue(slot, phEl, rawVal, hint) {
        var s = formatCompileOutputDate(rawVal, hint);
        if (!s) return '';
        if (compilePreviewSlotShouldWrapInBrackets(slot, phEl)) {
            if (s.charAt(0) === '[' && s.charAt(s.length - 1) === ']') return s;
            return '[' + s + ']';
        }
        return s;
    }

    function applyDocxPreviewValues(docxEl, data, modal) {
        if (!docxEl) return;
        var hints = (modal && modal._vgFieldHints) ? modal._vgFieldHints : {};
        var slots = docxEl.querySelectorAll('.vg-kanban-compila__slot[data-vg-field]');
        for (var i = 0; i < slots.length; i++) {
            var slot = slots[i];
            var name = slot.getAttribute('data-vg-field');
            if (!name) continue;
            var ph = slot.querySelector('.vg-kanban-compila__ph');
            var valEl = slot.querySelector('.vg-kanban-compila__filled-value');
            if (!valEl) continue;
            var val = data && data[name];
            var hint = hints[name] || null;
            var filled = !(val === undefined || val === null || String(val).trim() === '');
            if (filled) {
                valEl.textContent = compilePreviewDisplayValue(slot, ph, val, hint);
                valEl.removeAttribute('aria-hidden');
                if (ph) ph.style.display = 'none';
                slot.classList.add('vg-kanban-compila__slot--filled');
            } else {
                valEl.textContent = '';
                valEl.setAttribute('aria-hidden', 'true');
                if (ph) ph.style.display = '';
                slot.classList.remove('vg-kanban-compila__slot--filled');
            }
        }
        var altChoices = docxEl.querySelectorAll('.vg-kanban-compila__alt-choice[data-vg-alt-field]');
        for (var a = 0; a < altChoices.length; a++) {
            var ch = altChoices[a];
            var fname = ch.getAttribute('data-vg-alt-field');
            var label = ch.getAttribute('data-vg-alt-label') || '';
            var selected = fname && data ? data[fname] : null;
            var on = !!(selected && String(selected).trim() === String(label).trim());
            if (on) ch.classList.add('vg-kanban-compila__alt-choice--selected');
            else ch.classList.remove('vg-kanban-compila__alt-choice--selected');
        }
    }

    function refreshCompilePreviewFromForm(previewEl, modal, focusName) {
        if (!previewEl || !modal) return;
        var survey = modal._vgSurvey;
        var docx = previewEl.querySelector('.vg-kanban-compila__docx');
        var templateView = modal._vgPreviewView === 'template';
        if (docx && modal._vgDocxTemplate) {
            if (!modal._vgDocxAnnotated) {
                if (docx.querySelector('.vg-kanban-compila__slot[data-vg-field]')) {
                    modal._vgDocxAnnotated = true;
                } else {
                    docx.innerHTML = annotateDocxPreviewTemplate(
                        modal._vgDocxTemplate,
                        getCompileFieldOrder(modal),
                        modal._vgFieldHints || {}
                    );
                    modal._vgDocxAnnotated = true;
                }
            }
            if (!templateView && docx.querySelector('.vg-kanban-compila__slot[data-vg-field]')) {
                applyDocxPreviewValues(docx, survey ? (survey.data || {}) : {}, modal);
            }
        }
        var focus = focusName || modal._vgPendingFocus;
        if (focus) focusCompilePreview(previewEl, modal, focus);
    }

    function scheduleRefreshCompilePreview(previewEl, modal, focusName) {
        if (!modal) return;
        if (modal._vgPreviewView === 'template') return;
        if (modal._vgPreviewRefreshTimer) {
            clearTimeout(modal._vgPreviewRefreshTimer);
        }
        modal._vgPreviewRefreshTimer = setTimeout(function () {
            modal._vgPreviewRefreshTimer = null;
            refreshCompilePreviewFromForm(previewEl, modal, focusName);
        }, 50);
    }

    function focusCompilePreview(previewEl, modal, questionName) {
        if (!previewEl || !modal || !questionName) return;
        var hints = modal._vgFieldHints || {};
        var hint = hints[String(questionName)] || null;
        if (!hint) return;
        clearCompilePreviewHighlights(previewEl);
        var iframe = previewEl.querySelector('iframe.vg-kanban-compila__iframe, iframe.vg-kanban-docbox__iframe');
        if (iframe) {
            var attempts = 0;
            var tryPdf = function () {
                attempts += 1;
                try {
                    var win = iframe.contentWindow;
                    var app = win && win.PDFViewerApplication;
                    if (!app || !app.pdfViewer || !app.pdfDocument) {
                        if (attempts < 40) setTimeout(tryPdf, 250);
                        return;
                    }
                    var pageNum = hint.page ? (parseInt(hint.page, 10) || 1) : 1;
                    var rect = hint.rect;
                    if (rect && rect.length === 4 && app.pdfDocument && app.pdfViewer && app.pdfViewer.scrollPageIntoView) {
                        app.pdfDocument.getPage(pageNum).then(function (pdfPage) {
                            try {
                                var vp = pdfPage.getViewport({ scale: 1 });
                                var ph = vp.height;
                                var yBot = ph - parseFloat(rect[3]);
                                var yTop = ph - parseFloat(rect[1]);
                                app.pdfViewer.scrollPageIntoView({
                                    pageNumber: pageNum,
                                    destArray: [null, { name: 'FitR' }, parseFloat(rect[0]), yBot, parseFloat(rect[2]), yTop]
                                });
                            } catch (eRect) {}
                        }).catch(function () {
                            if (attempts < 40) setTimeout(tryPdf, 250);
                        });
                        return;
                    }
                    if (hint.page && app.page !== pageNum) {
                        app.page = pageNum;
                    }
                    var q = String(hint.anchor || hint.title || '').trim();
                    if (q && app.eventBus && typeof app.eventBus.dispatch === 'function') {
                        app.eventBus.dispatch('find', {
                            source: window,
                            type: '',
                            query: q,
                            phraseSearch: true,
                            caseSensitive: false,
                            entireWord: false,
                            highlightAll: true,
                            findPrevious: false
                        });
                    }
                } catch (ePdf) {
                    if (attempts < 40) setTimeout(tryPdf, 250);
                }
            };
            tryPdf();
            return;
        }
        var docx = previewEl.querySelector('.vg-kanban-compila__docx');
        if (docx) {
            var slot = docx.querySelector('.vg-kanban-compila__slot[data-vg-field="' + cssEscapeIdent(questionName) + '"]');
            if (slot) {
                slot.classList.add('vg-kanban-compila__slot--focus');
                try { slot.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (eSv) {}
                return;
            }
            if (docx.querySelector('.vg-kanban-compila__slot[data-vg-field]')) return;
            var needle = String(hint.anchor || hint.title || '').trim();
            if (!highlightTextInPreview(docx, needle) && hint.title && hint.title !== needle) {
                highlightTextInPreview(docx, hint.title);
            }
        }
    }

    function enablePdfFreeEditor(previewEl) {
        if (!previewEl) return;
        var iframe = previewEl.querySelector('iframe.vg-kanban-compila__iframe, iframe.vg-kanban-docbox__iframe');
        if (!iframe) return;
        var attempts = 0;
        var tryOn = function () {
            attempts += 1;
            try {
                var win = iframe.contentWindow;
                var app = win && win.PDFViewerApplication;
                if (!app || !app.pdfDocument || !app.eventBus) {
                    if (attempts < 40) setTimeout(tryOn, 250);
                    return;
                }
                try {
                    app.eventBus.dispatch('switchannotationeditormode', { source: window, mode: 3 });
                } catch (eM1) {}
            } catch (ePdf) {
                if (attempts < 40) setTimeout(tryOn, 250);
            }
        };
        tryOn();
    }

    function bytesToBase64(bytes) {
        var arr = bytes;
        if (arr instanceof ArrayBuffer) arr = new Uint8Array(arr);
        var bin = '';
        var step = 0x8000;
        for (var i = 0; i < arr.length; i += step) {
            bin += String.fromCharCode.apply(null, arr.subarray(i, i + step));
        }
        return btoa(bin);
    }

    function savePdfFreeCompile(previewEl, putPath, statusEl, modal, itemId, refreshPreview) {
        var iframe = previewEl && previewEl.querySelector('iframe');
        if (!iframe || !iframe.contentWindow) {
            if (statusEl) statusEl.textContent = 'Anteprima PDF non pronta';
            return;
        }
        var app = iframe.contentWindow.PDFViewerApplication;
        if (!app || !app.pdfDocument || typeof app.pdfDocument.saveDocument !== 'function') {
            if (statusEl) statusEl.textContent = 'Salvataggio annotazioni non disponibile';
            return;
        }
        if (statusEl) statusEl.textContent = 'Salvataggio…';
        app.pdfDocument.saveDocument().then(function (data) {
            var b64 = bytesToBase64(data);
            return apiJson(putPath, { method: 'POST', body: { pdf_base64: b64 } });
        }).then(function (res) {
            if (statusEl) statusEl.textContent = 'Salvato';
            if (res && res.preview_url) modal._vgCompilePreview.url = resolveKanbanApiUrl(res.preview_url);
            refreshPreview(true);
            try { document.dispatchEvent(new CustomEvent('vg-kanban-compile-saved', { detail: { itemId: itemId } })); } catch (eEv) {}
        }).catch(function (err) {
            if (statusEl) statusEl.textContent = (err && err.message) ? err.message : 'Errore salvataggio';
            showCompileError(previewEl, err, { action: 'pdf-free-save', path: putPath });
        });
    }

    function countSurveyElements(surveyJson) {
        var n = 0;
        function walk(els) {
            if (!Array.isArray(els)) return;
            for (var i = 0; i < els.length; i++) {
                var el = els[i];
                if (!el || !el.type) continue;
                if (el.type === 'panel' || el.type === 'paneldynamic') {
                    walk(el.elements || el.templateElements);
                } else {
                    n += 1;
                }
            }
        }
        var pages = (surveyJson && surveyJson.pages) ? surveyJson.pages : [];
        for (var p = 0; p < pages.length; p++) {
            walk(pages[p] && pages[p].elements ? pages[p].elements : []);
        }
        return n;
    }

    function sanitizeCompileSurveyJson(surveyJson) {
        surveyJson = surveyJson && typeof surveyJson === 'object' ? surveyJson : { pages: [{ elements: [] }] };
        var pages = Array.isArray(surveyJson.pages) ? surveyJson.pages : [];
        var outPages = [];
        for (var pi = 0; pi < pages.length; pi++) {
            var page = pages[pi];
            if (!page || !Array.isArray(page.elements)) continue;
            var els = [];
            for (var ei = 0; ei < page.elements.length; ei++) {
                var el = page.elements[ei];
                if (!el || !el.name) continue;
                el = Object.assign({}, el);
                var choices = Array.isArray(el.choices) ? el.choices : null;
                var typ = String(el.type || 'text').toLowerCase();
                if (choices && choices.length && (typ === 'text' || typ === 'comment')) {
                    el.type = 'radiogroup';
                    typ = 'radiogroup';
                }
                if (typ === 'radiogroup' && choices && choices.length) {
                    el.colCount = el.colCount || 1;
                } else if (typ !== 'radiogroup' && typ !== 'dropdown' && typ !== 'checkbox') {
                    delete el.choices;
                    delete el.colCount;
                }
                els.push(el);
            }
            if (els.length) outPages.push(Object.assign({}, page, { elements: els }));
        }
        if (!outPages.length) return { pages: [{ elements: [] }] };
        return Object.assign({}, surveyJson, { pages: outPages });
    }

    function isPlausibleCompileValue(val) {
        if (val === undefined || val === null) return false;
        if (typeof val === 'boolean') return true;
        var s = String(val).trim();
        if (s.length < 2) return false;
        if (/^\[.+\]$/.test(s)) return false;
        if (/_{4,}|\.{3,}/.test(s)) return false;
        return true;
    }

    function stripCompileProgressSuffix(filename) {
        return String(filename || 'documento').replace(/\s*\(\d+\/\d+\)\s*(?=\.[^.]+$|$)/, '');
    }

    function countCompileProgressFromSurvey(survey) {
        if (!survey || typeof survey.getAllQuestions !== 'function') {
            return { filled: 0, total: 0 };
        }
        var qs = survey.getAllQuestions(false) || [];
        var total = qs.length;
        var filled = 0;
        for (var i = 0; i < qs.length; i++) {
            var nm = qs[i].name;
            if (!nm) continue;
            var val = survey.getValue(nm);
            if (val === true) filled += 1;
            else if (val !== undefined && val !== null && String(val).trim() !== '') filled += 1;
        }
        return { filled: filled, total: total };
    }

    function updateCompileProgressChrome(modal, survey, titleEl, statusEl, opts) {
        opts = opts || {};
        if (!survey) return;
        var c = countCompileProgressFromSurvey(survey);
        modal._vgCompileProgress = c;
        var base = stripCompileProgressSuffix(
            (modal._vgCompilePreview && modal._vgCompilePreview.filename) ? modal._vgCompilePreview.filename : 'documento'
        );
        var suffix = (c.total > 0) ? (' (' + c.filled + '/' + c.total + ')') : '';
        if (titleEl && opts.updateTitle !== false) {
            titleEl.textContent = 'Compila: ' + base + suffix;
        }
        if (statusEl && opts.statusText) {
            statusEl.textContent = opts.statusText;
        }
    }

    function compileQuestionHasUserValue(survey, q) {
        if (!survey || !q || !q.name) return false;
        var val = survey.getValue(q.name);
        if (val === true) return true;
        if (Array.isArray(val)) return val.length > 0;
        if (val === undefined || val === null) return false;
        return String(val).trim() !== '';
    }

    function compileFieldAssistApiPath(modal, fieldName) {
        var itemId = parseInt(modal._vgCompileItemId, 10) || 0;
        var nm = encodeURIComponent(String(fieldName || ''));
        if (modal._vgCompileOrigin === 'manual') {
            return '/kanban/items/' + itemId + '/uploads/' +
                encodeURIComponent(String(modal._vgCompileUploadId || '')) +
                '/compile-field-assist/' + nm;
        }
        return '/kanban/items/' + itemId + '/downloads/' +
            encodeURIComponent(String(modal._vgCompileFileId || '')) +
            '/compile-field-assist/' + nm;
    }

    function compileFieldAssistBatchApiPath(modal) {
        var itemId = parseInt(modal._vgCompileItemId, 10) || 0;
        if (modal._vgCompileOrigin === 'manual') {
            return '/kanban/items/' + itemId + '/uploads/' +
                encodeURIComponent(String(modal._vgCompileUploadId || '')) +
                '/compile-field-assist/batch';
        }
        return '/kanban/items/' + itemId + '/downloads/' +
            encodeURIComponent(String(modal._vgCompileFileId || '')) +
            '/compile-field-assist/batch';
    }

    function mergeAssistCache(modal, fieldsMap) {
        if (!modal || !fieldsMap || typeof fieldsMap !== 'object') return;
        if (!modal._vgFieldAssistCache) modal._vgFieldAssistCache = {};
        Object.keys(fieldsMap).forEach(function (k) {
            var row = fieldsMap[k];
            if (row && typeof row === 'object') {
                modal._vgFieldAssistCache[k] = row;
            }
        });
    }

    function listEmptyCompileFieldNames(survey, modal) {
        var out = [];
        if (!survey) return out;
        var qs = survey.getAllQuestions(false) || [];
        for (var i = 0; i < qs.length; i++) {
            var q = qs[i];
            if (!q || !q.name) continue;
            if (!compileQuestionHasUserValue(survey, q)) {
                out.push(String(q.name));
            }
        }
        return out;
    }

    function findAssistBlockForField(modal, fieldName) {
        var blocks = modal && modal._vgAssistBlocks ? modal._vgAssistBlocks : [];
        var nm = String(fieldName || '');
        for (var i = 0; i < blocks.length; i++) {
            var b = blocks[i];
            var names = b && b.field_names ? b.field_names : [];
            for (var j = 0; j < names.length; j++) {
                if (String(names[j]) === nm) return b;
            }
        }
        return null;
    }

    function prefetchFieldNamesFromAnchor(modal, survey, anchorFieldName) {
        var empty = listEmptyCompileFieldNames(survey, modal);
        if (!empty.length) return [];
        var start = 0;
        if (anchorFieldName) {
            var idx = empty.indexOf(String(anchorFieldName));
            start = idx >= 0 ? idx + 1 : 0;
        }
        var slice = empty.slice(start, start + 8);
        var block = anchorFieldName ? findAssistBlockForField(modal, anchorFieldName) : null;
        if (block && block.field_names && block.field_names.length > 1) {
            var blockNames = [];
            var seen = {};
            for (var bi = 0; bi < block.field_names.length; bi++) {
                var bn = String(block.field_names[bi]);
                if (!compileQuestionHasUserValue(survey, survey.getQuestionByName(bn)) && !seen[bn]) {
                    seen[bn] = true;
                    blockNames.push(bn);
                }
            }
            if (blockNames.length) {
                return blockNames;
            }
        }
        var nextBlock = null;
        for (var si = start; si < empty.length; si++) {
            var cand = findAssistBlockForField(modal, empty[si]);
            if (cand && cand.field_names && cand.field_names.length > 1) {
                nextBlock = cand;
                break;
            }
        }
        if (nextBlock && nextBlock.field_names) {
            var out = [];
            var seen2 = {};
            for (var k = 0; k < nextBlock.field_names.length; k++) {
                var fn = String(nextBlock.field_names[k]);
                if (!modal._vgFieldAssistCache || !modal._vgFieldAssistCache[fn]) {
                    if (!seen2[fn]) {
                        seen2[fn] = true;
                        out.push(fn);
                    }
                }
            }
            if (out.length) return out;
        }
        return slice.filter(function (nm) {
            return !modal._vgFieldAssistCache || !modal._vgFieldAssistCache[nm];
        });
    }

    function scheduleCompileAssistPrefetch(modal, survey, anchorFieldName) {
        if (!modal || !survey || modal._vgCompileMode === 'pdf_free') return;
        var names = prefetchFieldNamesFromAnchor(modal, survey, anchorFieldName);
        if (!names.length) return;
        var need = [];
        for (var i = 0; i < names.length; i++) {
            if (!modal._vgFieldAssistCache || !modal._vgFieldAssistCache[names[i]]) {
                need.push(names[i]);
            }
        }
        if (!need.length) {
            refreshCompileFieldAssistPanels(modal, survey, anchorFieldName);
            return;
        }
        modal._vgAssistPrefetchGen = (modal._vgAssistPrefetchGen || 0) + 1;
        var gen = modal._vgAssistPrefetchGen;
        modal._vgAssistPrefetchPending = need;
        fetchCompileFieldAssistBatch(modal, need, { prefer_blocks: true }).then(function (res) {
            if (gen !== modal._vgAssistPrefetchGen) return;
            if (!modal._vgSurvey || modal.hasAttribute('hidden')) return;
            modal._vgAssistPrefetchPending = null;
            if (res && res.fields) {
                applyProgressiveCompileAssist(modal, survey, Object.keys(res.fields));
            }
            refreshCompileFieldAssistPanels(modal, survey, anchorFieldName);
        }).catch(function () {
            if (gen !== modal._vgAssistPrefetchGen) return;
            modal._vgAssistPrefetchPending = null;
        });
    }

    function fetchCompileFieldAssistBatch(modal, fieldNames, opts) {
        opts = opts || {};
        if (!modal || !fieldNames || !fieldNames.length) return Promise.resolve({});
        if (!modal._vgFieldAssistInflight) modal._vgFieldAssistInflight = {};
        var key = 'batch:' + fieldNames.join('|');
        if (modal._vgFieldAssistInflight[key]) {
            return modal._vgFieldAssistInflight[key];
        }
        var p = apiJson(compileFieldAssistBatchApiPath(modal), {
            method: 'POST',
            body: {
                field_names: fieldNames,
                prefer_blocks: opts.prefer_blocks !== false
            }
        }).then(function (res) {
            if (res && res.fields) {
                mergeAssistCache(modal, res.fields);
                if (modal._vgSurvey) {
                    applyProgressiveCompileAssist(modal, modal._vgSurvey, Object.keys(res.fields));
                }
            }
            delete modal._vgFieldAssistInflight[key];
            return res;
        }).catch(function (err) {
            delete modal._vgFieldAssistInflight[key];
            return Promise.reject(err);
        });
        modal._vgFieldAssistInflight[key] = p;
        return p;
    }

    function fetchCompileFieldAssist(modal, fieldName) {
        if (!modal || !fieldName) return Promise.resolve(null);
        if (!modal._vgFieldAssistCache) modal._vgFieldAssistCache = {};
        if (modal._vgFieldAssistCache[fieldName]) {
            return Promise.resolve(modal._vgFieldAssistCache[fieldName]);
        }
        if (modal._vgFieldAssistInflight && modal._vgFieldAssistInflight[fieldName]) {
            return modal._vgFieldAssistInflight[fieldName];
        }
        if (!modal._vgFieldAssistInflight) modal._vgFieldAssistInflight = {};
        var p = apiJson(compileFieldAssistApiPath(modal, fieldName)).then(function (res) {
            if (res && typeof res === 'object') {
                modal._vgFieldAssistCache[fieldName] = res;
                if (modal._vgSurvey && !res.profile_data_missing) {
                    applyProgressiveCompileAssist(modal, modal._vgSurvey, [fieldName]);
                }
            }
            delete modal._vgFieldAssistInflight[fieldName];
            return res;
        }).catch(function (err) {
            delete modal._vgFieldAssistInflight[fieldName];
            var msg = (err && err.message) ? String(err.message) : 'Errore di rete';
            modal._vgFieldAssistCache[fieldName] = {
                field_name: fieldName,
                status: 'unavailable',
                input_mode: 'text',
                recommendation: '',
                rationale: msg,
                suggestions: [],
                _client_error: true
            };
            return modal._vgFieldAssistCache[fieldName];
        });
        modal._vgFieldAssistInflight[fieldName] = p;
        return p;
    }

    function isAssistInstructionalText(val) {
        var s = String(val || '').trim().toLowerCase();
        if (!s) return false;
        if (s.indexOf('non abbiamo trovato') === 0) return false;
        if (s.indexOf('valore dal company profile') === 0) return false;
        if (s.indexOf('dato anagrafico dal contatto') === 0) return false;
        if (s.length > 200) return true;
        var markers = [
            'compilare il campo', 'compilare con', 'assicurati', 'è importante',
            'inserire i dati', 'inserire il nome', 'verifica che', 'deve corrispondere',
            'evitare problemi', 'nome e cognome del', 'garantir', 'poteri necessari',
            'procedura di gara', 'validità della domanda', 'questo garantir'
        ];
        for (var i = 0; i < markers.length; i++) {
            if (s.indexOf(markers[i]) >= 0) return true;
        }
        return false;
    }

    function isAssistActionableValue(val) {
        var s = String(val || '').trim();
        if (!s || s.length > 80) return false;
        return !isAssistInstructionalText(s);
    }

    function assistDisplayRationale(assist) {
        var parts = [];
        var ragN = assist && String(assist.rag_index_notice || '').trim();
        if (ragN) parts.push(ragN);
        var r = String((assist && assist.rationale) || '').trim();
        if (r && ragN && r.indexOf(ragN) >= 0) {
            /* already merged server-side */
        } else if (r) {
            parts.push(r);
        }
        if (parts.length) {
            return parts.join(' ').trim();
        }
        if (r && assist && assist.profile_data_missing) {
            return r;
        }
        if (isAssistInstructionalText(r)) {
            if (assist && assist.profile_data_missing) {
                if (assist.profile_missing_kind === 'contact_field') {
                    return r || (
                        'Non abbiamo trovato questo dato nel profilo del legale rappresentante. ' +
                        'Completa il contatto in Profilo azienda → Contatti.'
                    );
                }
                return 'Non abbiamo trovato questo dato nel Company Profile. Aggiungi un contatto con ruolo «Legale rappresentante» in Contatti, oppure compila manualmente.';
            }
            var suggestions = filterAssistSuggestions(assist && assist.suggestions);
            if (suggestions.length) {
                return 'Usa il valore dal Company Profile: clicca il chip sotto per inserirlo nel campo.';
            }
            return 'Compila il campo in base al modulo. Non abbiamo un valore certo salvato nel profilo azienda.';
        }
        return r;
    }

    function assistProfileLinkHint(assist) {
        if (!assist || !assist.profile_data_missing) return '';
        if (assist.profile_missing_kind === 'contact_field') {
            return ' per completare Nascita/Residenza del legale rappresentante in Contatti.';
        }
        return ' per aggiungere il legale rappresentante in Contatti.';
    }

    function renderCompileRagBanner(modal, ragIndex) {
        if (!modal) return;
        var host = modal.querySelector('[data-compila-rag-banner]');
        if (!host) {
            var statusRow = modal.querySelector('[data-compila-status]');
            if (!statusRow || !statusRow.parentNode) return;
            host = document.createElement('div');
            host.className = 'vg-kanban-compila__rag-banner';
            host.setAttribute('data-compila-rag-banner', '');
            host.setAttribute('hidden', 'hidden');
            statusRow.parentNode.insertBefore(host, statusRow.nextSibling);
        }
        if (!ragIndex || ragIndex.complete === true) {
            host.hidden = true;
            host.innerHTML = '';
            return;
        }
        var notice = String(ragIndex.notice || '').trim();
        if (!notice) {
            notice = 'Indice profilo azienda non ancora pronto: i suggerimenti possono essere incompleti.';
        }
        var url = String(ragIndex.company_profile_url || '/company-profile/');
        host.hidden = false;
        host.innerHTML =
            '<p class="vg-kanban-compila__rag-banner-text">' + escapeHtml(notice) + '</p>' +
            '<a class="vg-kanban-compila__rag-banner-link" href="' + escapeHtml(url) +
            '" target="_blank" rel="noopener">Apri Company Profile</a>';
    }

    function applyProgressiveCompileAssist(modal, survey, fieldNames) {
        if (!modal || !survey || !fieldNames || !fieldNames.length) return;
        fieldNames.forEach(function (nm) {
            var assist = modal._vgFieldAssistCache && modal._vgFieldAssistCache[nm];
            if (!assist || assist.profile_data_missing || assist.input_mode === 'skip') return;
            var q = survey.getQuestionByName(nm);
            if (!q || compileQuestionHasUserValue(survey, q)) return;
            var suggestions = filterAssistSuggestions(assist.suggestions);
            var profileSugs = suggestions.filter(function (s) {
                return s && String(s.source || '').toLowerCase() === 'profile';
            });
            var val = '';
            if (profileSugs.length === 1) {
                val = String(profileSugs[0].value || '').trim();
            } else if (
                profileSugs.length === 0 &&
                isAssistActionableValue(assist.recommendation) &&
                String(assist.recommendation || '').trim()
            ) {
                val = String(assist.recommendation || '').trim();
            }
            if (!val) return;
            if (assist.input_mode === 'radiogroup' && profileSugs.length > 1) return;
            setCompileQuestionValue(survey, modal, nm, val);
        });
        refreshCompileFieldAssistPanels(modal, survey, modal._vgPendingFocus);
        updateCompileProgressChrome(
            modal,
            survey,
            modal.querySelector('[data-title]'),
            modal.querySelector('[data-compila-status]'),
            { updateTitle: true }
        );
    }

    function filterAssistSuggestions(suggestions) {
        if (!Array.isArray(suggestions)) return [];
        return suggestions.filter(function (s) {
            return s && isAssistActionableValue(s.value);
        });
    }

    function getCompileQuestionHost(modal, fieldName) {
        var nm = String(fieldName || '');
        if (modal && modal._vgQuestionHostByName && modal._vgQuestionHostByName[nm]) {
            return modal._vgQuestionHostByName[nm];
        }
        if (!modal) return null;
        return modal.querySelector('[data-name="' + cssEscapeIdent(nm) + '"]');
    }

    function getCompileQuestionInput(modal, survey, fieldName) {
        var host = getCompileQuestionHost(modal, fieldName);
        if (host) {
            var list = host.querySelectorAll('input, textarea, select');
            for (var i = 0; i < list.length; i++) {
                if (list[i].type === 'hidden') continue;
                return list[i];
            }
        }
        var q = survey && fieldName ? survey.getQuestionByName(String(fieldName)) : null;
        if (q && typeof q.inputId === 'string' && q.inputId) {
            var byId = document.getElementById(q.inputId);
            if (byId) return byId;
        }
        return null;
    }

    function fireCompileInputEvents(inp) {
        if (!inp) return;
        try { inp.dispatchEvent(new Event('input', { bubbles: true })); } catch (eIn) {}
        try { inp.dispatchEvent(new Event('change', { bubbles: true })); } catch (eCh) {}
        try { inp.dispatchEvent(new Event('blur', { bubbles: true })); } catch (eBl) {}
    }

    /** Imposta il valore sul campo SurveyJS e sincronizza l'input visibile. */
    function setCompileQuestionValue(survey, modal, fieldName, val) {
        if (!survey || !fieldName) return false;
        var nm = String(fieldName);
        var v = String(val == null ? '' : val).trim();
        if (!v) return false;
        var q = survey.getQuestionByName(nm);
        if (!q) return false;
        var qType = q.getType ? q.getType() : '';
        if (qType === 'radiogroup' || qType === 'boolean') {
            try { q.value = v; } catch (eQv) {}
            try { survey.setValue(nm, v); } catch (eRg) {}
            return true;
        }
        try { survey.setValue(nm, v); } catch (eSv) {}
        try { q.value = v; } catch (eQv2) {}
        try {
            if (survey.data && typeof survey.data === 'object') survey.data[nm] = v;
        } catch (eDt) {}
        var inp = getCompileQuestionInput(modal, survey, nm);
        if (inp) {
            inp.value = v;
            fireCompileInputEvents(inp);
            try { inp.focus(); } catch (eFc) {}
        }
        try {
            if (q && typeof q.updateElement === 'function') q.updateElement();
        } catch (eUe) {}
        try {
            if (typeof survey.onValueChanged !== 'undefined' && survey.onValueChanged.fire) {
                survey.onValueChanged.fire(survey, {
                    name: nm,
                    value: v,
                    question: survey.getQuestionByName(nm)
                });
            }
        } catch (eVc) {}
        return String(survey.getValue(nm) || '').trim() === v || (inp && String(inp.value || '').trim() === v);
    }

    function renderCompileFieldAssistPanel(modal, survey, fieldName, state, assist) {
        var map = modal._vgAssistPanelByName;
        if (!map) return;
        var el = map[fieldName];
        if (!el || !el.parentNode) return;
        var q = survey.getQuestionByName(fieldName);
        if (!q) {
            el.setAttribute('hidden', 'hidden');
            el.innerHTML = '';
            return;
        }
        if (compileQuestionHasUserValue(survey, q)) {
            el.setAttribute('hidden', 'hidden');
            el.innerHTML = '';
            return;
        }
        el.removeAttribute('hidden');
        if (state === 'loading') {
            el.innerHTML = '<div class="vg-kanban-compila__assist vg-kanban-compila__assist--loading">' +
                '<span class="vg-kanban-compila__assist-label">Suggerimenti</span>' +
                '<p class="vg-kanban-compila__assist-rationale">Caricamento suggerimenti contestuali…</p></div>';
            return;
        }
        if (state === 'prefetched' && assist) {
            var rationalePf = assistDisplayRationale(assist);
            if (!rationalePf) rationalePf = 'Suggerimento pronto — seleziona il campo per i dettagli.';
            el.innerHTML = '<div class="vg-kanban-compila__assist vg-kanban-compila__assist--prefetched">' +
                '<span class="vg-kanban-compila__assist-label">Suggerimenti</span>' +
                '<p class="vg-kanban-compila__assist-rationale">' + escapeHtml(rationalePf) + '</p></div>';
            return;
        }
        if (state === 'error') {
            el.innerHTML = '<div class="vg-kanban-compila__assist vg-kanban-compila__assist--error">' +
                '<span class="vg-kanban-compila__assist-label">Suggerimenti</span>' +
                '<p class="vg-kanban-compila__assist-rationale">Suggerimenti non disponibili al momento. Compila manualmente.</p></div>';
            return;
        }
        if (!assist) {
            el.setAttribute('hidden', 'hidden');
            el.innerHTML = '';
            return;
        }
        if (assist.input_mode === 'skip') {
            el.setAttribute('hidden', 'hidden');
            el.innerHTML = '';
            return;
        }
        var rationale = assistDisplayRationale(assist);
        if (!rationale) {
            rationale = 'Verifica il valore in base al modulo e alla documentazione di gara.';
        }
        var rec = isAssistActionableValue(assist.recommendation)
            ? String(assist.recommendation || '').trim()
            : '';
        var suggestions = filterAssistSuggestions(assist.suggestions);
        var assistClass = 'vg-kanban-compila__assist';
        if (assist.rag_index_incomplete) assistClass += ' vg-kanban-compila__assist--rag-incomplete';
        var html = '<div class="' + assistClass + '">' +
            '<span class="vg-kanban-compila__assist-label">Cosa consigliamo</span>' +
            '<p class="vg-kanban-compila__assist-rationale">' + escapeHtml(rationale) + '</p>';
        if (rec) {
            html += '<p class="vg-kanban-compila__assist-rec"><strong>Valore consigliato:</strong> ' +
                escapeHtml(rec) + '</p>';
        } else if (assist.profile_data_missing) {
            var linkHint = assistProfileLinkHint(assist) ||
                'per aggiungere il legale rappresentante in Contatti.';
            html += '<p class="vg-kanban-compila__assist-rec vg-kanban-compila__assist-rec--hint">' +
                '<a href="/company-profile/" target="_blank" rel="noopener">Apri Company Profile</a> ' +
                escapeHtml(linkHint) + '</p>';
        }
        if (suggestions.length && assist.input_mode !== 'boolean') {
            html += '<div class="vg-kanban-compila__assist-chips" role="list">';
            suggestions.forEach(function (s) {
                var val = String((s && s.value) || '').trim();
                if (!val) return;
                var src = String((s && s.source) || '').trim();
                var chipLabel = String((s && s.label) || '').trim() || src || 'Suggerimento';
                html += '<button type="button" class="vg-kanban-compila__assist-chip" role="listitem">' +
                    '<span class="vg-kanban-compila__assist-chip-src">' +
                    escapeHtml(chipLabel) + '</span><span class="vg-kanban-compila__assist-chip-val">' +
                    escapeHtml(val) + '</span></button>';
            });
            html += '</div>';
        }
        html += '</div>';
        el.innerHTML = html;
        el.querySelectorAll('.vg-kanban-compila__assist-chip').forEach(function (btn) {
            var valEl = btn.querySelector('.vg-kanban-compila__assist-chip-val');
            var chipVal = valEl ? String(valEl.textContent || '').trim() : '';
            if (chipVal) btn.dataset.vgChipValue = chipVal;
            btn.addEventListener('mousedown', function (ev) {
                if (ev && ev.preventDefault) ev.preventDefault();
            });
            btn.addEventListener('click', function (ev) {
                if (ev) {
                    if (ev.preventDefault) ev.preventDefault();
                    if (ev.stopPropagation) ev.stopPropagation();
                }
                var activeSurvey = modal._vgSurvey || survey;
                var val = String(btn.dataset.vgChipValue || btn.getAttribute('data-vg-chip-value') || '').trim();
                if (!val) return;
                setCompileQuestionValue(activeSurvey, modal, fieldName, val);
                window.setTimeout(function () {
                    if (!modal._vgSurvey || modal.hasAttribute('hidden')) return;
                    renderCompileFieldAssistPanel(modal, activeSurvey, fieldName, 'ready', assist);
                    scheduleRefreshCompilePreview(
                        modal.querySelector('[data-compila-preview]'),
                        modal,
                        fieldName
                    );
                }, 0);
            });
        });
    }

    function syncCompileFieldAssist(modal, survey, fieldName, opts) {
        opts = opts || {};
        if (!modal || !survey || !fieldName) return;
        var nm = String(fieldName);
        if (opts.loading) {
            renderCompileFieldAssistPanel(modal, survey, nm, 'loading', null);
            return;
        }
        if (opts.error) {
            renderCompileFieldAssistPanel(modal, survey, nm, 'error', null);
            return;
        }
        if (opts.ready && modal._vgFieldAssistCache && modal._vgFieldAssistCache[nm]) {
            renderCompileFieldAssistPanel(modal, survey, nm, 'ready', modal._vgFieldAssistCache[nm]);
            return;
        }
        if (modal._vgFieldAssistCache && modal._vgFieldAssistCache[nm]) {
            renderCompileFieldAssistPanel(modal, survey, nm, 'ready', modal._vgFieldAssistCache[nm]);
            scheduleCompileAssistPrefetch(modal, survey, nm);
            return;
        }
        var block = findAssistBlockForField(modal, nm);
        var blockNames = block && block.field_names ? block.field_names : [nm];
        var blockMissing = [];
        for (var bi = 0; bi < blockNames.length; bi++) {
            var bn = String(blockNames[bi]);
            if (!modal._vgFieldAssistCache || !modal._vgFieldAssistCache[bn]) {
                blockMissing.push(bn);
            }
        }
        renderCompileFieldAssistPanel(modal, survey, nm, 'loading', null);
        var fetchP;
        if (blockMissing.length > 1) {
            fetchP = fetchCompileFieldAssistBatch(modal, blockMissing, { prefer_blocks: true });
        } else {
            fetchP = fetchCompileFieldAssist(modal, nm);
        }
        fetchP.then(function (res) {
            if (!modal._vgSurvey || modal.hasAttribute('hidden')) return;
            var applied = [nm];
            if (res && res.fields) {
                applied = Object.keys(res.fields);
            }
            applyProgressiveCompileAssist(modal, survey, applied);
            syncCompileFieldAssist(modal, survey, nm, { ready: true });
            scheduleCompileAssistPrefetch(modal, survey, nm);
        }).catch(function () {
            if (!modal._vgSurvey || modal.hasAttribute('hidden')) return;
            syncCompileFieldAssist(modal, survey, nm, { error: true });
        });
    }

    function refreshCompileFieldAssistPanels(modal, survey, focusedQuestionName) {
        if (!modal || !survey) return;
        var map = modal._vgAssistPanelByName;
        if (!map) return;
        var foc = focusedQuestionName ? String(focusedQuestionName) : '';
        Object.keys(map).forEach(function (nm) {
            var q = survey.getQuestionByName(nm);
            if (!q) {
                var elMissing = map[nm];
                if (elMissing) {
                    elMissing.setAttribute('hidden', 'hidden');
                    elMissing.innerHTML = '';
                }
                return;
            }
            if (compileQuestionHasUserValue(survey, q)) {
                renderCompileFieldAssistPanel(modal, survey, nm, 'ready', null);
                return;
            }
            if (modal._vgFieldAssistCache && modal._vgFieldAssistCache[nm]) {
                var st = nm === foc ? 'ready' : 'prefetched';
                renderCompileFieldAssistPanel(modal, survey, nm, st, modal._vgFieldAssistCache[nm]);
            } else if (nm === foc) {
                syncCompileFieldAssist(modal, survey, nm);
            } else if (
                modal._vgAssistPrefetchPending &&
                modal._vgAssistPrefetchPending.indexOf(nm) >= 0
            ) {
                renderCompileFieldAssistPanel(modal, survey, nm, 'loading', null);
            } else {
                var el = map[nm];
                if (el) {
                    el.removeAttribute('hidden');
                    el.innerHTML = '<div class="vg-kanban-compila__assist vg-kanban-compila__assist--idle">' +
                        '<span class="vg-kanban-compila__assist-label">Suggerimenti</span>' +
                        '<p class="vg-kanban-compila__assist-rationale">Seleziona il campo per caricare i suggerimenti.</p></div>';
                }
            }
        });
    }

    function applyCompileFormData(survey, res) {
        if (!survey || !res) return;
        var raw = Object.assign({}, (res.data) || {});
        var data = {};
        Object.keys(raw).forEach(function (k) {
            if (isPlausibleCompileValue(raw[k])) data[k] = raw[k];
        });
        try {
            if (typeof survey.mergeData === 'function') survey.mergeData(data);
            else survey.data = Object.assign({}, survey.data || {}, data);
        } catch (eMd) {
            survey.data = Object.assign({}, survey.data || {}, data);
        }
        Object.keys(data).forEach(function (k) {
            try { survey.setValue(k, data[k]); } catch (eSv) {}
        });
    }

    function mammothDocxToHtml(arrayBuffer) {
        var convOpts = {
            styleMap: [
                "highlight => mark",
                "r[style-name='Highlight'] => mark",
                "b => strong",
                "i => em",
                "u => u"
            ]
        };
        return window.mammoth.convertToHtml({ arrayBuffer: arrayBuffer }, convOpts);
    }

    /** Emoji come toolbar mappa homepage (`partials/appaltimap-map.hbs`). */
    function compilaToolbarEmoji(name) {
        var ch = '📥';
        if (name === 'download') ch = '📥';
        else if (name === 'template') ch = '📄';
        else if (name === 'working') ch = '📝';
        else if (name === 'save') ch = '💾';
        return '<span aria-hidden="true">' + ch + '</span>';
    }

    function compilaUsesMarkerTemplate(modal) {
        if (!modal) return false;
        var srv = String(modal._vgServerTemplateHtml || '');
        if (String(modal._vgServerTemplateHtml || '').indexOf('{field-') >= 0) return true;
        var hints = modal._vgFieldHints || {};
        for (var k in hints) {
            if (hints[k] && (hints[k].marker || hints[k].marker_num != null)) return true;
        }
        return modal._vgFillMethod === 'docx_markers';
    }

    function compilaPreviewUrlsDiffer(preview, modal) {
        preview = preview || {};
        if (compilaUsesMarkerTemplate(modal)) return true;
        var working = String(preview.url || '').trim();
        var template = String(preview.templateUrl || '').trim();
        return !!(working && template && working !== template);
    }

    function compilaPreviewToolbarHtml(opts) {
        var downloadUrl = resolveKanbanApiUrl(String(opts.downloadUrl || opts.url || ''));
        if (!downloadUrl) return '';
        var filename = String(opts.filename || '').trim() || 'documento';
        var view = opts.previewView === 'template' ? 'template' : 'working';
        var showToggle = !!opts.showTemplateToggle;
        var toggleTitle = view === 'template'
            ? 'Mostra anteprima compilazione'
            : 'Mostra template con marcatori';
        var toggleIcon = view === 'template' ? compilaToolbarEmoji('working') : compilaToolbarEmoji('template');
        var toggleCls =
            'appaltimap-btn appaltimap-btn--icon vg-kanban-docbox__toolbar-btn vg-kanban-docbox__toolbar-btn--view';
        if (view === 'template') toggleCls += ' vg-kanban-docbox__toolbar-btn--active';
        var html = '<div class="vg-kanban-docbox__toolbar vg-kanban-docbox__toolbar--icons">';
        if (showToggle) {
            html += '<button type="button" class="' + toggleCls + '" data-compila-view-toggle data-kanban-no-drag title="' +
                escapeHtml(toggleTitle) + '" aria-label="' + escapeHtml(toggleTitle) + '">' + toggleIcon + '</button>';
        }
        html += '<a class="appaltimap-btn appaltimap-btn--icon vg-kanban-docbox__toolbar-btn vg-kanban-docbox__toolbar-btn--download" href="' +
            escapeHtml(downloadUrl) + '" download="' + escapeHtml(filename) +
            '" target="_blank" rel="noopener" data-kanban-no-drag data-compila-download title="Scarica" aria-label="Scarica">' +
            compilaToolbarEmoji('download') + '</a>';
        html += '</div>';
        return html;
    }

    function compilaDocxOnTemplateCallback(modal) {
        return function (html) {
            var templateView = modal._vgPreviewView === 'template';
            var tplSrv = String(modal._vgServerTemplateHtml || '');
            var prevSrv = String(modal._vgServerPreviewHtml || '');
            if (templateView && tplSrv && docxTemplateMarkerHtml(tplSrv)) {
                modal._vgDocxTemplate = tplSrv;
                modal._vgDocxAnnotated = docxTemplateHasSlots(tplSrv) || tplSrv.indexOf('{field-') >= 0;
                return;
            }
            if (!templateView && prevSrv && docxTemplateUseServer(prevSrv)) {
                modal._vgDocxTemplate = prevSrv;
                modal._vgDocxAnnotated = docxTemplateHasSlots(prevSrv);
                return;
            }
            if (!templateView && docxPreviewHtmlHasMarkers(html) && prevSrv && docxTemplateUseServer(prevSrv)) {
                modal._vgDocxTemplate = prevSrv;
                modal._vgDocxAnnotated = docxTemplateHasSlots(prevSrv);
                return;
            }
            modal._vgDocxTemplate = html;
            modal._vgDocxAnnotated = docxTemplateHasSlots(html) && !docxPreviewHtmlHasMarkers(html);
        };
    }

    function renderCompilaPreview(previewEl, modal, extraOpts) {
        if (!previewEl || !modal) return;
        extraOpts = extraOpts || {};
        var p = modal._vgCompilePreview || {};
        var workingUrl = String(p.url || '').trim();
        if (!workingUrl) return;
        var templateUrl = String(p.templateUrl || workingUrl).trim();
        var view = modal._vgPreviewView === 'template' ? 'template' : 'working';
        var showUrl = view === 'template' ? templateUrl : workingUrl;
        if (extraOpts.cacheBust && showUrl) {
            showUrl += (showUrl.indexOf('?') >= 0 ? '&' : '?') + 't=' + Date.now();
        }
        var onReady = extraOpts.onReady;
        var focusName = modal._vgPendingFocus;
        var templateView = view === 'template';
        var prevSrv = String(modal._vgServerPreviewHtml || '');
        var tplSrv = String(modal._vgServerTemplateHtml || '');
        var slotHtml = templateView
            ? (tplSrv && docxTemplateMarkerHtml(tplSrv) ? tplSrv : '')
            : (prevSrv && docxTemplateUseServer(prevSrv) ? prevSrv : '');
        var preferMammoth = !slotHtml;
        if (!templateView && !slotHtml && tplSrv && prevSrv) {
            preferMammoth = false;
        }
        renderPreviewPane(previewEl, {
            compilaToolbar: true,
            previewView: view,
            showTemplateToggle: compilaPreviewUrlsDiffer(p, modal),
            url: showUrl,
            downloadUrl: showUrl,
            templateUrl: templateUrl,
            templateHtml: slotHtml,
            preferMammoth: preferMammoth,
            filename: p.filename,
            contentType: p.contentType,
            onDocxTemplate: compilaDocxOnTemplateCallback(modal),
            onReady: onReady || function () {
                refreshCompilePreviewFromForm(previewEl, modal, focusName);
            }
        });
    }

    function renderPreviewPane(bodyEl, opts) {
        opts = opts || {};
        if (!bodyEl) return;
        if (opts.showLoading !== false) {
            renderPreviewLoading(bodyEl, opts.loadingLabel || 'Caricamento anteprima…');
        }
        var downloadUrl = resolveKanbanApiUrl(String(opts.downloadUrl || opts.url || ''));
        var viewMode = opts.previewView === 'template' ? 'template' : 'working';
        var mammothUrl = resolveKanbanApiUrl(
            viewMode === 'template'
                ? String(opts.templateUrl || opts.downloadUrl || opts.url || '')
                : String(opts.downloadUrl || opts.url || opts.templateUrl || '')
        );
        var url = downloadUrl;
        var ct = String(opts.contentType || '').toLowerCase();
        var filename = String(opts.filename || '').trim() || 'documento';
        function previewToolbarHtml() {
            if (opts.compilaToolbar) {
                return compilaPreviewToolbarHtml(opts);
            }
            if (!downloadUrl) return '';
            return (
                '<div class="vg-kanban-docbox__toolbar">' +
                '<a class="vg-kanban-docbox__download" href="' + escapeHtml(downloadUrl) + '" download="' + escapeHtml(filename) + '" target="_blank" rel="noopener" data-kanban-no-drag data-compila-download>Scarica</a>' +
                '</div>'
            );
        }
        function done() {
            if (typeof opts.onReady === 'function') {
                try { opts.onReady(bodyEl); } catch (eRd) {}
            }
        }
        function isPdf() {
            if (ct.indexOf('application/pdf') >= 0) return true;
            return (filename.toLowerCase().slice(-4) === '.pdf') || /\/pdfs?$/.test(url.toLowerCase());
        }
        function isImage() {
            if (ct.indexOf('image/') === 0) return true;
            return /\.(png|jpe?g|gif|webp)$/i.test(filename);
        }
        function isDocx() {
            if (ct.indexOf('application/vnd.openxmlformats-officedocument.wordprocessingml.document') >= 0) return true;
            return /\.docx$/i.test(filename);
        }
        function isXlsx() {
            if (ct.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') >= 0) return true;
            if (ct.indexOf('application/vnd.ms-excel') >= 0) return true;
            return /\.(xlsx|xls)$/i.test(filename);
        }
        if (isPdf()) {
            bodyEl.innerHTML = previewToolbarHtml() +
                '<iframe class="vg-kanban-docbox__iframe vg-kanban-compila__iframe" data-kanban-no-drag src="' + escapeHtml(pdfJsViewerUrl(url)) + '" title="' + escapeHtml(filename) + '"></iframe>';
            var iframe = bodyEl.querySelector('iframe');
            if (iframe) iframe.addEventListener('load', function () { done(); }, { once: true });
            else done();
        } else if (isImage()) {
            bodyEl.innerHTML = previewToolbarHtml() +
                '<div class="vg-kanban-docbox__hint">Anteprima immagine.</div>' +
                '<img src="' + escapeHtml(url) + '" alt="' + escapeHtml(filename) + '" class="vg-kanban-compila__img" />';
            done();
        } else if (isDocx() && opts.templateHtml && docxTemplateUseServer(String(opts.templateHtml))) {
            var thSrv = String(opts.templateHtml);
            if (typeof opts.onDocxTemplate === 'function') {
                try { opts.onDocxTemplate(thSrv); } catch (eTplSrv) {}
            }
            bodyEl.innerHTML = previewToolbarHtml() +
                '<div class="vg-kanban-docbox__hint">Anteprima DOCX</div>' +
                '<div class="vg-kanban-compila__docx vg-kanban-compila__docx--rich">' + thSrv + '</div>';
            done();
        } else if (isDocx() && opts.preferMammoth !== false && window.mammoth && typeof window.mammoth.convertToHtml === 'function') {
            fetch(mammothUrl, { credentials: 'include' }).then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.arrayBuffer();
            }).then(function (ab) { return mammothDocxToHtml(ab); })
                .then(function (res) {
                    var raw = (res && res.value) ? res.value : '';
                    if (typeof opts.onDocxTemplate === 'function') {
                        try { opts.onDocxTemplate(raw); } catch (eTpl) {}
                    }
                    bodyEl.innerHTML = previewToolbarHtml() +
                        '<div class="vg-kanban-docbox__hint">Anteprima DOCX</div>' +
                        '<div class="vg-kanban-compila__docx vg-kanban-compila__docx--rich">' + raw + '</div>';
                    done();
                })
                .catch(function () {
                    if (opts.templateHtml) {
                        var thFb = String(opts.templateHtml);
                        if (typeof opts.onDocxTemplate === 'function') {
                            try { opts.onDocxTemplate(thFb); } catch (eTplFb) {}
                        }
                        bodyEl.innerHTML = previewToolbarHtml() +
                            '<div class="vg-kanban-docbox__hint">Anteprima DOCX (semplificata)</div>' +
                            '<div class="vg-kanban-compila__docx">' + thFb + '</div>';
                        done();
                    } else {
                        bodyEl.innerHTML = previewToolbarHtml() +
                            '<div class="vg-kanban-compila__error">Impossibile visualizzare DOCX.</div>';
                        done();
                    }
                });
        } else if (isDocx() && opts.templateHtml) {
            var th = String(opts.templateHtml);
            if (typeof opts.onDocxTemplate === 'function') {
                try { opts.onDocxTemplate(th); } catch (eTpl2) {}
            }
            bodyEl.innerHTML = previewToolbarHtml() +
                '<div class="vg-kanban-docbox__hint">Anteprima DOCX (semplificata)</div>' +
                '<div class="vg-kanban-compila__docx">' + th + '</div>';
            done();
        } else if (isDocx() && window.mammoth && typeof window.mammoth.convertToHtml === 'function') {
            fetch(url, { credentials: 'include' }).then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.arrayBuffer();
            }).then(function (ab) { return mammothDocxToHtml(ab); })
                .then(function (res) {
                    var raw = (res && res.value) ? res.value : '';
                    if (typeof opts.onDocxTemplate === 'function') {
                        try { opts.onDocxTemplate(raw); } catch (eTpl) {}
                    }
                    bodyEl.innerHTML = previewToolbarHtml() +
                        '<div class="vg-kanban-docbox__hint">Anteprima DOCX</div>' +
                        '<div class="vg-kanban-compila__docx vg-kanban-compila__docx--rich">' + raw + '</div>';
                    done();
                })
                .catch(function () {
                    bodyEl.innerHTML = previewToolbarHtml() +
                        '<div class="vg-kanban-compila__error">Impossibile visualizzare DOCX.</div>';
                    done();
                });
        } else if (isXlsx() && window.XLSX && typeof window.XLSX.read === 'function') {
            fetch(url, { credentials: 'include' }).then(function (r) { return r.arrayBuffer(); })
                .then(function (ab) {
                    var wb = window.XLSX.read(ab, { type: 'array' });
                    var sheetName = (wb.SheetNames && wb.SheetNames[0]) ? wb.SheetNames[0] : null;
                    if (!sheetName) throw new Error('No sheets');
                    var html = window.XLSX.utils.sheet_to_html(wb.Sheets[sheetName]);
                    bodyEl.innerHTML = previewToolbarHtml() +
                        '<div class="vg-kanban-docbox__hint">Anteprima XLSX</div><div class="vg-kanban-compila__xlsx">' + html + '</div>';
                    done();
                })
                .catch(function () {
                    bodyEl.innerHTML = previewToolbarHtml() +
                        '<div class="vg-kanban-compila__error">Impossibile visualizzare Excel.</div>';
                    done();
                });
        } else {
            bodyEl.innerHTML = previewToolbarHtml() +
                '<div class="vg-kanban-docbox__hint">Anteprima non disponibile.</div>' +
                '<p><a href="' + escapeHtml(url) + '" target="_blank" rel="noopener" data-kanban-no-drag>' + escapeHtml(filename) + '</a></p>';
            done();
        }
    }


    function openDocbox(opts) {
        opts = opts || {};
        var modal = ensureDocboxModal();
        var titleEl = modal.querySelector('[data-title]');
        var bodyEl = modal.querySelector('[data-body]');
        var btnClose = modal.querySelector('[data-close]');
        if (titleEl) titleEl.textContent = opts.title || 'Documento';
        if (!bodyEl) return;
        renderPreviewPane(bodyEl, opts);
        modal.removeAttribute('hidden');
        var prev = document.activeElement;
        try { if (btnClose && btnClose.focus) btnClose.focus(); } catch (e) {}
        function close() {
            cleanup();
            modal.setAttribute('hidden', 'hidden');
            try { if (bodyEl) bodyEl.innerHTML = ''; } catch (e2) {}
            try { if (prev && prev.focus) prev.focus(); } catch (e3) {}
        }
        function onKey(e) { if (e.key === 'Escape') close(); }
        function onBackdrop(e) { if (e.target === modal) close(); }
        function onClose() { close(); }
        function cleanup() {
            document.removeEventListener('keydown', onKey);
            modal.removeEventListener('click', onBackdrop);
            if (btnClose) btnClose.removeEventListener('click', onClose);
        }
        document.addEventListener('keydown', onKey);
        modal.addEventListener('click', onBackdrop);
        if (btnClose) btnClose.addEventListener('click', onClose);
    }

    function ensureCompilaModal() {
        var existing = document.getElementById('vg-kanban-compila');
        if (existing) return existing;
        var wrap = document.createElement('div');
        wrap.id = 'vg-kanban-compila';
        wrap.className = 'vg-kanban-modal';
        wrap.setAttribute('hidden', 'hidden');
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel vg-kanban-compila__panel" role="document">' +
            '  <div class="vg-kanban-compila__header">' +
            '    <h2 class="vg-kanban-compila__title" data-title>Compila modulo</h2>' +
            '    <div class="vg-kanban-compila__header-actions">' +
            '      <button type="button" class="appaltimap-btn appaltimap-btn--primary vg-kanban-compila__save" data-compila-save title="Salva" aria-label="Salva">' +
            '        <span class="vg-kanban-compila__save-icon">' + compilaToolbarEmoji('save') + '</span>' +
            '        <span class="vg-kanban-compila__save-text">Salva</span>' +
            '      </button>' +
            '      <button type="button" class="vg-kanban-compila__close" data-close aria-label="Chiudi">✕</button>' +
            '    </div>' +
            '  </div>' +
            '  <div class="vg-kanban-compila__status" data-compila-status></div>' +
            '  <div class="vg-kanban-compila__grid">' +
            '    <div class="vg-kanban-compila__form"><div data-compila-survey></div></div>' +
            '    <div class="vg-kanban-compila__preview" data-compila-preview></div>' +
            '  </div>' +
            '</div>';
        (document.body || document.documentElement).appendChild(wrap);
        return wrap;
    }

    function replaceCompileSurveyMount(modal) {
        var form = modal ? modal.querySelector('.vg-kanban-compila__form') : null;
        if (!form) return null;
        var mount = document.createElement('div');
        mount.setAttribute('data-compila-survey', '');
        var old = form.querySelector('[data-compila-survey]');
        if (old) form.replaceChild(mount, old);
        else form.appendChild(mount);
        return mount;
    }

    function openCompila(opts) {
        opts = opts || {};
        var modal = ensureCompilaModal();
        if (typeof modal._vgCompileTeardown === 'function') {
            try { modal._vgCompileTeardown(); } catch (eTd) {}
            modal._vgCompileTeardown = null;
        }
        var titleEl = modal.querySelector('[data-title]');
        var statusEl = modal.querySelector('[data-compila-status]');
        var previewEl = modal.querySelector('[data-compila-preview]');
        var btnClose = modal.querySelector('[data-close]');
        var btnSave = modal.querySelector('[data-compila-save]');
        var itemId = parseInt(opts.itemId, 10) || 0;
        var origin = String(opts.origin || 'ai');
        var fileId = opts.fileId ? String(opts.fileId) : '';
        var uploadId = opts.uploadId ? String(opts.uploadId) : '';
        var filename = String(opts.filename || 'documento');

        modal._vgCompileSessionId = (modal._vgCompileSessionId || 0) + 1;
        var sessionId = modal._vgCompileSessionId;
        modal._vgCompileItemId = itemId;
        modal._vgCompileOrigin = origin;
        modal._vgCompileFileId = fileId;
        modal._vgCompileUploadId = uploadId;
        modal._vgFieldAssistCache = {};
        modal._vgFieldAssistInflight = {};
        modal._vgAssistPanelByName = {};
        modal._vgAssistBlocks = [];
        modal._vgAssistPrefetchGen = 0;
        modal._vgAssistPrefetchPending = null;
        disposeCompileSurvey(modal);
        var surveyMount = replaceCompileSurveyMount(modal);
        modal._vgDocxTemplate = null;
        modal._vgServerTemplateHtml = '';
        modal._vgDocxAnnotated = false;
        if (modal._vgPreviewRefreshTimer) {
            clearTimeout(modal._vgPreviewRefreshTimer);
            modal._vgPreviewRefreshTimer = null;
        }

        if (titleEl) titleEl.textContent = 'Compila: ' + filename;
        if (statusEl) statusEl.textContent = 'Caricamento…';
        if (surveyMount) surveyMount.innerHTML = '<div class="vg-kanban-compila__loading">Caricamento modulo…</div>';
        if (previewEl) renderPreviewLoading(previewEl, 'Caricamento anteprima…');

        var sessionPath = origin === 'manual'
            ? ('/kanban/items/' + itemId + '/uploads/' + encodeURIComponent(uploadId) + '/compile-session')
            : ('/kanban/items/' + itemId + '/downloads/' + encodeURIComponent(fileId) + '/compile-session');
        var putPath = origin === 'manual'
            ? ('/kanban/items/' + itemId + '/uploads/' + encodeURIComponent(uploadId) + '/compile')
            : ('/kanban/items/' + itemId + '/downloads/' + encodeURIComponent(fileId) + '/compile');

        modal._vgCompilePutPath = putPath;
        modal._vgCompilePreview = { filename: filename, contentType: opts.contentType || '' };
        modal._vgSurvey = null;
        modal._vgPreviewView = 'working';

        modal.removeAttribute('hidden');
        try { document.documentElement.classList.add('vg-kanban-modal-lock'); } catch (eL0) {}

        apiJson(sessionPath).then(function (res) {
            if (sessionId !== modal._vgCompileSessionId || modal.hasAttribute('hidden')) return;
            modal.classList.remove('vg-kanban-compila--pdf-free');
            modal._vgCompileMode = (res && res.compile_mode) ? String(res.compile_mode) : 'survey';
            modal._vgCompilePreview.filename = (res && res.filename) ? String(res.filename) : filename;
            modal._vgCompilePreview.contentType = (res && res.content_type) ? String(res.content_type) : (opts.contentType || '');
            var previewUrl = resolveKanbanApiUrl((res && res.preview_url) ? res.preview_url : '');
            var templateUrl = resolveKanbanApiUrl(
                (res && res.template_url) ? res.template_url : ((res && res.preview_url) ? res.preview_url : '')
            );
            modal._vgCompilePreview.url = previewUrl;
            modal._vgCompilePreview.templateUrl = templateUrl;
            modal._vgFillMethod = (res && res.fill_method) ? String(res.fill_method) : '';
            modal._vgServerPreviewHtml = (res && res.preview_html) ? String(res.preview_html) : '';
            modal._vgServerTemplateHtml = (res && res.template_html) ? String(res.template_html) : '';
            modal._vgCompilePrefill =
                res && res.prefill && typeof res.prefill === 'object' ? Object.assign({}, res.prefill) : {};

            if (res && res.compile_mode === 'pdf_free') {
                modal._vgSurvey = null;
                modal._vgFieldHints = {};
                if (surveyMount) {
                    surveyMount.innerHTML = '<div class="vg-kanban-compila__free-hint"><strong>Editor PDF libero</strong><p>Questo PDF non ha moduli AcroForm. Usa lo strumento <em>Testo</em> nella toolbar del visualizzatore per scrivere sul documento, poi premi <strong>Salva</strong>.</p></div>';
                }
                modal.classList.add('vg-kanban-compila--pdf-free');
                renderPreviewPane(previewEl, Object.assign({}, modal._vgCompilePreview, {
                    onReady: function () { enablePdfFreeEditor(previewEl); }
                }));
                if (statusEl) statusEl.textContent = '';
                return;
            }

            ensureSurveyAvailable();
            if (!modal.querySelector('[data-compila-survey]')) return;
            var surveyJson = sanitizeCompileSurveyJson(
                res && res.survey_json ? res.survey_json : { pages: [{ elements: [] }] }
            );
            if (countSurveyElements(surveyJson) < 1) {
                throw new Error('Nessun campo compilabile rilevato nel documento');
            }
            var survey;
            try {
                survey = new Survey.Model(surveyJson);
            } catch (eModel) {
                var smErr = modal.querySelector('[data-compila-survey]');
                if (smErr) {
                    smErr.innerHTML = '<div class="vg-kanban-compila__error">Errore modulo: ' +
                        escapeHtml((eModel && eModel.message) ? eModel.message : 'schema non valido') + '</div>';
                }
                return;
            }
            applyCompileFormData(survey, res);
            survey.showCompleteButton = false;
            var surveyPageCount = (surveyJson && surveyJson.pages && surveyJson.pages.length) ? surveyJson.pages.length : 1;
            if (surveyPageCount > 1) {
                survey.showNavigationButtons = 'bottom';
                survey.showProgressBar = 'top';
                survey.showPrevButton = true;
            } else {
                survey.showNavigationButtons = false;
                survey.showProgressBar = false;
            }
            try {
                if (window.Survey && window.Survey.StylesManager && window.Survey.StylesManager.applyTheme) {
                    window.Survey.StylesManager.applyTheme('defaultV2');
                }
            } catch (eTh) {}
            modal._vgFieldHints = (res && res.field_hints) ? res.field_hints : {};
            modal._vgAssistBlocks = (res && res.assist_blocks) ? res.assist_blocks : [];
            modal._vgRagIndex = (res && res.rag_index) ? res.rag_index : null;
            renderCompileRagBanner(modal, modal._vgRagIndex);
            if (res && res.field_assist_cache && typeof res.field_assist_cache === 'object') {
                modal._vgFieldAssistCache = Object.assign({}, res.field_assist_cache);
            }
            modal._vgPendingFocus = null;
            modal._vgAssistPanelByName = {};
            modal._vgQuestionHostByName = {};
            survey.onAfterRenderQuestion.add(function (_s, opts) {
                var q = opts && opts.question ? opts.question : null;
                var root = opts && opts.htmlElement ? opts.htmlElement : null;
                if (!q || !q.name || !root || root.querySelector('[data-vg-assist-root]')) return;
                modal._vgQuestionHostByName[q.name] = root;
                var wrap = document.createElement('div');
                wrap.className = 'vg-kanban-compila__assist-root';
                wrap.setAttribute('data-vg-assist-root', q.name);
                wrap.setAttribute('hidden', 'hidden');
                root.appendChild(wrap);
                modal._vgAssistPanelByName[q.name] = wrap;
            });
            survey.onFocusInQuestion.add(function (_sender, options) {
                var q = options && options.question ? options.question : null;
                if (!q || !q.name) return;
                modal._vgPendingFocus = q.name;
                refreshCompileFieldAssistPanels(modal, survey, q.name);
                scheduleRefreshCompilePreview(previewEl, modal, q.name);
                scheduleCompileAssistPrefetch(modal, survey, q.name);
            });
            survey.onValueChanged.add(function (_sender, options) {
                var q = options && options.question ? options.question : null;
                if (!q || !q.name) return;
                modal._vgPendingFocus = q.name;
                refreshCompileFieldAssistPanels(modal, survey, q.name);
                updateCompileProgressChrome(modal, survey, titleEl, statusEl, { updateTitle: true });
                scheduleRefreshCompilePreview(previewEl, modal, q.name);
            });
            survey.onCurrentPageChanged.add(function () {
                refreshCompileFieldAssistPanels(modal, survey, modal._vgPendingFocus);
                scheduleRefreshCompilePreview(previewEl, modal, modal._vgPendingFocus);
                scheduleCompileAssistPrefetch(modal, survey, modal._vgPendingFocus);
            });
            modal._vgSurvey = survey;
            modal._vgCompilePreview.filename = (res && res.filename) ? String(res.filename) : filename;
            modal._vgCompilePreview.contentType = (res && res.content_type) ? String(res.content_type) : (opts.contentType || '');
            var previewUrl2 = resolveKanbanApiUrl((res && res.preview_url) ? res.preview_url : '');
            var templateUrl2 = resolveKanbanApiUrl(
                (res && res.template_url) ? res.template_url : ((res && res.preview_url) ? res.preview_url : '')
            );
            modal._vgCompilePreview.url = previewUrl2;
            modal._vgCompilePreview.templateUrl = templateUrl2;
            modal._vgFillMethod = (res && res.fill_method) ? String(res.fill_method) : modal._vgFillMethod || '';

            function mountSurvey() {
                if (sessionId !== modal._vgCompileSessionId || modal.hasAttribute('hidden')) return;
                var sm = modal.querySelector('[data-compila-survey]');
                if (!sm) return;
                sm.innerHTML = '';
                modal._vgAssistPanelByName = {};
                modal._vgQuestionHostByName = {};
                try {
                    survey.render(sm);
                } catch (eRn) {
                    sm.innerHTML = '<div class="vg-kanban-compila__error">Errore rendering modulo.</div>';
                    return;
                }
                applyCompileFormData(survey, res);
                updateCompileProgressChrome(modal, survey, titleEl, statusEl, { updateTitle: true });
                renderCompilaPreview(previewEl, modal, {
                    onReady: function () {
                        var first = survey.getAllQuestions(false)[0];
                        if (first && first.name) modal._vgPendingFocus = first.name;
                        refreshCompilePreviewFromForm(previewEl, modal, modal._vgPendingFocus);
                        refreshCompileFieldAssistPanels(modal, survey, modal._vgPendingFocus);
                        if (modal._vgFieldAssistCache) {
                            applyProgressiveCompileAssist(
                                modal, survey, Object.keys(modal._vgFieldAssistCache)
                            );
                        }
                        scheduleCompileAssistPrefetch(modal, survey, modal._vgPendingFocus);
                    }
                });
                if (statusEl) statusEl.textContent = '';
            }

            requestAnimationFrame(function () {
                requestAnimationFrame(function () { mountSurvey(); });
            });
        }).catch(function (err) {
            if (sessionId !== modal._vgCompileSessionId || modal.hasAttribute('hidden')) return;
            if (statusEl) statusEl.textContent = '';
            showCompileError(modal.querySelector('[data-compila-survey]'), err, {
                action: 'compile-session',
                filename: filename,
                contentType: opts.contentType || '',
                path: sessionPath
            });
            if (previewEl) previewEl.innerHTML = '';
        });

        var prev = document.activeElement;

        function refreshPreview(cacheBust) {
            if (!previewEl || !(modal._vgCompilePreview || {}).url) return;
            renderCompilaPreview(previewEl, modal, { cacheBust: !!cacheBust });
        }

        function applyCompileSaveResponse(res, opts) {
            opts = opts || {};
            var survey = modal._vgSurvey;
            if (survey) {
                updateCompileProgressChrome(modal, survey, titleEl, statusEl, {
                    updateTitle: true,
                    statusText: opts.quiet ? '' : (
                        (res && res.compile_progress && res.compile_progress.total > 0)
                            ? ('Salvato (' + res.compile_progress.filled + '/' + res.compile_progress.total + ')')
                            : 'Salvato'
                    )
                });
            } else if (res && res.compile_progress) {
                var pf = parseInt(res.compile_progress.filled, 10);
                var pt = parseInt(res.compile_progress.total, 10);
                if (statusEl && !isNaN(pf) && !isNaN(pt) && pt > 0) {
                    statusEl.textContent = opts.quiet ? '' : ('Salvato (' + pf + '/' + pt + ')');
                } else if (statusEl && !opts.quiet) {
                    statusEl.textContent = 'Salvato';
                }
            } else if (statusEl && !opts.quiet) {
                statusEl.textContent = 'Salvato';
            }
            if (res && res.preview_url) modal._vgCompilePreview.url = resolveKanbanApiUrl(res.preview_url);
            if (res && res.template_url) {
                modal._vgCompilePreview.templateUrl = resolveKanbanApiUrl(res.template_url);
            }
            modal._vgDocxTemplate = null;
            modal._vgDocxAnnotated = false;
            if (res && res.filename) {
                modal._vgCompilePreview.filename = String(res.filename);
                if (titleEl) titleEl.textContent = 'Compila: ' + String(res.filename);
            }
            if (!opts.skipPreviewRefresh) refreshPreview(true);
            try { document.dispatchEvent(new CustomEvent('vg-kanban-compile-saved', { detail: { itemId: itemId } })); } catch (eEv) {}
        }

        function persistCompileValues(opts) {
            opts = opts || {};
            if (modal._vgCompileMode === 'pdf_free') {
                return Promise.reject(new Error('PDF libero: usa Salva nel visualizzatore'));
            }
            var survey = modal._vgSurvey;
            if (!survey) return Promise.reject(new Error('Modulo non pronto'));
            if (statusEl && !opts.quiet) statusEl.textContent = 'Salvataggio…';
            return apiJson(putPath, { method: 'POST', body: { values: survey.data || {} } }).then(function (res) {
                applyCompileSaveResponse(res, opts);
                return res;
            });
        }

        function doSave() {
            if (modal._vgCompileMode === 'pdf_free') {
                savePdfFreeCompile(previewEl, putPath, statusEl, modal, itemId, refreshPreview);
                return;
            }
            persistCompileValues({}).catch(function (err) {
                if (statusEl) statusEl.textContent = '';
                showCompileError(modal.querySelector('[data-compila-survey]'), err, {
                    action: 'compile-save',
                    filename: (modal._vgCompilePreview && modal._vgCompilePreview.filename) || filename,
                    path: putPath
                });
            });
        }

        function onPreviewToolbarClick(e) {
            var toggle = e.target && e.target.closest ? e.target.closest('[data-compila-view-toggle]') : null;
            if (!toggle || !previewEl || !previewEl.contains(toggle)) return;
            e.preventDefault();
            modal._vgPreviewView = modal._vgPreviewView === 'template' ? 'working' : 'template';
            modal._vgDocxAnnotated = false;
            renderCompilaPreview(previewEl, modal);
        }

        function onPreviewDownloadClick(e) {
            var a = e.target && e.target.closest ? e.target.closest('[data-compila-download]') : null;
            if (!a || !previewEl || !previewEl.contains(a)) return;
            e.preventDefault();
            if (modal._vgCompileMode === 'pdf_free') {
                var hrefFree = a.getAttribute('href') || '';
                if (hrefFree) window.open(hrefFree, '_blank', 'noopener');
                return;
            }
            if (modal._vgPreviewView === 'template') {
                var hrefTpl = a.getAttribute('href') || '';
                if (hrefTpl) window.open(hrefTpl, '_blank', 'noopener');
                return;
            }
            persistCompileValues({ quiet: true, skipPreviewRefresh: true }).then(function () {
                var u = a.getAttribute('href') || (modal._vgCompilePreview && modal._vgCompilePreview.url) || '';
                if (!u) return;
                u += (u.indexOf('?') >= 0 ? '&' : '?') + 't=' + Date.now();
                window.open(u, '_blank', 'noopener');
            }).catch(function (err) {
                if (statusEl) statusEl.textContent = '';
                showCompileError(modal.querySelector('[data-compila-survey]'), err, {
                    action: 'compile-save',
                    filename: (modal._vgCompilePreview && modal._vgCompilePreview.filename) || filename,
                    path: putPath
                });
            });
        }

        function close() {
            cleanup();
            modal._vgCompileTeardown = null;
            if (modal._vgPreviewRefreshTimer) {
                clearTimeout(modal._vgPreviewRefreshTimer);
                modal._vgPreviewRefreshTimer = null;
            }
            disposeCompileSurvey(modal);
            modal._vgAssistPrefetchGen = (modal._vgAssistPrefetchGen || 0) + 1;
            modal._vgFieldAssistInflight = {};
            modal._vgAssistPrefetchPending = null;
            modal.setAttribute('hidden', 'hidden');
            try { document.documentElement.classList.remove('vg-kanban-modal-lock'); } catch (eL2) {}
            try { modal.classList.remove('vg-kanban-compila--pdf-free'); } catch (ePf) {}
            try {
                var smClose = modal.querySelector('[data-compila-survey]');
                if (smClose) smClose.innerHTML = '';
            } catch (eS) {}
            try { if (previewEl) previewEl.innerHTML = ''; } catch (eP) {}
            modal._vgDocxTemplate = null;
            modal._vgServerTemplateHtml = '';
            modal._vgDocxAnnotated = false;
            try { if (prev && prev.focus) prev.focus(); } catch (eF) {}
        }
        function onKey(e) { if (e.key === 'Escape') close(); }
        function onBackdrop(e) { if (e.target === modal) close(); }
        function onClose() { close(); }
        function onSave(e) { e.preventDefault(); doSave(); }
        function cleanup() {
            document.removeEventListener('keydown', onKey);
            modal.removeEventListener('click', onBackdrop);
            if (previewEl) previewEl.removeEventListener('click', onPreviewDownloadClick);
            if (previewEl) previewEl.removeEventListener('click', onPreviewToolbarClick);
            if (btnClose) btnClose.removeEventListener('click', onClose);
            if (btnSave) btnSave.removeEventListener('click', onSave);
        }
        document.addEventListener('keydown', onKey);
        modal.addEventListener('click', onBackdrop);
        if (previewEl) previewEl.addEventListener('click', onPreviewDownloadClick);
        if (previewEl) previewEl.addEventListener('click', onPreviewToolbarClick);
        if (btnClose) btnClose.addEventListener('click', onClose);
        if (btnSave) btnSave.addEventListener('click', onSave);
        modal._vgCompileTeardown = cleanup;
    }

    function ensureFocusModal() {
        var existing = document.getElementById('vg-kanban-focus');
        if (existing) return existing;
        var wrap = document.createElement('div');
        wrap.id = 'vg-kanban-focus';
        wrap.className = 'vg-kanban-modal';
        wrap.setAttribute('hidden', 'hidden');
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel vg-kanban-focus__panel" role="document">' +
            '  <div class="vg-kanban-focus__windowbar" data-kanban-no-drag>' +
            '    <div class="vg-kanban-focus__windowbar-left">' +
            '      <span class="vg-kanban-focus__semaphore vg-kanban-card__semaphore vg-kanban-card__semaphore--ok" data-semaphore aria-hidden="true"></span>' +
            '    </div>' +
            '    <h2 class="vg-kanban-focus__title" data-title>Dettaglio</h2>' +
            '    <div class="vg-kanban-focus__windowbar-screenings" data-focus-screenings-wrap hidden>' +
            '      <div class="vg-kanban-focus__screening-mean-item">' +
            '        <span class="vg-kanban-focus__screening-mean-label">Preliminare</span>' +
            '        <span class="vg-kanban-screening-donut-wrap vg-kanban-screening-donut-wrap--md">' +
            '          <canvas class="vg-kanban-screening-donut" width="34" height="34" data-focus-mean-prelim aria-hidden="true"></canvas>' +
            '          <span class="vg-kanban-screening-donut__value" data-focus-mean-prelim-val aria-hidden="true"></span>' +
            '        </span>' +
            '      </div>' +
            '      <div class="vg-kanban-focus__screening-mean-item">' +
            '        <span class="vg-kanban-focus__screening-mean-label">Disciplinare</span>' +
            '        <span class="vg-kanban-screening-donut-wrap vg-kanban-screening-donut-wrap--md">' +
            '          <canvas class="vg-kanban-screening-donut" width="34" height="34" data-focus-mean-disc aria-hidden="true"></canvas>' +
            '          <span class="vg-kanban-screening-donut__value" data-focus-mean-disc-val aria-hidden="true"></span>' +
            '        </span>' +
            '      </div>' +
            '    </div>' +
            '    <div class="vg-kanban-focus__windowbar-actions">' +
            '      <button type="button" class="vg-kanban-focus__close" data-close aria-label="Chiudi">✕</button>' +
            '    </div>' +
            '  </div>' +
            '  <div class="vg-kanban-focus__body" data-body></div>' +
            '</div>';
        (document.body || document.documentElement).appendChild(wrap);
        return wrap;
    }

    function ensureUploadModal() {
        var existing = document.getElementById('vg-kanban-upload');
        if (existing) return existing;
        var wrap = document.createElement('div');
        wrap.id = 'vg-kanban-upload';
        wrap.className = 'vg-kanban-modal';
        wrap.setAttribute('hidden', 'hidden');
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel vg-kanban-upload__panel" role="document">' +
            '  <div class="vg-kanban-docbox__header">' +
            '    <h2 class="vg-kanban-docbox__title" data-title>Carica documento</h2>' +
            '    <button type="button" class="vg-kanban-docbox__close" data-close aria-label="Chiudi">Chiudi</button>' +
            '  </div>' +
            '  <div class="vg-kanban-upload__body">' +
            '    <p class="vg-kanban-upload__hint">Seleziona un file (max 50MB). Tipi consigliati: PDF, DOC/DOCX, XLS/XLSX, ZIP, immagini.</p>' +
            '    <input type="file" class="vg-kanban-upload__file" data-file />' +
            '    <div class="vg-kanban-upload__status" data-status></div>' +
            '    <div class="vg-kanban-upload__actions">' +
            '      <button type="button" class="appaltimap-btn appaltimap-btn--primary vg-kanban-upload__btn" data-upload><span aria-hidden="true">📤</span> Upload</button>' +
            '      <button type="button" class="appaltimap-btn vg-kanban-upload__btn" data-cancel><span aria-hidden="true">✖️</span> Annulla</button>' +
            '    </div>' +
            '  </div>' +
            '</div>';
        (document.body || document.documentElement).appendChild(wrap);
        return wrap;
    }

    function apiUploadFile(itemId, fileObj) {
        var url = apiBase() + '/kanban/items/' + encodeURIComponent(String(itemId)) + '/uploads';
        var fd = new FormData();
        fd.append('file', fileObj);
        return fetch(url, {
            method: 'POST',
            credentials: 'include',
            body: fd
        }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (data) {
                if (!r.ok) {
                    var d = data && data.detail ? data.detail : null;
                    var msg = typeof d === 'string' ? d : (d && d.message ? d.message : ('HTTP ' + r.status));
                    throw new Error(msg);
                }
                return data;
            });
        });
    }

    function apiRenameUpload(itemId, uploadId, filename) {
        return apiJson('/kanban/items/' + encodeURIComponent(String(itemId)) + '/uploads/' + encodeURIComponent(String(uploadId)), {
            method: 'PATCH',
            body: { filename: filename }
        });
    }

    function apiDeleteUpload(itemId, uploadId) {
        return apiJson('/kanban/items/' + encodeURIComponent(String(itemId)) + '/uploads/' + encodeURIComponent(String(uploadId)), {
            method: 'DELETE'
        });
    }

    function apiRenameDownload(itemId, fileId, filename) {
        return apiJson('/kanban/items/' + encodeURIComponent(String(itemId)) + '/downloads/' + encodeURIComponent(String(fileId)), {
            method: 'PATCH',
            body: { filename: filename }
        });
    }

    function apiDeleteDownload(itemId, fileId) {
        return apiJson('/kanban/items/' + encodeURIComponent(String(itemId)) + '/downloads/' + encodeURIComponent(String(fileId)), {
            method: 'DELETE'
        });
    }

    function openUploadModal(opts) {
        opts = opts || {};
        var itemId = parseInt(opts.itemId, 10) || 0;
        if (!itemId) return;
        var modal = ensureUploadModal();
        var titleEl = modal.querySelector('[data-title]');
        var btnClose = modal.querySelector('[data-close]');
        var btnCancel = modal.querySelector('[data-cancel]');
        var btnUpload = modal.querySelector('[data-upload]');
        var fileEl = modal.querySelector('[data-file]');
        var statusEl = modal.querySelector('[data-status]');

        if (titleEl) titleEl.textContent = opts.title || 'Carica documento';
        if (statusEl) statusEl.textContent = '';
        if (fileEl) fileEl.value = '';
        if (btnUpload) btnUpload.disabled = false;

        function setStatus(msg) { if (statusEl) statusEl.textContent = msg || ''; }

        function close() {
            cleanup();
            modal.setAttribute('hidden', 'hidden');
        }
        function onKey(e) { if (e.key === 'Escape') close(); }
        function onBackdrop(e) { if (e.target === modal) close(); }
        function onClose() { close(); }
        function onCancel() { close(); }
        function onUpload() {
            if (!fileEl || !fileEl.files || !fileEl.files[0]) {
                setStatus('Seleziona un file.');
                return;
            }
            var f = fileEl.files[0];
            if (btnUpload) btnUpload.disabled = true;
            setStatus('Upload in corso…');
            apiUploadFile(itemId, f).then(function () {
                setStatus('Upload completato.');
                try { if (opts.onDone) opts.onDone(); } catch (eD) {}
                close();
            }).catch(function (err) {
                setStatus((err && err.message) ? err.message : 'Errore upload');
                if (btnUpload) btnUpload.disabled = false;
            });
        }
        function cleanup() {
            document.removeEventListener('keydown', onKey);
            modal.removeEventListener('click', onBackdrop);
            if (btnClose) btnClose.removeEventListener('click', onClose);
            if (btnCancel) btnCancel.removeEventListener('click', onCancel);
            if (btnUpload) btnUpload.removeEventListener('click', onUpload);
        }

        modal.removeAttribute('hidden');
        document.addEventListener('keydown', onKey);
        modal.addEventListener('click', onBackdrop);
        if (btnClose) btnClose.addEventListener('click', onClose);
        if (btnCancel) btnCancel.addEventListener('click', onCancel);
        if (btnUpload) btnUpload.addEventListener('click', onUpload);
        try { if (fileEl && fileEl.focus) fileEl.focus(); } catch (eF) {}
    }

    function isFundingKanbanCard(cardEl) {
        if (!cardEl) return false;
        try {
            if (cardEl.classList && cardEl.classList.contains('vg-kanban-card--funding')) return true;
            var pid = String(cardEl.getAttribute('data-procedure-id') || '');
            return pid.indexOf('funding:') === 0;
        } catch (eFc) {
            return false;
        }
    }

    function openCardFocus(cardEl, opts) {
        opts = opts || {};
        var modal = ensureFocusModal();
        var titleEl = modal.querySelector('[data-title]');
        var bodyEl = modal.querySelector('[data-body]');
        var btnClose = modal.querySelector('[data-close]');
        var semEl = modal.querySelector('[data-semaphore]');
        var fundingFocus = isFundingKanbanCard(cardEl);
        var focusPanel = modal.querySelector('.vg-kanban-focus__panel');
        if (focusPanel) {
            focusPanel.classList.toggle('vg-kanban-focus--funding', fundingFocus);
        }
        try {
            var labPre = modal.querySelector('.vg-kanban-focus__screening-mean-item .vg-kanban-focus__screening-mean-label');
            var labItems = modal.querySelectorAll('.vg-kanban-focus__screening-mean-item .vg-kanban-focus__screening-mean-label');
            if (labItems && labItems.length >= 2) {
                labItems[0].textContent = fundingFocus ? 'Screening incentivo' : 'Preliminare';
                labItems[1].textContent = fundingFocus ? 'Analisi bando' : 'Disciplinare';
            } else if (labPre) {
                labPre.textContent = fundingFocus ? 'Screening incentivo' : 'Preliminare';
            }
        } catch (eLab) {}
        if (titleEl) titleEl.textContent = opts.title || 'Dettaglio';
        if (!bodyEl) return;

        // Copy semaphore color from the card (urgency indicator).
        if (semEl && cardEl && cardEl.querySelector) {
            try {
                var srcSem = cardEl.querySelector('.vg-kanban-card__semaphore');
                var cls = srcSem ? (srcSem.className || '') : '';
                // reset to base
                semEl.className = 'vg-kanban-focus__semaphore vg-kanban-card__semaphore';
                if (cls.indexOf('vg-kanban-card__semaphore--red') !== -1) semEl.classList.add('vg-kanban-card__semaphore--red');
                else if (cls.indexOf('vg-kanban-card__semaphore--yellow') !== -1) semEl.classList.add('vg-kanban-card__semaphore--yellow');
                else semEl.classList.add('vg-kanban-card__semaphore--ok');
            } catch (eS) {}
        }

        function fileExt(name) {
            var s = String(name || '').toLowerCase();
            var m = s.match(/\.([a-z0-9]{1,6})(?:$|\?)/i);
            return m ? m[1] : '';
        }
        function iconForFile(name, ct) {
            var ext = fileExt(name);
            var t = String(ct || '').toLowerCase();
            if (t.indexOf('application/pdf') >= 0 || ext === 'pdf') return '📕';
            if (t.indexOf('image/') === 0 || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].indexOf(ext) !== -1) return '🖼️';
            if (t.indexOf('word') !== -1 || ['doc', 'docx', 'odt', 'rtf'].indexOf(ext) !== -1) return '📝';
            if (t.indexOf('excel') !== -1 || ['xls', 'xlsx', 'ods', 'csv'].indexOf(ext) !== -1) return '📊';
            if (['zip', '7z', 'rar'].indexOf(ext) !== -1) return '🗜️';
            return '📄';
        }
        function fmtBytes(n) {
            var x = parseInt(n, 10);
            if (!x || x < 1) return '';
            if (x < 1024) return x + ' B';
            if (x < 1024 * 1024) return Math.round(x / 1024) + ' KB';
            return (Math.round((x / (1024 * 1024)) * 10) / 10) + ' MB';
        }
        function hostFromUrl(u) {
            try { return (new URL(String(u))).host; } catch (eU) { return ''; }
        }
        function splitNameExt(filename) {
            var s = String(filename || '').trim();
            if (!s) return { base: '', ext: '' };
            var lastDot = s.lastIndexOf('.');
            if (lastDot <= 0 || lastDot === s.length - 1) return { base: s, ext: '' };
            var base = s.slice(0, lastDot);
            var ext = s.slice(lastDot); // includes dot
            // Keep only short/simple ext shapes ('.pdf', '.docx', ...). Otherwise treat as no-ext.
            if (!/^\.[a-z0-9]{1,6}$/i.test(ext)) return { base: s, ext: '' };
            return { base: base, ext: ext };
        }
        function vgKanbanDocCatHtml(f) {
            var slug = (f && f.doc_category) ? String(f.doc_category) : '';
            if (!slug) return '';
            var lab = (f && f.doc_category_label) ? String(f.doc_category_label) : slug;
            var safe = slug.replace(/[^a-z0-9_]/gi, '');
            if (!safe) safe = 'altro';
            return ' <span class="vg-kanban-doc-cat vg-kanban-doc-cat--' + escapeHtml(safe) + '">' + escapeHtml(lab) + '</span>';
        }
        function isArchiveFile(f) {
            var ext = fileExt(f && f.filename ? String(f.filename) : '');
            return ['zip', '7z', 'rar'].indexOf(ext) !== -1;
        }
        function compareFilesByImportance(a, b) {
            var ia = parseInt(a.doc_importance, 10);
            var ib = parseInt(b.doc_importance, 10);
            if (isNaN(ia)) ia = 0;
            if (isNaN(ib)) ib = 0;
            if (ia !== ib) return ib - ia;
            var an = String(a.filename || '').toLowerCase();
            var bn = String(b.filename || '').toLowerCase();
            return an < bn ? -1 : an > bn ? 1 : 0;
        }
        function sortFilesForDisplay(files) {
            var list = (files || []).slice();
            list.sort(compareFilesByImportance);
            return list;
        }
        function sortConsultazioneFiles(files) {
            var nonArch = [];
            var arch = [];
            for (var i = 0; i < (files || []).length; i++) {
                var f = files[i];
                if (isArchiveFile(f)) arch.push(f);
                else nonArch.push(f);
            }
            nonArch.sort(compareFilesByFilename);
            arch.sort(compareFilesByFilename);
            return nonArch.concat(arch);
        }
        function filesHaveActions(files) {
            for (var mi = 0; mi < (files || []).length; mi++) {
                var o = String(files[mi].origin || '');
                if ((o === 'manual' && files[mi].upload_id) || ((o === 'ai' || o === 'funding') && files[mi].file_id)) return true;
            }
            return false;
        }
        function resolveDownloadHref(f2) {
            var href = f2.download_url ? String(f2.download_url) : '';
            if (href && href.indexOf('/kanban/') === 0) {
                var baseStr = '';
                try { baseStr = (typeof apiBase === 'function') ? apiBase() : String(apiBase || ''); } catch (eB) { baseStr = ''; }
                baseStr = String(baseStr || '').trim();
                if (!baseStr) baseStr = '/api';
                baseStr = baseStr.replace(/\/+$/, '');
                if (baseStr && baseStr !== '/') href = baseStr + href;
            }
            return href;
        }
        function renderFilesTableBody(ok, hasActions) {
            var html = '';
            (ok || []).forEach(function (f2) {
                var fn = f2.filename ? String(f2.filename) : 'documento';
                var nameParts = splitNameExt(fn);
                var href = resolveDownloadHref(f2);
                var bytes = fmtBytes(f2.bytes);
                var host = hostFromUrl(f2.source_url || f2.url || '');
                var ico = iconForFile(fn, f2.content_type || '');
                var isManual = String(f2.origin || '') === 'manual' && f2.upload_id;
                var isAi = String(f2.origin || '') === 'ai' && f2.file_id;
                var isFundingDoc = String(f2.origin || '') === 'funding' && f2.file_id;
                var docOrigin = isManual ? 'manual' : (isFundingDoc ? 'funding' : 'ai');
                html += '<tr>' +
                    '<td class="vg-kanban-focus__td-ico" aria-hidden="true">' + escapeHtml(ico) + '</td>' +
                    '<td class="vg-kanban-focus__td-name">' +
                    (href
                        ? (
                            '<button type="button" class="vg-kanban-focus__filelink" ' +
                            'data-kanban-doc-open data-doc-url="' + escapeHtml(href) + '" data-doc-filename="' + escapeHtml(fn) + '" data-doc-ct="' + escapeHtml(String(f2.content_type || '')) + '" data-kanban-no-drag>' +
                            '<span data-doc-base>' + escapeHtml(nameParts.base || fn) + '</span>' +
                            (nameParts.ext ? ('<span data-doc-ext>' + escapeHtml(nameParts.ext) + '</span>') : '') +
                            '</button>' +
                            vgKanbanDocCatHtml(f2) + docBadgesHtml(f2, state) +
                            (canShowCompilaButton(f2, state) ? (' <button type="button" class="appaltimap-btn appaltimap-btn--small vg-kanban-focus__compila-btn" data-kanban-compila data-kanban-no-drag data-item-id="' + escapeHtml(String(itemId)) + '" data-origin="' + escapeHtml(docOrigin) + '"' + (isManual ? (' data-upload-id="' + escapeHtml(String(f2.upload_id)) + '"') : (' data-file-id="' + escapeHtml(String(f2.file_id)) + '"')) + ' data-filename="' + escapeHtml(fn) + '" data-doc-ct="' + escapeHtml(String(f2.content_type || '')) + '"><span aria-hidden="true">📋</span> Compila</button>') : '') +
                            '<span class="vg-kanban-focus__rename" data-rename-wrap aria-hidden="true">' +
                            '<input type="text" class="vg-kanban-focus__rename-input" data-rename-input value="' + escapeHtml(nameParts.base || fn) + '" />' +
                            (nameParts.ext ? ('<span class="vg-kanban-focus__rename-ext" data-rename-ext>' + escapeHtml(nameParts.ext) + '</span>') : '<span data-rename-ext></span>') +
                            '<button type="button" class="vg-kanban-focus__action" data-rename-save>OK</button>' +
                            '<button type="button" class="vg-kanban-focus__action" data-rename-cancel>Annulla</button>' +
                            '</span>'
                          )
                        : escapeHtml(fn)) +
                    '</td>' +
                    '<td class="vg-kanban-focus__td-bytes">' + escapeHtml(bytes || '—') + '</td>' +
                    '<td class="vg-kanban-focus__td-host">' + escapeHtml(host || '—') + '</td>' +
                    (hasActions
                        ? (
                            '<td class="vg-kanban-focus__td-actions">' +
                            (isManual
                                ? (
                                    '<button type="button" class="vg-kanban-focus__action" data-doc-rename data-origin="manual" data-upload-id="' + escapeHtml(String(f2.upload_id)) + '" data-filename="' + escapeHtml(fn) + '">Rinomina</button>' +
                                    '<button type="button" class="vg-kanban-focus__action vg-kanban-focus__action--danger" data-doc-delete data-origin="manual" data-upload-id="' + escapeHtml(String(f2.upload_id)) + '">Rimuovi</button>'
                                  )
                                : isAi
                                    ? (
                                        '<button type="button" class="vg-kanban-focus__action" data-doc-rename data-origin="ai" data-file-id="' + escapeHtml(String(f2.file_id)) + '" data-filename="' + escapeHtml(fn) + '">Rinomina</button>' +
                                        '<button type="button" class="vg-kanban-focus__action vg-kanban-focus__action--danger" data-doc-delete data-origin="ai" data-file-id="' + escapeHtml(String(f2.file_id)) + '">Rimuovi</button>'
                                      )
                                    : '—') +
                            '</td>'
                          )
                        : '') +
                    '</tr>';
            });
            return html;
        }
        function renderFilesTableShell(ok, hasActions, ariaLabel) {
            if (!ok || !ok.length) return '';
            var html = '<div class="vg-kanban-focus__table-wrap">';
            html += '<table class="vg-kanban-focus__table" role="table" aria-label="' + escapeHtml(ariaLabel || 'Documenti scaricati') + '">';
            html += '<thead><tr>' +
                '<th style="width:44px" aria-label="Tipo"></th>' +
                '<th>Nome file</th>' +
                '<th style="width:120px">Dimensione</th>' +
                '<th style="width:210px">Sorgente</th>' +
                (hasActions ? '<th style="width:180px">Azioni</th>' : '') +
                '</tr></thead><tbody>';
            html += renderFilesTableBody(ok, hasActions);
            html += '</tbody></table></div>';
            return html;
        }
        function renderFailedDownloads(bad) {
            if (!bad || !bad.length) return '';
            var html = '<details class="vg-kanban-focus__failed"><summary>Tentativi falliti (' + bad.length + ')</summary>';
            html += '<ul class="vg-kanban-card__docs-list">';
            bad.forEach(function (f3) {
                var u = f3 && (f3.source_url || f3.url) ? String(f3.source_url || f3.url) : '';
                var host2 = hostFromUrl(u);
                var err = f3 && (f3.error || f3.detail) ? String(f3.error || f3.detail) : 'errore';
                html += '<li class="vg-kanban-card__docs-item">' +
                    (u ? ('<a href="' + escapeHtml(u) + '" target="_blank" rel="noopener" data-kanban-no-drag>' + escapeHtml(host2 || u) + '</a>') : 'URL') +
                    '<div class="vg-kanban-card__docs-meta">' + escapeHtml(err) + '</div>' +
                    '</li>';
            });
            html += '</ul></details>';
            return html;
        }
        function fileHasCampiDaCompilareCount(f) {
            var n = parseInt(f && f.campi_da_compilare, 10);
            return !isNaN(n) && n > 0;
        }
        function isCompileUiExtension(f) {
            var fn = String(f && f.filename || '').toLowerCase();
            return /\.(docx|pdf|xlsx)$/.test(fn);
        }
        function fileGoesInCompilazione(f) {
            if (!f || isHiddenKanbanDownloadFile(f)) return false;
            return !!f.da_compilare && isCompileUiExtension(f);
        }
        function fileIsInCompileProgress(f) {
            if (!fileGoesInCompilazione(f)) return false;
            if (f.working_copy_file_id || f.working_copy_upload_id) return true;
            if (f.compile_progress) {
                var pf = parseInt(f.compile_progress.filled, 10);
                if (!isNaN(pf) && pf > 0) return true;
            }
            return false;
        }
        function compileExtSortOrder(f) {
            var fn = String(f && f.filename || '').toLowerCase();
            if (fn.endsWith('.docx')) return 0;
            if (/\.xlsx$/.test(fn)) return 1;
            if (fn.endsWith('.pdf')) return 2;
            return 3;
        }
        function sortCompileExtensionGroup(files) {
            files.sort(function (a, b) {
                var oa = compileExtSortOrder(a);
                var ob = compileExtSortOrder(b);
                if (oa !== ob) return oa - ob;
                return compareFilesByFilename(a, b);
            });
            return files;
        }
        function countModuliCompileDrafts(files) {
            var n = 0;
            for (var i = 0; i < (files || []).length; i++) {
                var f = files[i];
                if (!f || isHiddenKanbanDownloadFile(f)) continue;
                if (f.working_copy_file_id || f.working_copy_upload_id) {
                    n += 1;
                }
            }
            return n;
        }
        var lastFocusDownloadFiles = [];
        function partitionCompilazioneFiles(files) {
            var inProgress = [];
            var daCompilare = [];
            for (var i = 0; i < (files || []).length; i++) {
                var f = files[i];
                if (!fileGoesInCompilazione(f)) continue;
                if (fileIsInCompileProgress(f)) inProgress.push(f);
                else daCompilare.push(f);
            }
            return {
                inProgress: sortCompileExtensionGroup(inProgress),
                daCompilare: sortCompileExtensionGroup(daCompilare)
            };
        }
        function renderFilesTable(files) {
            var ok = filterKanbanDownloadFiles(files);
            var bad = [];
            for (var i = 0; i < (files || []).length; i++) {
                var f = files[i] || {};
                if (!f || isHiddenKanbanDownloadFile(f)) continue;
                if (!f.stored_relpath) bad.push(f);
            }
            ok = sortFilesForDisplay(ok);
            var hasActions = filesHaveActions(ok);
            var html = '';
            if (ok.length) {
                html += '<div class="vg-kanban-focus__section-title">Documenti</div>';
                if (state === 'decision') {
                    var compilazione = [];
                    var consultazione = [];
                    for (var ci = 0; ci < ok.length; ci++) {
                        if (fileGoesInCompilazione(ok[ci])) compilazione.push(ok[ci]);
                        else consultazione.push(ok[ci]);
                    }
                    var parts = partitionCompilazioneFiles(compilazione);
                    consultazione = sortConsultazioneFiles(consultazione);
                    if (parts.inProgress.length) {
                        html += '<details class="vg-kanban-focus__docs-group" open>' +
                            '<summary>In compilazione (' + parts.inProgress.length + ')</summary>' +
                            renderFilesTableShell(parts.inProgress, hasActions, 'Documenti in compilazione') +
                            '</details>';
                    }
                    if (parts.daCompilare.length) {
                        html += '<details class="vg-kanban-focus__docs-group" open>' +
                            '<summary>Da compilare (' + parts.daCompilare.length + ')</summary>' +
                            renderFilesTableShell(parts.daCompilare, hasActions, 'Documenti da compilare') +
                            '</details>';
                    }
                    if (consultazione.length) {
                        html += '<details class="vg-kanban-focus__docs-group" open>' +
                            '<summary>Consultazione (' + consultazione.length + ')</summary>' +
                            renderFilesTableShell(consultazione, hasActions, 'Documenti di consultazione') +
                            '</details>';
                    }
                } else {
                    html += renderFilesTableShell(ok, hasActions, 'Documenti scaricati');
                }
            } else {
                html += '<div class="vg-kanban-card__docs-empty">Nessun documento disponibile.</div>';
            }
            html += renderFailedDownloads(bad);
            return html;
        }
        var itemId = 0;
        var state = '';
        try { itemId = parseInt(cardEl.getAttribute('data-item-id') || '0', 10) || 0; } catch (eId) { itemId = 0; }
        try { state = String(cardEl.getAttribute('data-state') || ''); } catch (eSt) { state = ''; }
        var canRetryAi = state === 'ai_ready' || state === 'ai_failed';
        var canRefreshModuli = state === 'decision';

        bodyEl.innerHTML =
            '<div class="vg-kanban-focus__toolbar" role="toolbar" aria-label="Azioni">' +
            '<div class="vg-kanban-focus__toolbar-left">' +
            '<button type="button" class="appaltimap-btn vg-kanban-focus__toolbar-btn" data-focus-upload title="Carica documento" aria-label="Carica documento">' +
            '<span class="vg-kanban-focus__btn-ico" aria-hidden="true">📤</span>' +
            '<span class="vg-kanban-focus__btn-text">Upload</span>' +
            '</button>' +
            (canRetryAi
                ? ('<button type="button" class="appaltimap-btn appaltimap-btn--primary vg-kanban-focus__toolbar-btn" data-focus-retry title="Rilancia AI" aria-label="Rilancia AI">' +
                   '<span class="vg-kanban-focus__btn-ico" aria-hidden="true">🤖</span>' +
                   '<span class="vg-kanban-focus__btn-text">Rilancia AI</span>' +
                   '</button>')
                : '') +
            (canRefreshModuli
                ? ('<button type="button" class="appaltimap-btn vg-kanban-focus__toolbar-btn" data-focus-moduli-refresh title="Aggiorna moduli" aria-label="Aggiorna moduli">' +
                   '<span class="vg-kanban-focus__btn-ico" aria-hidden="true">🔄</span>' +
                   '<span class="vg-kanban-focus__btn-text">Aggiorna moduli</span>' +
                   '</button>')
                : '') +
            '</div>' +
            '<div class="vg-kanban-focus__toolbar-right">' +
            '<button type="button" class="appaltimap-btn vg-kanban-focus__toolbar-btn" data-focus-download-all hidden title="Scarica tutti i documenti" aria-label="Scarica tutti i documenti">' +
            '<span class="vg-kanban-focus__btn-ico" aria-hidden="true">📥</span>' +
            '<span class="vg-kanban-focus__btn-text">Scarica tutti</span>' +
            '</button>' +
            '</div>' +
            '</div>' +
            '<div class="vg-kanban-focus__grid">' +
            '  <div class="vg-kanban-focus__card">' +
            '    <div class="vg-kanban-focus__section-title">Dettagli</div>' +
            '    <div class="vg-kanban-focus__details" data-focus-details>Caricamento…</div>' +
            '    <div data-focus-screening></div>' +
            '  </div>' +
            '  <div class="vg-kanban-focus__card">' +
            '    <div data-focus-docs>Caricamento documenti…</div>' +
            '  </div>' +
            '</div>';

        // Load downloads fresh (more reliable than scraping DOM).
        function refreshFocusDocs() {
            if (!itemId) return;
            apiJson('/kanban/items/' + encodeURIComponent(itemId) + '/downloads').then(function (res) {
                var files = (res && res.files) ? res.files : [];
                lastFocusDownloadFiles = files;
                var docsEl = bodyEl.querySelector('[data-focus-docs]');
                var dlAllBtn = bodyEl.querySelector('[data-focus-download-all]');
                var nDl = countFocusDownloadableFiles(files);
                if (dlAllBtn) {
                    if (nDl > 0) {
                        dlAllBtn.removeAttribute('hidden');
                        var dlTxt = dlAllBtn.querySelector('.vg-kanban-focus__btn-text');
                        if (dlTxt) dlTxt.textContent = 'Scarica tutti (' + nDl + ')';
                    } else {
                        dlAllBtn.setAttribute('hidden', 'hidden');
                    }
                }
                if (docsEl) {
                    docsEl.innerHTML = renderFilesTable(files);
                    // Ensure rename UI is hidden until user explicitly enters edit mode.
                    try {
                        var wraps = docsEl.querySelectorAll('[data-rename-wrap]');
                        for (var wi = 0; wi < wraps.length; wi++) {
                            var w = wraps[wi];
                            if (!w) continue;
                            w.style.display = 'none';
                            w.setAttribute('aria-hidden', 'true');
                        }
                        var links = docsEl.querySelectorAll('[data-kanban-doc-open]');
                        for (var li = 0; li < links.length; li++) {
                            var b = links[li];
                            if (!b) continue;
                            b.style.display = '';
                        }
                    } catch (eR0) {}
                }
            }).catch(function () {
                var docsEl2 = bodyEl.querySelector('[data-focus-docs]');
                if (docsEl2) docsEl2.innerHTML = '<div class="vg-kanban-card__docs-empty">Errore caricamento documenti.</div>';
            });
        }
        _vgFocusRefreshDocsCb = refreshFocusDocs;
        if (itemId) {
            refreshFocusDocs();
        } else {
            var docsEl0 = bodyEl.querySelector('[data-focus-docs]');
            if (docsEl0) docsEl0.innerHTML = '<div class="vg-kanban-card__docs-empty">ID scheda non disponibile.</div>';
        }

        // Build details. For manual procedures fetch the full row from the API and render
        // every form field read-only. For TED procedures keep the legacy DOM-copy rendering.
        var procIdAttr = '';
        try { procIdAttr = String(cardEl.getAttribute('data-procedure-id') || ''); } catch (ePid) { procIdAttr = ''; }
        var isManualCard = procIdAttr.indexOf('manual:') === 0;
        var isFundingCard = procIdAttr.indexOf('funding:') === 0;

        function renderLegacyDetailsFromCardDom() {
            try {
                var meta = cardEl && cardEl.querySelector ? cardEl.querySelector('.vg-kanban-card__meta') : null;
                var notice = cardEl && cardEl.querySelector ? cardEl.querySelector('.vg-kanban-card__notice-title') : null;
                var detEl = bodyEl.querySelector('[data-focus-details]');
                if (!detEl) return;
                var parts = '';
                if (notice && (notice.textContent || '').trim()) {
                    parts += '<div class="vg-kanban-focus__detail-row"><span class="vg-kanban-focus__k">Titolo</span><span class="vg-kanban-focus__v">' + escapeHtml((notice.textContent || '').trim()) + '</span></div>';
                }
                if (meta) {
                    var metaHtml = String(meta.innerHTML || '');
                    metaHtml = metaHtml.replace(/<div class="vg-kanban-card__docs-wrap">[\s\S]*?<\/div>\s*$/i, '');
                    metaHtml = metaHtml.replace(/<details class="vg-kanban-card__docs-failed">[\s\S]*?<\/details>\s*$/i, '');
                    metaHtml = metaHtml.trim();
                    if (metaHtml) {
                        parts += '<div class="vg-kanban-focus__detail-row"><span class="vg-kanban-focus__k">Meta</span><span class="vg-kanban-focus__v">' + metaHtml + '</span></div>';
                    }
                }
                detEl.innerHTML = parts || '—';
            } catch (eDLegacy) {}
        }

        if (isFundingCard) {
            (function () {
                var detEl = bodyEl.querySelector('[data-focus-details]');
                if (detEl) detEl.innerHTML = '<div class="vg-kanban-focus__detail-loading">Caricamento dettagli…</div>';
                fetchFundingCallDetail(procIdAttr).then(function (fc) {
                    var detEl2 = bodyEl.querySelector('[data-focus-details]');
                    if (!detEl2) return;
                    detEl2.innerHTML = buildFundingDetailsHtml(fc) || '—';
                }).catch(function () {
                    renderLegacyDetailsFromCardDom();
                });
            })();
        } else if (isManualCard) {
            (function () {
                var detEl = bodyEl.querySelector('[data-focus-details]');
                if (detEl) detEl.innerHTML = '<div class="vg-kanban-focus__detail-loading">Caricamento dettagli…</div>';
                fetchManualProcedureDetail(procIdAttr).then(function (mp) {
                    return Promise.resolve(mp && mp.cpv ? resolveCpvLabel(mp.cpv) : '').then(function (cpvLabel) {
                        return { mp: mp, cpvLabel: cpvLabel || '' };
                    });
                }).then(function (out) {
                    var detEl2 = bodyEl.querySelector('[data-focus-details]');
                    if (!detEl2) return;
                    var html = buildManualProcedureDetailsHtml(out.mp, out.cpvLabel);
                    detEl2.innerHTML = html || '—';
                }).catch(function (err) {
                    // Auth issues or 404: fallback to legacy rendering so the modal isn't empty.
                    if (err && (err.status === 401 || err.status === 403)) {
                        renderLegacyDetailsFromCardDom();
                        return;
                    }
                    if (err && err.status === 404) {
                        var detEl3 = bodyEl.querySelector('[data-focus-details]');
                        if (detEl3) detEl3.innerHTML = '<div class="vg-kanban-focus__detail-empty">Dati gara non più disponibili.</div>';
                        return;
                    }
                    renderLegacyDetailsFromCardDom();
                });
            })();
        } else {
            renderLegacyDetailsFromCardDom();
        }

        function hydrateFocusScreeningFromServer() {
            try {
                var wrap = modal.querySelector('[data-focus-screenings-wrap]');
                var cvsP = modal.querySelector('[data-focus-mean-prelim]');
                var cvsD = modal.querySelector('[data-focus-mean-disc]');
                var host = bodyEl.querySelector('[data-focus-screening]');
                if (!itemId || !host) return;

                apiJson('/kanban/items/' + encodeURIComponent(itemId)).then(function (res) {
                    var it = (res && res.item) ? res.item : null;
                    if (!it) return;
                    var ps = it.ai_result ? it.ai_result.preliminary_screening : null;
                    var df = it.ai_result ? it.ai_result.disciplinare_fit : null;
                    var mean = screeningMeanFromItem(it);
                    var discMean = null;
                    try {
                        if (df && typeof df.mean === 'number' && isFinite(df.mean)) discMean = df.mean;
                    } catch (eDm) { discMean = null; }

                    if (wrap && cvsP && cvsD) {
                        var hasPrelimRows = ps && Array.isArray(ps.requirements) && ps.requirements.length > 0;
                        var hasDiscRows = df && Array.isArray(df.requirements) && df.requirements.length > 0;
                        var showBar = (mean !== null && mean !== undefined) ||
                            (discMean !== null && discMean !== undefined) ||
                            hasPrelimRows ||
                            hasDiscRows;
                        if (showBar) {
                            wrap.removeAttribute('hidden');
                            if (mean !== null && mean !== undefined) {
                                cvsP.setAttribute('data-score', String(mean));
                                cvsP.setAttribute('aria-label', 'Screening preliminare: media ' + String(mean) + ' su 100');
                                cvsP.removeAttribute('aria-hidden');
                                renderScreeningDonut(cvsP, mean, { cutout: '74%' });
                            } else {
                                try { destroyChartOnCanvas(cvsP); } catch (eP0) {}
                                cvsP.setAttribute('aria-label', 'Screening preliminare: non disponibile');
                                cvsP.setAttribute('data-score', '0');
                            }
                            if (discMean !== null && discMean !== undefined) {
                                cvsD.setAttribute('data-score', String(discMean));
                                cvsD.setAttribute('aria-label', 'Analisi disciplinare: media ' + String(discMean) + ' su 100');
                                cvsD.removeAttribute('aria-hidden');
                                renderScreeningDonut(cvsD, discMean, { cutout: '74%' });
                            } else {
                                try { destroyChartOnCanvas(cvsD); } catch (eD0) {}
                                cvsD.setAttribute('aria-label', 'Analisi disciplinare: non disponibile');
                                cvsD.setAttribute('data-score', '0');
                            }
                        } else {
                            wrap.setAttribute('hidden', 'hidden');
                            try { destroyChartOnCanvas(cvsP); } catch (eP1) {}
                            try { destroyChartOnCanvas(cvsD); } catch (eD1) {}
                        }
                    }

                    var html = '';
                    try {
                        if (String(it.state || '') === 'ai_failed') {
                            html += renderAiFailedBlock(it);
                        }
                    } catch (eAF) {}
                    html += renderScreeningFocusHtml(ps, df, fundingFocus) || '';
                    host.innerHTML = html || '';
                    mountScreeningDonutsIn(host);
                }).catch(function () {
                    if (wrap) wrap.setAttribute('hidden', 'hidden');
                    if (host) host.innerHTML = '';
                });
            } catch (eH) {}
        }
        hydrateFocusScreeningFromServer();

        // Wire retry button (in focus toolbar).
        try {
            var retryBtn = bodyEl.querySelector('[data-focus-retry]');
            if (retryBtn) {
                retryBtn.addEventListener('click', function (eR) {
                    eR.preventDefault();
                    if (!itemId) return;
                    retryBtn.disabled = true;
                    apiJson('/kanban/items/' + encodeURIComponent(itemId), {
                        method: 'PATCH',
                        body: { state: 'ai_queued' }
                    }).then(function () {
                        // Close + refresh board.
                        try { modal.setAttribute('hidden', 'hidden'); } catch (eH) {}
                        refresh().catch(function () {});
                    }).catch(function () {
                        retryBtn.disabled = false;
                    });
                });
            }
        } catch (eR2) {}

        // Wire moduli refresh button (focus toolbar, Decisione).
        try {
            var moduliBtn = bodyEl.querySelector('[data-focus-moduli-refresh]');
            if (moduliBtn) {
                moduliBtn.addEventListener('click', function (eM) {
                    eM.preventDefault();
                    if (!itemId) return;
                    function proceedModuliRefresh() {
                        moduliBtn.disabled = true;
                        var txtEl = moduliBtn.querySelector('.vg-kanban-focus__btn-text');
                        var prevTxt = txtEl ? txtEl.textContent : '';
                        if (txtEl) txtEl.textContent = 'Aggiornamento…';
                        apiJson('/kanban/items/' + encodeURIComponent(itemId) + '/moduli-scan', {
                            method: 'POST'
                        }).then(function () {
                            refreshFocusDocs();
                            moduliBtn.disabled = false;
                            if (txtEl) txtEl.textContent = prevTxt || 'Aggiorna moduli';
                            return refresh();
                        }).catch(function () {
                            moduliBtn.disabled = false;
                            if (txtEl) txtEl.textContent = prevTxt || 'Aggiorna moduli';
                        });
                    }
                    var draftN = countModuliCompileDrafts(lastFocusDownloadFiles);
                    if (draftN > 0) {
                        var msg = draftN === 1
                            ? 'C\'è 1 modulo con compilazione in corso (bozza salvata o copia di lavoro). ' +
                              'Aggiornando i moduli la bozza verrà eliminata e dovrai ricompilare da zero. Continuare?'
                            : ('Ci sono ' + draftN + ' moduli con compilazione in corso (bozze o copie di lavoro). ' +
                              'Aggiornando i moduli tutte le bozze verranno eliminate e dovrai ricompilare da zero. Continuare?');
                        openConfirmModal({
                            title: 'Aggiorna moduli',
                            message: msg,
                            cancelText: 'Annulla',
                            confirmText: 'Continua',
                            danger: true
                        }).then(function (ok) {
                            if (!ok) return;
                            proceedModuliRefresh();
                        });
                        return;
                    }
                    proceedModuliRefresh();
                });
            }
        } catch (eM2) {}

        // Wire upload button (focus toolbar).
        try {
            var upBtn = bodyEl.querySelector('[data-focus-upload]');
            if (upBtn) {
                upBtn.addEventListener('click', function (eU) {
                    eU.preventDefault();
                    openUploadModal({
                        itemId: itemId,
                        title: 'Carica documento',
                        onDone: function () {
                            refreshFocusDocs();
                            refresh().catch(function () {});
                        }
                    });
                });
            }
        } catch (eU2) {}

        try {
            var dlAllBtnWire = bodyEl.querySelector('[data-focus-download-all]');
            if (dlAllBtnWire) {
                dlAllBtnWire.addEventListener('click', function (eDl) {
                    eDl.preventDefault();
                    if (!itemId) return;
                    downloadKanbanBundleZip(itemId, { buttonEl: dlAllBtnWire }).catch(function (err) {
                        window.VistaGareUi.alert(err && err.message ? err.message : 'Download non riuscito');
                    });
                });
            }
        } catch (eDl2) {}

        // Wire actions on manual uploads (rename/delete) inside table.
        try {
            bodyEl.addEventListener('click', function (ev) {
                function findRow(el) {
                    return el && el.closest ? el.closest('tr') : null;
                }
                function setEditing(row, on) {
                    if (!row) return;
                    var btn = row.querySelector && row.querySelector('[data-kanban-doc-open]');
                    var wrap = row.querySelector && row.querySelector('[data-rename-wrap]');
                    // Avoid relying on the `hidden` attribute alone: some global button styles can override UA hiding.
                    if (btn) btn.style.display = on ? 'none' : '';
                    if (wrap) {
                        wrap.style.display = on ? 'inline-flex' : 'none';
                        wrap.setAttribute('aria-hidden', on ? 'false' : 'true');
                    }
                    if (on) {
                        var inp = row.querySelector && row.querySelector('[data-rename-input]');
                        try { if (inp && inp.focus) { inp.focus(); inp.select && inp.select(); } } catch (eF) {}
                    }
                }
                function currentPartsFromRow(row) {
                    var fn = '';
                    try { fn = String(row.getAttribute('data-filename') || ''); } catch (eN) { fn = ''; }
                    if (!fn) {
                        // fallback to link dataset
                        try {
                            var b = row.querySelector('[data-kanban-doc-open]');
                            fn = b ? String(b.getAttribute('data-doc-filename') || '') : '';
                        } catch (eN2) { fn = ''; }
                    }
                    return splitNameExt(fn);
                }

                var btnRen = ev.target && ev.target.closest ? ev.target.closest('[data-doc-rename]') : null;
                if (btnRen) {
                    ev.preventDefault();
                    var row = findRow(btnRen);
                    if (row) {
                        // store metadata for save
                        row.setAttribute('data-origin', String(btnRen.getAttribute('data-origin') || ''));
                        row.setAttribute('data-upload-id', String(btnRen.getAttribute('data-upload-id') || ''));
                        row.setAttribute('data-file-id', String(btnRen.getAttribute('data-file-id') || ''));
                        row.setAttribute('data-filename', String(btnRen.getAttribute('data-filename') || ''));
                        var parts = currentPartsFromRow(row);
                        var inp = row.querySelector && row.querySelector('[data-rename-input]');
                        var extEl = row.querySelector && row.querySelector('[data-rename-ext]');
                        if (inp) inp.value = parts.base || '';
                        if (extEl) extEl.textContent = parts.ext || '';
                        setEditing(row, true);
                    }
                    return;
                }

                var btnSave = ev.target && ev.target.closest ? ev.target.closest('[data-rename-save]') : null;
                if (btnSave) {
                    ev.preventDefault();
                    var rowS = findRow(btnSave);
                    if (!rowS) return;
                    var originS = String(rowS.getAttribute('data-origin') || '').trim();
                    var uploadIdS = String(rowS.getAttribute('data-upload-id') || '').trim();
                    var fileIdS = String(rowS.getAttribute('data-file-id') || '').trim();
                    var inpS = rowS.querySelector && rowS.querySelector('[data-rename-input]');
                    var extS = '';
                    try { extS = String((rowS.querySelector('[data-rename-ext]') || {}).textContent || '').trim(); } catch (eE) { extS = ''; }
                    var baseS = inpS ? String(inpS.value || '').trim() : '';
                    if (!baseS) return;
                    // Enforce: extension not editable (server also enforces).
                    var composed = baseS.replace(/\.[a-z0-9]{1,6}$/i, '') + (extS || '');
                    // Disable buttons during save
                    try { btnSave.disabled = true; } catch (eD) {}
                    if (originS === 'manual') {
                        apiRenameUpload(itemId, uploadIdS, composed).then(function () {
                            refreshFocusDocs();
                            refresh().catch(function () {});
                        }).catch(function (errS) {
                            window.VistaGareUi.alert((errS && errS.message) ? errS.message : 'Errore rinomina');
                        }).finally(function () {
                            try { btnSave.disabled = false; } catch (eD2) {}
                            setEditing(rowS, false);
                        });
                        return;
                    }
                    if (originS === 'ai') {
                        apiRenameDownload(itemId, fileIdS, composed).then(function () {
                            refreshFocusDocs();
                            refresh().catch(function () {});
                        }).catch(function (errSA) {
                            window.VistaGareUi.alert((errSA && errSA.message) ? errSA.message : 'Errore rinomina');
                        }).finally(function () {
                            try { btnSave.disabled = false; } catch (eD3) {}
                            setEditing(rowS, false);
                        });
                        return;
                    }
                    try { btnSave.disabled = false; } catch (eD4) {}
                    setEditing(rowS, false);
                    return;
                }

                var btnCancel = ev.target && ev.target.closest ? ev.target.closest('[data-rename-cancel]') : null;
                if (btnCancel) {
                    ev.preventDefault();
                    var rowC = findRow(btnCancel);
                    setEditing(rowC, false);
                    return;
                }

                var btnDel = ev.target && ev.target.closest ? ev.target.closest('[data-doc-delete]') : null;
                if (btnDel) {
                    ev.preventDefault();
                    var origin2 = String(btnDel.getAttribute('data-origin') || '').trim();
                    openConfirmModal({
                        title: 'Rimuovere documento?',
                        message: 'Rimuovere questo documento?',
                        cancelText: 'Annulla',
                        confirmText: 'Rimuovi',
                        danger: true
                    }).then(function (ok) {
                        if (!ok) return;
                        if (origin2 === 'manual') {
                            var uploadId2 = btnDel.getAttribute('data-upload-id') || '';
                            apiDeleteUpload(itemId, uploadId2).then(function () {
                                refreshFocusDocs();
                                refresh().catch(function () {});
                            }).catch(function (err2) {
                                window.VistaGareUi.alert((err2 && err2.message) ? err2.message : 'Errore rimozione');
                            });
                            return;
                        }
                        if (origin2 === 'ai') {
                            var fileId2 = btnDel.getAttribute('data-file-id') || '';
                            apiDeleteDownload(itemId, fileId2).then(function () {
                                refreshFocusDocs();
                                refresh().catch(function () {});
                            }).catch(function (errA2) {
                                window.VistaGareUi.alert((errA2 && errA2.message) ? errA2.message : 'Errore rimozione');
                            });
                        }
                    });
                    return;
                }
            });
        } catch (eA) {}

        modal.removeAttribute('hidden');
        var prev = document.activeElement;
        try { if (btnClose && btnClose.focus) btnClose.focus(); } catch (e2) {}

        function close() {
            cleanup();
            if (_vgFocusRefreshDocsCb === refreshFocusDocs) _vgFocusRefreshDocsCb = null;
            modal.setAttribute('hidden', 'hidden');
            try { if (bodyEl) bodyEl.innerHTML = ''; } catch (e3) {}
            try { if (prev && prev.focus) prev.focus(); } catch (e4) {}
        }
        function onKey(e) { if (e.key === 'Escape') close(); }
        function onBackdrop(e) { if (e.target === modal) close(); }
        function onClose() { close(); }
        function cleanup() {
            document.removeEventListener('keydown', onKey);
            modal.removeEventListener('click', onBackdrop);
            if (btnClose) btnClose.removeEventListener('click', onClose);
        }
        document.addEventListener('keydown', onKey);
        modal.addEventListener('click', onBackdrop);
        if (btnClose) btnClose.addEventListener('click', onClose);
    }

    function confirmTransition(fromState, targetState) {
        if (targetState === 'archived') {
            return openConfirmModal({
                title: 'Archiviazione',
                message: 'Archiviare questa scheda?',
                confirmText: 'Archivia',
                cancelText: 'Annulla',
                danger: true
            });
        }
        if (fromState === 'to_evaluate' && targetState === 'decision') {
            return openConfirmModal({
                title: 'Salta analisi AI',
                message: 'Stai saltando l’analisi AI e passando direttamente a “' + zoneTitleIt('decision') + '”. Sei sicuro?',
                confirmText: 'Sì, continua',
                cancelText: 'No'
            });
        }
        if (fromState === 'decision' && targetState === 'ai_queued') {
            return openConfirmModal({
                title: 'Rilancia analisi AI',
                message: 'Vuoi riportare la scheda in “' + zoneTitleIt('ai') + '” e rilanciare l’elaborazione?',
                confirmText: 'Sì, rilancia',
                cancelText: 'Annulla'
            });
        }
        if (fromState === 'decision' && targetState === 'to_evaluate') {
            return openConfirmModal({
                title: 'Riporta a Da valutare',
                message: 'Vuoi riportare la scheda in “Da valutare”? L’analisi AI non verrà avviata automaticamente.',
                confirmText: 'Sì, continua',
                cancelText: 'Annulla'
            });
        }
        return Promise.resolve(true);
    }

    /** Entro 7 giorni o scaduta → rosso; entro 30 (e >7) → giallo. */
    function deadlineUrgency(iso) {
        if (!iso) return null;
        var d = new Date(iso);
        if (isNaN(d.getTime())) return null;
        var diffMs = d.getTime() - Date.now();
        if (diffMs <= 0) return 'red';
        var days = diffMs / 86400000;
        if (days <= 7) return 'red';
        if (days <= 30) return 'yellow';
        return null;
    }

    function isKanbanItemExpired(item) {
        if (!item || String(item.state || '') === 'archived') return false;
        var iso = item.notice_deadline_date ? String(item.notice_deadline_date) : '';
        if (!iso) return false;
        var d = new Date(iso);
        if (isNaN(d.getTime())) return false;
        return d.getTime() <= Date.now();
    }

    function countExpiredKanbanItems(items) {
        var n = 0;
        (items || []).forEach(function (it) {
            if (isKanbanItemExpired(it)) n += 1;
        });
        return n;
    }

    function archiveExpiredKanbanItemsPrompt() {
        var n = countExpiredKanbanItems(lastItemsSnapshot);
        if (!n) {
            return window.VistaGareUi.alert(
                'Non ci sono schede con scadenza passata da archiviare.',
                { title: 'Archivia scadute' }
            );
        }
        var msg = n === 1
            ? 'Archiviare 1 scheda con scadenza passata? Verrà spostata in Archiviate.'
            : ('Archiviare ' + n + ' schede con scadenza passata? Verranno spostate in Archiviate.');
        return openConfirmModal({
            title: 'Archivia scadute',
            message: msg,
            confirmText: n === 1 ? 'Archivia' : 'Archivia tutte',
            cancelText: 'Annulla',
            danger: true
        }).then(function (ok) {
            if (!ok) return;
            setStatus('Archiviazione schede scadute…');
            return apiJson('/kanban/items/archive-expired', { method: 'POST' }).then(function (res) {
                var cnt = res && res.archived_count != null ? Number(res.archived_count) : 0;
                if (cnt === 1) setStatus('1 scheda archiviata.');
                else if (cnt > 1) setStatus(cnt + ' schede archiviate.');
                else setStatus('Nessuna scheda archiviata.');
                return refresh();
            }).catch(function (err) {
                if (!maybeShowProfileIncompleteDialog(err)) {
                    setStatus((err && err.message) ? err.message : 'Errore archiviazione');
                }
                return refresh();
            });
        });
    }

    function fmtMoney(amount, cur) {
        if (amount == null || amount === '') return '';
        var n = Number(amount);
        if (isNaN(n)) return String(amount);
        try {
            return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: (cur && String(cur).length === 3) ? String(cur) : 'EUR',
                maximumFractionDigits: 0
            }).format(n);
        } catch (e) {
            return String(amount) + (cur ? ' ' + cur : '');
        }
    }

    function fmtDateOnlyIt(iso) {
        if (!iso) return '';
        var d = new Date(iso);
        if (isNaN(d.getTime())) return '';
        try {
            return d.toLocaleDateString('it-IT');
        } catch (e) {
            return d.toISOString().slice(0, 10);
        }
    }

    function splitCpv(raw) {
        var s = (raw == null) ? '' : String(raw).trim();
        if (!s) return { code: '', label: '' };
        // Common shapes: "45200000 — Lavori ...", "45200000 - Lavori ...", "45200000: Lavori ..."
        var m = s.match(/^\s*(\d{2,8})\s*(?:[—–-]|:)?\s*(.*)\s*$/);
        if (m) return { code: m[1] || '', label: (m[2] || '').trim() };
        return { code: '', label: s };
    }

    var cpvLabelCache = Object.create(null);
    function cpvSuggestUrl(q) {
        return apiBase() + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(q) + '&limit=1';
    }

    // Cache: full manual procedure rows (GET /kanban/manual-procedures/{id}). Avoids
    // re-fetching when the user re-opens the focus modal on the same card.
    var manualProcDetailCache = Object.create(null);
    function fetchManualProcedureDetail(procedureId) {
        var pid = String(procedureId || '').trim();
        if (!pid || pid.indexOf('manual:') !== 0) return Promise.reject(new Error('not manual'));
        if (manualProcDetailCache[pid]) return Promise.resolve(manualProcDetailCache[pid]);
        return apiJson('/kanban/manual-procedures/' + encodeURIComponent(pid)).then(function (res) {
            var item = res && res.item ? res.item : null;
            if (!item) throw new Error('empty');
            manualProcDetailCache[pid] = item;
            return item;
        });
    }

    var fundingDetailCache = Object.create(null);
    function fetchFundingCallDetail(procedureId) {
        var pid = String(procedureId || '').trim();
        if (!pid || pid.indexOf('funding:') !== 0) return Promise.reject(new Error('not funding'));
        if (fundingDetailCache[pid]) return Promise.resolve(fundingDetailCache[pid]);
        return apiJson('/funding-calls/by-procedure/' + encodeURIComponent(pid)).then(function (res) {
            var item = res && res.item ? res.item : null;
            if (!item) throw new Error('empty');
            fundingDetailCache[pid] = item;
            return item;
        });
    }

    function buildFundingDetailsHtml(fc) {
        if (!fc) return '';
        var html = '';
        html += vgManualDetailRow('Tipo', escapeHtml(String(fc.type || '—')));
        if (fc.region) html += vgManualDetailRow('Regione', escapeHtml(String(fc.region)));
        if (fc.source) html += vgManualDetailRow('Fonte', escapeHtml(String(fc.source)));
        if (fc.title) html += vgManualDetailRow('Titolo', escapeHtml(String(fc.title)));
        var dl = vgFormatIsoDateIt(fc.deadline);
        if (dl) html += vgManualDetailRow('Scadenza', escapeHtml(dl));
        if (fc.budget) html += vgManualDetailRow('Budget', escapeHtml(String(fc.budget)));
        if (fc.official_url) {
            html += vgManualDetailRow(
                'Scheda ufficiale',
                '<a href="' + escapeHtml(fc.official_url) + '" target="_blank" rel="noopener">Apri fonte</a>'
            );
        }
        if (fc.ghost_url) {
            html += vgManualDetailRow(
                'Scheda VistaGare',
                '<a href="' + escapeHtml(fc.ghost_url) + '" target="_blank" rel="noopener">Apri dettaglio</a>'
            );
        }
        if (fc.eligibility) {
            html += vgManualDetailRow('Ammissibilità', escapeHtml(String(fc.eligibility)));
        }
        return html;
    }

    function vgFormatIsoDateIt(iso) {
        try {
            if (!iso) return '';
            var s = String(iso);
            // Accept both date-only (YYYY-MM-DD) and full ISO; show as DD/MM/YYYY.
            var dt = new Date(s.indexOf('T') > 0 ? s : (s + 'T00:00:00'));
            if (isNaN(dt.getTime())) return '';
            var dd = String(dt.getDate()).padStart(2, '0');
            var mm = String(dt.getMonth() + 1).padStart(2, '0');
            var yy = String(dt.getFullYear());
            return dd + '/' + mm + '/' + yy;
        } catch (eFD) { return ''; }
    }

    function vgFormatAmount(amount, currency) {
        var n = Number(amount);
        if (!isFinite(n)) return '';
        try {
            var fmt = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 }).format(n);
            return fmt + (currency ? (' ' + String(currency)) : '');
        } catch (eFA) {
            return String(amount) + (currency ? (' ' + String(currency)) : '');
        }
    }

    function vgManualCategoryLabel(v) {
        switch (String(v || '').trim().toLowerCase()) {
            case 'works': return 'Lavori';
            case 'services': return 'Servizi';
            case 'supplies': return 'Forniture';
            default: return String(v || '').trim();
        }
    }

    function vgManualDetailRow(k, valueHtml) {
        if (valueHtml == null || valueHtml === '') return '';
        return (
            '<div class="vg-kanban-focus__detail-row">' +
            '  <span class="vg-kanban-focus__k">' + escapeHtml(k) + '</span>' +
            '  <span class="vg-kanban-focus__v">' + valueHtml + '</span>' +
            '</div>'
        );
    }

    function buildManualProcedureDetailsHtml(mp, cpvLabel) {
        if (!mp) return '';
        var html = '';
        if (mp.title) html += vgManualDetailRow('Titolo', escapeHtml(String(mp.title)));
        if (mp.buyer_name) html += vgManualDetailRow('Ente', escapeHtml(String(mp.buyer_name)));
        if (mp.cpv) {
            var code = escapeHtml(String(mp.cpv));
            var lbl = cpvLabel ? (' — ' + escapeHtml(String(cpvLabel))) : '';
            html += vgManualDetailRow('CPV', code + lbl);
        }
        if (mp.category) html += vgManualDetailRow('Categoria', escapeHtml(vgManualCategoryLabel(mp.category)));
        if (mp.procedure_type) html += vgManualDetailRow('Tipo procedura', escapeHtml(String(mp.procedure_type)));
        if (mp.award_criteria) html += vgManualDetailRow('Criterio', escapeHtml(String(mp.award_criteria)));
        var amountTxt = vgFormatAmount(mp.amount_estimated, mp.currency);
        if (amountTxt) html += vgManualDetailRow('Importo', escapeHtml(amountTxt));
        var pub = vgFormatIsoDateIt(mp.publication_date);
        if (pub) html += vgManualDetailRow('Pubblicazione', escapeHtml(pub));
        var dl = vgFormatIsoDateIt(mp.deadline_date);
        if (dl) html += vgManualDetailRow('Scadenza', escapeHtml(dl));
        if (mp.external_url) {
            var href = escapeHtml(String(mp.external_url));
            html += vgManualDetailRow(
                'Link',
                '<a href="' + href + '" target="_blank" rel="noopener">' + href + '</a>'
            );
        }
        if (mp.description) {
            html += vgManualDetailRow(
                'Descrizione',
                '<span class="vg-kanban-focus__desc">' + escapeHtml(String(mp.description)) + '</span>'
            );
        }
        return html;
    }
    function resolveCpvLabel(code) {
        var c = String(code || '').trim();
        if (!c) return Promise.resolve('');
        if (cpvLabelCache[c] != null) return Promise.resolve(cpvLabelCache[c]);
        return fetch(cpvSuggestUrl(c), { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : {}; })
            .then(function (data) {
                var it = data && data.items && data.items[0];
                var label = it && it.label_it ? String(it.label_it).trim() : '';
                cpvLabelCache[c] = label || '';
                return cpvLabelCache[c];
            })
            .catch(function () {
                cpvLabelCache[c] = '';
                return '';
            });
    }

    function hydrateCpvLabels() {
        var nodes = root.querySelectorAll('[data-cpv-code][data-cpv-label-pending="1"]');
        if (!nodes || !nodes.length) return;
        var codes = [];
        for (var i = 0; i < nodes.length; i++) {
            var c = String(nodes[i].getAttribute('data-cpv-code') || '').trim();
            if (c && codes.indexOf(c) === -1) codes.push(c);
        }
        if (!codes.length) return;
        // simple concurrency limiter
        var idx = 0;
        var running = 0;
        var limit = 6;
        function pump() {
            while (running < limit && idx < codes.length) {
                (function (code) {
                    running += 1;
                    resolveCpvLabel(code).then(function (label) {
                        if (!label) return;
                        var els = root.querySelectorAll('[data-cpv-code="' + code + '"][data-cpv-label-pending="1"]');
                        for (var ei = 0; ei < els.length; ei++) {
                            var target = els[ei].querySelector('.vg-kanban-card__cpv-label');
                            if (target) target.textContent = label;
                            els[ei].removeAttribute('data-cpv-label-pending');
                        }
                    }).finally(function () {
                        running -= 1;
                        pump();
                    });
                })(codes[idx++]);
            }
        }
        pump();
    }

    function stateLabelIt(state) {
        var s = (state == null) ? '' : String(state);
        switch (s) {
            case 'to_evaluate': return 'Da valutare';
            case 'ai_queued': return 'In coda AI';
            case 'ai_processing': return 'In lavorazione AI';
            case 'ai_ready': return 'AI pronta';
            case 'ai_failed': return 'AI fallita';
            case 'decision': return 'In preparazione';
            case 'in_progress': return 'In consegna';
            case 'archived': return 'Archiviata';
            default: return s ? s.replace(/_/g, ' ') : '—';
        }
    }

    function isCompileUiExtension(f) {
        var fn = String(f && f.filename || '').toLowerCase();
        return /\.(docx|pdf|xlsx)$/.test(fn);
    }

    function canShowCompilaButton(f, cardState) {
        if (String(cardState || '') !== 'decision') return false;
        if (!f || !f.da_compilare) return false;
        if (!isCompileUiExtension(f)) return false;
        var n = parseInt(f.campi_da_compilare, 10);
        if (isNaN(n) || n <= 1) return false;
        return true;
    }

    function docDaCompilareHtml(f, cardState) {
        if (String(cardState || '') !== 'decision') return '';
        if (!f || !f.da_compilare) return '';
        var label = 'da compilare';
        if (f.is_compile_working_copy && f.compile_progress) {
            var pf = parseInt(f.compile_progress.filled, 10);
            var pt = parseInt(f.compile_progress.total, 10);
            if (!isNaN(pf) && !isNaN(pt) && pt > 0) {
                return ' <span class="vg-kanban-doc-cat vg-kanban-doc-cat--in_compilazione">' +
                    escapeHtml('in compilazione (' + pf + '/' + pt + ')') + '</span>';
            }
        }
        var n = parseInt(f.campi_da_compilare, 10);
        if (!isNaN(n) && n > 0) label += ' (' + n + ')';
        return ' <span class="vg-kanban-doc-cat vg-kanban-doc-cat--da_compilare">' + escapeHtml(label) + '</span>';
    }

    function docProvenanceHtml(f) {
        if (!f || f.is_compile_working_copy) return '';
        var p = f.doc_provenance ? String(f.doc_provenance).toLowerCase() : 'originale';
        if (!p || (p !== 'convertito' && p !== 'originale')) return '';
        var label = p === 'convertito' ? 'convertito' : 'originale';
        return ' <span class="vg-kanban-doc-cat vg-kanban-doc-cat--' + escapeHtml(p) + '">' + escapeHtml(label) + '</span>';
    }

    function docBadgesHtml(f, cardState) {
        return docProvenanceHtml(f) + docDaCompilareHtml(f, cardState);
    }

    function missingProfileKeyLabel(k) {
        var s = String(k || '').trim();
        switch (s) {
            case 'organization_name': return 'Ragione sociale';
            case 'vat_or_tax_code': return 'Partita IVA o Codice fiscale';
            case 'cpv': return 'CPV di interesse';
            default: return s || 'Dato profilo';
        }
    }

    function aiFailedInfo(aiResult) {
        var err = aiResult && aiResult.error ? aiResult.error : null;
        var reason = err && err.reason ? String(err.reason) : '';
        if (reason === 'profile_incomplete') {
            var miss = (err && err.missing_profile_data) ? err.missing_profile_data : [];
            var parts = [];
            for (var i = 0; i < (miss || []).length; i++) parts.push(missingProfileKeyLabel(miss[i]));
            return {
                why: 'Company profile incompleto per avviare l’analisi AI.',
                fixHtml:
                    'Completa il profilo' +
                    (parts.length ? (' (mancano: ' + escapeHtml(parts.join(', ')) + ')') : '') +
                    ' e poi premi “Riprova”. ' +
                    '<a href="/company-profile/" target="_blank" rel="noopener" data-kanban-no-drag>Apri Company Profile</a>.'
            };
        }
        if (reason === 'documents_unreachable') {
            return {
                why: 'Impossibile scaricare i documenti di gara: la piattaforma sembra chiusa o richiede autenticazione.',
                fixHtml:
                    'Apri la gara su TED e prova a scaricare manualmente i documenti. ' +
                    'Se richiede login (MePA/portali regionali), non possiamo automatizzare il download. ' +
                    'Dopo aver reso disponibili i documenti, premi “Riprova”.'
            };
        }
        if (reason === 'no_documents_found') {
            return {
                why: 'Non ho trovato documenti di gara nei dati TED (XML/raw).',
                fixHtml:
                    'Verifica su TED se sono presenti allegati/documenti di gara. ' +
                    'Se i documenti sono su piattaforme esterne, potrebbero non essere linkati nell’XML.'
            };
        }
        if (reason === 'manual_documents_no_text') {
            var root = err && err.uploads_root ? String(err.uploads_root) : '';
            var ups = (err && err.uploads && Array.isArray(err.uploads)) ? err.uploads : [];
            var extra = '';
            try {
                if (root || ups.length) {
                    extra =
                        '<details style="margin-top:8px;"><summary>Dettagli tecnici</summary>' +
                        (root ? ('<div><strong>uploads_root:</strong> <code>' + escapeHtml(root) + '</code></div>') : '') +
                        (ups.length
                            ? ('<div style="margin-top:6px;"><strong>uploads:</strong>' +
                               ups.slice(0, 10).map(function (u) {
                                   var fn = (u && u.filename) ? String(u.filename) : 'file';
                                   var rel = (u && u.stored_relpath) ? String(u.stored_relpath) : '';
                                   var ex = (u && typeof u.exists_on_disk === 'boolean') ? (u.exists_on_disk ? 'ok' : 'missing') : '—';
                                   return '<div style="margin-top:4px;"><code>' + escapeHtml(fn) + '</code> <span style="opacity:.7;">(' + escapeHtml(ex) + ')</span>' +
                                       (rel ? ('<div style="opacity:.7;"><code>' + escapeHtml(rel) + '</code></div>') : '') +
                                       '</div>';
                               }).join('') +
                               '</div>')
                            : '') +
                        '</details>';
                }
            } catch (eT) { extra = ''; }
            return {
                why: 'Upload manuali presenti, ma l’AI non ha estratto testo dal documento.',
                fixHtml:
                    'Se il PDF è scansionato/immagine, serve OCR. Se invece è testuale, potrebbe esserci un mismatch dei path uploads tra API e worker.' +
                    extra
            };
        }
        // Generic: show as much as we can without being noisy.
        if (err) {
            var msg =
                err.message ? String(err.message) :
                    (err.detail ? String(err.detail) :
                        (err.reason ? String(err.reason) : ''));
            var trace = err.trace ? String(err.trace) : '';
            var extra = '';
            try {
                if (trace && trace.trim()) {
                    extra =
                        '<details style="margin-top:8px;"><summary>Trace</summary>' +
                        '<pre style="white-space:pre-wrap; max-height:240px; overflow:auto; padding:10px; border-radius:10px; border:1px solid rgba(0,0,0,0.12); background:rgba(0,0,0,0.03);">' +
                        escapeHtml(trace.slice(-8000)) +
                        '</pre></details>';
                }
            } catch (eTr) { extra = ''; }
            return {
                why: msg ? ('Errore AI: ' + msg) : 'Errore AI non specificato.',
                fixHtml: 'Risolvi la causa dell’errore e poi premi “Riprova”.' + extra
            };
        }
        return {
            why: 'Analisi AI fallita.',
            fixHtml: 'Riprova tra poco oppure verifica che i documenti siano disponibili.'
        };
    }

    function renderAiFailedBlock(item) {
        var info = aiFailedInfo(item && item.ai_result ? item.ai_result : null);
        var why = escapeHtml(info.why || 'Analisi AI fallita.');
        var fix = info.fixHtml || '';
        return (
            '<div class="vg-kanban-card__ai-failed" role="note" aria-label="Dettagli errore analisi AI">' +
            '<div class="vg-kanban-card__ai-failed-title">🔴 AI fallita</div>' +
            '<div class="vg-kanban-card__ai-failed-why">' + why + '</div>' +
            (fix ? ('<div class="vg-kanban-card__ai-failed-fix">' + fix + '</div>') : '') +
            '<div class="vg-kanban-card__ai-failed-actions">' +
            '<button type="button" class="vg-kanban-card__retry" data-kanban-no-drag data-kanban-retry>Riprova</button>' +
            '</div>' +
            '</div>'
        );
    }

    function renderAiRelaunchBlock() {
        return (
            '<div class="vg-kanban-card__ai-relaunch" role="group" aria-label="Azioni analisi AI">' +
            '<button type="button" class="vg-kanban-card__retry" data-kanban-no-drag data-kanban-retry>Rilancia AI</button>' +
            '</div>'
        );
    }

    function screeningMeanFromItem(item) {
        try {
            var ps = item && item.ai_result ? item.ai_result.preliminary_screening : null;
            if (!ps) return null;
            if (typeof ps.mean === 'number' && isFinite(ps.mean)) return ps.mean;
            var sc = ps.scores || {};
            var keys = [
                'sector_cpv',
                'geo',
                'financial_fit',
                'operational_fit',
                'tender_access',
                'complexity',
                'preliminary_participability'
            ];
            var sum = 0;
            var c = 0;
            for (var i = 0; i < keys.length; i++) {
                var v = sc[keys[i]];
                if (typeof v === 'number' && isFinite(v)) {
                    sum += v;
                    c += 1;
                }
            }
            if (!c) return null;
            return Math.round((sum / c) * 10) / 10;
        } catch (eM) {
            return null;
        }
    }

    function screeningColorForScore(score0to100) {
        var s = parseFloat(score0to100);
        if (!isFinite(s)) s = 0;
        if (s >= 75) return '#16a34a';
        if (s >= 55) return '#f59e0b';
        return '#ef4444';
    }

    function screeningPctLabel(score0to100) {
        var n = parseFloat(score0to100);
        if (!isFinite(n)) n = 0;
        if (n < 0) n = 0;
        if (n > 100) n = 100;
        var r = Math.round(n);
        if (Math.abs(n - r) < 0.05) return String(r);
        var t = (Math.round(n * 10) / 10).toFixed(1);
        if (t.slice(-2) === '.0') return t.slice(0, -2);
        return t;
    }

    function ensureScreeningDonutWrap(canvas) {
        if (!canvas || !canvas.parentNode) return null;
        var wrap = canvas.parentNode;
        if (wrap.classList && wrap.classList.contains('vg-kanban-screening-donut-wrap')) {
            var lab = wrap.querySelector('.vg-kanban-screening-donut__value');
            if (!lab) {
                lab = document.createElement('span');
                lab.className = 'vg-kanban-screening-donut__value';
                lab.setAttribute('aria-hidden', 'true');
                wrap.appendChild(lab);
            }
            return { wrap: wrap, canvas: canvas, label: lab };
        }
        wrap = document.createElement('span');
        wrap.className = 'vg-kanban-screening-donut-wrap';
        var parent = canvas.parentNode;
        parent.insertBefore(wrap, canvas);
        wrap.appendChild(canvas);
        var lab2 = document.createElement('span');
        lab2.className = 'vg-kanban-screening-donut__value';
        lab2.setAttribute('aria-hidden', 'true');
        wrap.appendChild(lab2);
        return { wrap: wrap, canvas: canvas, label: lab2 };
    }

    function destroyChartOnCanvas(canvas) {
        if (!canvas) return;
        try {
            if (canvas._vgChart && typeof canvas._vgChart.destroy === 'function') {
                canvas._vgChart.destroy();
            }
        } catch (eD) {}
        canvas._vgChart = null;
    }

    function renderScreeningDonut(canvas, score0to100, opts) {
        opts = opts || {};
        if (!canvas) return;
        destroyChartOnCanvas(canvas);
        var v = parseFloat(score0to100);
        if (!isFinite(v)) v = 0;
        if (v < 0) v = 0;
        if (v > 100) v = 100;
        var rest = Math.max(0, 100 - v);
        var color = opts.color || screeningColorForScore(v);
        var parts = ensureScreeningDonutWrap(canvas);
        if (!parts || !parts.label) return;
        parts.label.textContent = screeningPctLabel(v);

        if (typeof window.Chart !== 'undefined') {
            var ctx = parts.canvas.getContext('2d');
            if (!ctx) return;
            parts.canvas._vgChart = new window.Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: ['score', 'rest'],
                    datasets: [{
                        data: [v, rest],
                        backgroundColor: [color, 'rgba(148, 163, 184, 0.28)'],
                        borderWidth: 0,
                        hoverOffset: 0
                    }]
                },
                options: {
                    responsive: false,
                    animation: false,
                    plugins: { legend: { display: false }, tooltip: { enabled: false } },
                    cutout: opts.cutout || '72%'
                }
            });
            return;
        }

        // Minimal SVG fallback (no external deps)
        var size = parseInt(parts.canvas.getAttribute('width'), 10) || 32;
        var r = 12;
        var cx = size / 2;
        var cy = size / 2;
        var circ = 2 * Math.PI * r;
        var dash = (v / 100) * circ;
        var svg =
            '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '">' +
            '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="rgba(148,163,184,0.35)" stroke-width="5" />' +
            '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="' + escapeHtml(color) + '" stroke-width="5" ' +
            'stroke-linecap="round" stroke-dasharray="' + dash.toFixed(2) + ' ' + (circ - dash).toFixed(2) + '" ' +
            'transform="rotate(-90 ' + cx + ' ' + cy + ')" />' +
            '</svg>';
        var holder = document.createElement('span');
        holder.className = 'vg-kanban-screening-donut__svg';
        holder.innerHTML = svg;
        try {
            parts.wrap.insertBefore(holder, parts.label);
        } catch (eI) {
            parts.wrap.appendChild(holder);
        }
        try {
            parts.wrap.removeChild(parts.canvas);
        } catch (eR) {}
    }

    function screeningStatusBadgeClass(st) {
        var s = String(st || '').toLowerCase();
        if (s === 'ok') return 'vg-kanban-screening__badge vg-kanban-screening__badge--ok';
        if (s === 'partial') return 'vg-kanban-screening__badge vg-kanban-screening__badge--partial';
        if (s === 'missing') return 'vg-kanban-screening__badge vg-kanban-screening__badge--missing';
        return 'vg-kanban-screening__badge vg-kanban-screening__badge--unknown';
    }

    function renderScreeningFocusHtml(ps, df, isFunding) {
        return (renderPreliminaryScreeningFocusHtml(ps, isFunding) || '') + (renderDisciplinareFocusHtml(df, isFunding) || '');
    }

    function renderPreliminaryScreeningFocusHtml(ps, isFunding) {
        if (!ps || !ps.scores) return '';
        var funding = isFunding || ps.kind === 'funding';
        var sectionTitle = funding ? 'Screening incentivo' : 'Screening preliminare';
        var reqs = Array.isArray(ps.requirements) ? ps.requirements : [];
        var rows = '';
        for (var i = 0; i < reqs.length; i++) {
            var r = reqs[i] || {};
            var title = escapeHtml(r.title || r.key || 'Voce');
            var st = escapeHtml(r.company_status || 'unknown');
            var note = escapeHtml(r.note || '');
            var score = (typeof r.score === 'number' && isFinite(r.score)) ? r.score : 0;
            rows +=
                '<tr>' +
                '<td class="vg-kanban-screening__td-donut">' +
                '<span class="vg-kanban-screening-donut-wrap vg-kanban-screening-donut-wrap--md">' +
                '<canvas class="vg-kanban-screening-donut" width="34" height="34" data-screening-mini="' + escapeHtml(String(r.key || '')) + '" ' +
                'data-score="' + escapeHtml(String(score)) + '" ' +
                'role="img" aria-label="Indice ' + title + ': ' + String(score) + ' su 100"></canvas>' +
                '<span class="vg-kanban-screening-donut__value" aria-hidden="true"></span>' +
                '</span>' +
                '</td>' +
                '<td class="vg-kanban-screening__td-title">' + title + '</td>' +
                '<td class="vg-kanban-screening__td-status"><span class="' + screeningStatusBadgeClass(st) + '">' + st + '</span></td>' +
                '<td class="vg-kanban-screening__td-note">' + (note || '—') + '</td>' +
                '</tr>';
        }
        if (!rows) return '';
        return (
            '<div class="vg-kanban-focus__section-title">' + escapeHtml(sectionTitle) + '</div>' +
            '<div class="vg-kanban-screening vg-kanban-screening--funding">' +
            '<div class="vg-kanban-screening__table-wrap">' +
            '<table class="vg-kanban-screening__table" role="table" aria-label="' + escapeHtml(sectionTitle) + '">' +
            '<thead><tr>' +
            '<th style="width:54px" aria-label="Indice"></th>' +
            '<th>Voce</th>' +
            '<th style="width:120px">Stato company</th>' +
            '<th>Nota</th>' +
            '</tr></thead><tbody>' + rows + '</tbody></table>' +
            '</div>' +
            '</div>'
        );
    }

    function renderDisciplinareFocusHtml(df, isFunding) {
        var funding = isFunding || (df && df.kind === 'funding');
        var sectionTitle = funding ? 'Analisi bando incentivo' : 'Analisi disciplinare';
        if (!df) {
            return '<div class="vg-kanban-focus__section-title">' + escapeHtml(sectionTitle) + '</div>' +
                '<div class="vg-kanban-screening"><p class="vg-kanban-focus__hint-muted">Non disponibile.</p></div>';
        }
        var reqs = Array.isArray(df.requirements) ? df.requirements : [];
        var rows = '';
        for (var j = 0; j < reqs.length; j++) {
            var r2 = reqs[j] || {};
            var title2 = escapeHtml(r2.title || r2.key || 'Voce');
            var st2 = escapeHtml(r2.company_status || 'unknown');
            var note2 = escapeHtml(r2.note || '');
            var score2 = (typeof r2.score === 'number' && isFinite(r2.score)) ? r2.score : 0;
            var rk = escapeHtml(String(r2.key || ('d' + j)));
            rows +=
                '<tr>' +
                '<td class="vg-kanban-screening__td-donut">' +
                '<span class="vg-kanban-screening-donut-wrap vg-kanban-screening-donut-wrap--md">' +
                '<canvas class="vg-kanban-screening-donut" width="34" height="34" data-screening-mini="' + rk + '" ' +
                'data-score="' + escapeHtml(String(score2)) + '" ' +
                'role="img" aria-label="Indice ' + title2 + ': ' + String(score2) + ' su 100"></canvas>' +
                '<span class="vg-kanban-screening-donut__value" aria-hidden="true"></span>' +
                '</span>' +
                '</td>' +
                '<td class="vg-kanban-screening__td-title">' + title2 + '</td>' +
                '<td class="vg-kanban-screening__td-status"><span class="' + screeningStatusBadgeClass(st2) + '">' + st2 + '</span></td>' +
                '<td class="vg-kanban-screening__td-note">' + (note2 || '—') + '</td>' +
                '</tr>';
        }
        if (!rows) {
            var reason = (String(df.status || '') === 'skipped')
                ? (funding
                    ? 'Analisi non attiva o senza testo del bando.'
                    : 'Analisi non attiva (impostazioni server) o senza testo disciplinare.')
                : 'Nessun dato estratto.';
            return '<div class="vg-kanban-focus__section-title">' + escapeHtml(sectionTitle) + '</div>' +
                '<div class="vg-kanban-screening"><p class="vg-kanban-focus__hint-muted">' + escapeHtml(reason) + '</p></div>';
        }
        return (
            '<div class="vg-kanban-focus__section-title">' + escapeHtml(sectionTitle) + '</div>' +
            '<div class="vg-kanban-screening vg-kanban-screening--funding">' +
            '<div class="vg-kanban-screening__table-wrap">' +
            '<table class="vg-kanban-screening__table" role="table" aria-label="' + escapeHtml(sectionTitle) + '">' +
            '<thead><tr>' +
            '<th style="width:54px" aria-label="Indice"></th>' +
            '<th>Voce</th>' +
            '<th style="width:120px">Stato company</th>' +
            '<th>Nota</th>' +
            '</tr></thead><tbody>' + rows + '</tbody></table>' +
            '</div>' +
            '</div>'
        );
    }

    function mountScreeningDonutsIn(rootEl) {
        if (!rootEl || !rootEl.querySelectorAll) return;
        var nodes = rootEl.querySelectorAll('canvas[data-screening-mini]');
        for (var i = 0; i < nodes.length; i++) {
            var c = nodes[i];
            var sc = parseFloat(c.getAttribute('data-score') || '0');
            renderScreeningDonut(c, sc, { cutout: '70%' });
        }
    }

    function buildCardEl(item) {
        var el = document.createElement('div');
        /* Muuri richiede un primo figlio (muuri-item-content) per layout/visibility — vedi README Muuri */
        el.className = 'vg-kanban-card muuri-item is-collapsed';
        el.setAttribute('data-item-id', String(item.id));
        el.setAttribute('data-state', item.state);
        el.setAttribute('data-procedure-id', item.procedure_id || '');
        var isFundingCard = (item.item_kind === 'funding') || String(item.procedure_id || '').indexOf('funding:') === 0;
        if (isFundingCard) {
            el.classList.add('vg-kanban-card--funding');
            el.setAttribute('data-item-kind', 'funding');
        }
        if (item.ghost_url) el.setAttribute('data-ghost-url', String(item.ghost_url));
        var buyer = item.notice_buyer_name || '';
        var dlRaw = item.notice_deadline_date ? String(item.notice_deadline_date) : '';
        var dl = fmtDateOnlyIt(dlRaw);
        var money = fmtMoney(item.notice_amount_estimated, item.notice_currency);
        var cpv = item.notice_cpv || '';
        var cpvParts = splitCpv(cpv);
        var st = item.state || '';
        var stIt = stateLabelIt(st);
        var urg = deadlineUrgency(dlRaw || null);
        var isAiFailed = st === 'ai_failed';
        var isAiReady = st === 'ai_ready';
        if (isAiFailed) el.classList.add('vg-kanban-card--ai-failed');
        var isPartial = false;
        try { isPartial = !!(item && item.ai_result && item.ai_result.summary && item.ai_result.summary.partial_downloads); } catch (ePart) {}
        var showPartialAnalysis = !!(isAiReady && isPartial);
        el.setAttribute('data-kanban-partial-doc', showPartialAnalysis ? '1' : '0');
        if (urg) el.classList.add('vg-kanban-card--has-urgency');
        var urgHtml = '';
        if (urg === 'red') {
            urgHtml =
                '<span class="vg-kanban-card__semaphore vg-kanban-card__semaphore--red" title="Scadenza entro 7 giorni o già passata" aria-label="Stato: scadenza imminente o passata" role="img"></span>';
        } else if (urg === 'yellow') {
            urgHtml =
                '<span class="vg-kanban-card__semaphore vg-kanban-card__semaphore--yellow" title="Scadenza entro 30 giorni" aria-label="Stato: scadenza entro 30 giorni" role="img"></span>';
        } else {
            urgHtml =
                '<span class="vg-kanban-card__semaphore vg-kanban-card__semaphore--ok" title="Nessuna urgenza" aria-label="Stato: nessuna urgenza" role="img"></span>';
        }
        var aiFailedHtml = isAiFailed ? renderAiFailedBlock(item) : '';
        var partialHtml = (isAiReady && isPartial)
            ? '<div class="vg-kanban-card__ai-partial" role="note">Analisi parziale: alcuni documenti non sono scaricabili (login/piattaforma chiusa).</div>'
            : '';
        // Actions are handled in focus lightbox only.
        var relaunchHtml = '';
        var docsAutoload = isAiReady || (isFundingCard && st === 'to_evaluate');
        var docsHtml = docsAutoload
            ? (
                '<div class="vg-kanban-card__docs-wrap">' +
                '<div class="vg-kanban-card__docs-title">Documenti</div>' +
                '<div class="vg-kanban-card__docs" data-kanban-docs-panel data-kanban-docs-autoload>Caricamento documenti…</div>' +
                '</div>'
            )
            : '';
        // Manual uploads must be visible also on non-AI cards: include the docs panel for every state,
        // but load it lazily (on expand) unless autoload (ai_ready o incentivo in Da valutare).
        if (!docsHtml) {
            docsHtml =
                '<div class="vg-kanban-card__docs-wrap">' +
                '<div class="vg-kanban-card__docs-title">Documenti</div>' +
                '<div class="vg-kanban-card__docs" data-kanban-docs-panel>Espandi la scheda per caricare i documenti…</div>' +
                '</div>';
        }
        var noticeTitle = item.notice_title || item.procedure_id || '—';
        var mean = screeningMeanFromItem(item);
        var screeningHtml = '';
        if (isAiReady && mean !== null) {
            screeningHtml =
                '<div class="vg-kanban-card__windowbar-screening" aria-hidden="false">' +
                '<span class="vg-kanban-screening-donut-wrap vg-kanban-screening-donut-wrap--sm">' +
                '<canvas class="vg-kanban-screening-donut" data-kanban-card-screening-mean width="32" height="32" ' +
                'data-score="' + escapeHtml(String(mean)) + '" ' +
                'role="img" aria-label="Screening preliminare: media ' + escapeHtml(String(mean)) + ' su 100"></canvas>' +
                '<span class="vg-kanban-screening-donut__value" aria-hidden="true"></span>' +
                '</span>' +
                '</div>';
        }
        el.innerHTML =
            '<div class="muuri-item-content vg-kanban-card__shell">' +
            '<div class="vg-kanban-card__windowbar">' +
            '  <div class="vg-kanban-card__windowbar-left">' +
            urgHtml +
            '  </div>' +
            '  <div class="vg-kanban-card__windowbar-title" title="' + escapeHtml(buyer || noticeTitle) + '">' +
            escapeHtml(buyer || noticeTitle) +
            '  </div>' +
            screeningHtml +
            '  <div class="vg-kanban-card__windowbar-actions">' +
            '    <button type="button" class="vg-kanban-card__btn vg-kanban-card__btn--minimize" data-kanban-no-drag data-kanban-toggle aria-expanded="false" title="Mostra o nascondi il contenuto" aria-label="Minimizza / espandi">—</button>' +
            '    <button type="button" class="vg-kanban-card__btn vg-kanban-card__btn--focus" data-kanban-no-drag data-kanban-focus title="Apri in modalità focus" aria-label="Apri in modalità focus">⛶</button>' +
            '  </div>' +
            '</div>' +
            '<div class="vg-kanban-card__body">' +
            '<div class="vg-kanban-card__content">' +
            (buyer ? ('<div class="vg-kanban-card__notice-title">' + escapeHtml(noticeTitle) + '</div>') : '') +
            aiFailedHtml +
            relaunchHtml +
            partialHtml +
            '<div class="vg-kanban-card__meta">' +
            (isFundingCard ? '<span class="vg-kanban-card__funding-badge">Incentivo</span><br/>' : '') +
            (dl ? '<span class="vg-kanban-card__deadline"><span class="vg-kanban-card__deadline-ico" aria-hidden="true">📅</span><span class="vg-kanban-card__deadline-text"> ' + escapeHtml(dl) + '</span></span><br/>' : '') +
            (money ? '<span class="vg-kanban-card__money">' + escapeHtml(money) + '</span><br/>' : '') +
            ((cpvParts.code || cpvParts.label)
                ? '<span class="vg-kanban-card__cpv" ' +
                    (cpvParts.code ? ('data-cpv-code="' + escapeHtml(cpvParts.code) + '"') : '') +
                    ((cpvParts.code && !cpvParts.label) ? ' data-cpv-label-pending="1"' : '') +
                    '><span class="vg-kanban-card__cpv-code">' +
                    escapeHtml(cpvParts.code || 'CPV') +
                    '</span>' +
                    '<span class="vg-kanban-card__cpv-sep"> — </span><span class="vg-kanban-card__cpv-label">' + escapeHtml(cpvParts.label || '') + '</span>' +
                    '</span><br/>'
                : '') +
            '<span class="vg-kanban-card__state">' + escapeHtml(stIt) + '</span>' +
            docsHtml +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
        try {
            var cMean = el.querySelector('[data-kanban-card-screening-mean]');
            if (cMean) {
                var sc = parseFloat(cMean.getAttribute('data-score') || '0');
                renderScreeningDonut(cMean, sc, { cutout: '74%' });
            }
        } catch (eR) {}
        try {
            updateKanbanCardDocCautionBorder(el, undefined);
        } catch (eB) {}
        return el;
    }

    function updateKanbanCardDocCautionBorder(cardEl, okCount) {
        if (!cardEl) return;
        var partial = cardEl.getAttribute('data-kanban-partial-doc') === '1';
        var one = typeof okCount === 'number' && okCount === 1;
        if (partial || one) {
            cardEl.classList.add('vg-kanban-card--docs-caution');
        } else if (typeof okCount === 'number') {
            cardEl.classList.remove('vg-kanban-card--docs-caution');
        }
    }

    function escapeHtml(s) {
        return String(s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    var columnGrids = [];
    var booted = false;
    var pendingAiRefreshInterval = null;
    var lastItemsSnapshot = null;
    var reloginInFlight = null;

    function hasPendingAiItems(items) {
        if (!Array.isArray(items)) return false;
        for (var i = 0; i < items.length; i++) {
            var it = items[i] || {};
            var st = String(it.state || '');
            if (st === 'ai_queued' || st === 'ai_processing') return true;
        }
        return false;
    }

    function hasOpenLightbox() {
        // Any visible modal counts (focus, upload, preview, profile incomplete, confirm).
        // If the user is reading a lightbox we should not reload the page.
        return !!document.querySelector('.vg-kanban-modal:not([hidden])');
    }

    function hasPendingAiCardsInDom() {
        return !!root.querySelector('.vg-kanban-card[data-state="ai_queued"], .vg-kanban-card[data-state="ai_processing"]');
    }

    function ensureGatewayLogin() {
        if (reloginInFlight) return reloginInFlight;
        reloginInFlight = Promise.resolve().then(function () {
            return fetchGhostSessionToken();
        }).then(function (tok) {
            if (!tok) return null;
            return loginOnGateway(tok).then(function () { return true; });
        }).catch(function () {
            return null;
        }).finally(function () {
            reloginInFlight = null;
        });
        return reloginInFlight;
    }

    function apiKanbanItemsWithRelogin() {
        return apiJson('/kanban/items').catch(function (err) {
            var st = err && typeof err.status === 'number' ? err.status : 0;
            // Long-lived page: gateway session may expire; re-login using Ghost session token and retry once.
            if (st !== 401 && st !== 403) throw err;
            return ensureGatewayLogin().then(function (ok) {
                if (!ok) throw err;
                return apiJson('/kanban/items');
            });
        });
    }

    function gridForElement(cardEl) {
        if (!cardEl) return null;
        for (var gi = 0; gi < columnGrids.length; gi++) {
            var g = columnGrids[gi];
            try {
                var muItems = g.getItems();
                for (var ii = 0; ii < muItems.length; ii++) {
                    if (muItems[ii].getElement() === cardEl) return g;
                }
            } catch (eG) {}
        }
        return null;
    }

    function gridForZone(zone) {
        // Muuri grid is created per .vg-kanban-items container in zone column, in buildMuuriGrids().
        for (var gi = 0; gi < columnGrids.length; gi++) {
            var g = columnGrids[gi];
            try {
                var el = g.getElement && g.getElement();
                // Grid element is the container (.vg-kanban-items). Its closest column has data-zone.
                var col = el && el.closest ? el.closest('[data-zone]') : null;
                if (col && String(col.getAttribute('data-zone') || '') === String(zone || '')) return g;
            } catch (eZ) {}
        }
        return null;
    }

    function replaceOrMoveCardFromItem(item) {
        if (!item) return;
        var id = item.id;
        var cardEl = root.querySelector('.vg-kanban-card[data-item-id="' + String(id) + '"]');
        if (!cardEl) return;

        var fromGrid = gridForElement(cardEl);
        var targetZone = zoneForState(item.state);
        var toCol = qs('[data-zone="' + targetZone + '"]', root);
        var toContainer = toCol ? qs('.vg-kanban-items', toCol) : null;
        var toGrid = toContainer ? gridForZone(targetZone) : null;

        var newEl = buildCardEl(item);

        try {
            if (fromGrid && fromGrid.remove) {
                // Remove old element from Muuri and DOM.
                fromGrid.remove(cardEl, { removeElements: true });
            } else if (cardEl && cardEl.parentNode) {
                cardEl.parentNode.removeChild(cardEl);
            }
        } catch (eR) {
            try { if (cardEl && cardEl.parentNode) cardEl.parentNode.removeChild(cardEl); } catch (eR2) {}
        }

        try {
            if (toContainer) toContainer.appendChild(newEl);
        } catch (eA) {
            // Fallback: if we can't find the target container, just keep it where it was.
            try {
                var p = (fromGrid && fromGrid.getElement) ? fromGrid.getElement() : null;
                if (p) p.appendChild(newEl);
            } catch (eA2) {}
        }

        try {
            if (toGrid && toGrid.add) {
                toGrid.add([newEl]);
            } else if (fromGrid && fromGrid.add) {
                fromGrid.add([newEl]);
            }
        } catch (eM) {}

        requestAnimationFrame(function () {
            try {
                columnGrids.forEach(function (g) {
                    try { g.refreshItems(); g.layout(); } catch (eL) {}
                });
            } catch (eL2) {}
        });

        // If it just became ai_ready, trigger docs autoload like refresh() does.
        try {
            if (String(item.state || '') === 'ai_ready' && root._vgLoadDocsForCard) {
                root._vgLoadDocsForCard(newEl, true);
            }
        } catch (eD) {}
    }

    function refreshPendingAiCards() {
        // Avoid disturbing the user while modals are open.
        if (hasOpenLightbox()) return Promise.resolve(null);
        return apiKanbanItemsWithRelogin().then(function (res) {
            var items = (res && res.items) ? res.items : [];
            lastItemsSnapshot = items;

            // Instead of trying to surgically swap Muuri items (fragile), we do a cheap check:
            // if any visible pending card changed state, refresh the board once.
            var byId = {};
            for (var i = 0; i < items.length; i++) byId[String(items[i] && items[i].id)] = items[i];

            var shouldRefreshBoard = false;
            var pendingEls = root.querySelectorAll('.vg-kanban-card[data-state="ai_queued"], .vg-kanban-card[data-state="ai_processing"]');
            for (var j = 0; j < pendingEls.length; j++) {
                var el = pendingEls[j];
                var itemId = el.getAttribute('data-item-id');
                var it = byId[String(itemId)];
                // If the server no longer returns this item (e.g. it was archived or filtered),
                // force a full refresh to reconcile DOM with source of truth.
                if (!it) {
                    shouldRefreshBoard = true;
                    break;
                }
                var cur = String(el.getAttribute('data-state') || '');
                var next = String(it.state || '');
                if (next && next !== cur) {
                    shouldRefreshBoard = true;
                    break;
                }
            }
            if (shouldRefreshBoard) {
                return refresh().catch(function () { return items; });
            }

            return items;
        }).catch(function (err) {
            // Don't fail silently: if the gateway session expired or the request fails,
            // keep a small hint so the user understands why cards may look stale.
            try {
                var msg = (err && err.message) ? String(err.message) : '';
                setStatus(msg ? ('Auto-refresh AI: ' + msg) : 'Auto-refresh AI: errore');
            } catch (eS) {}
            return null;
        });
    }

    function ensurePendingAiRefreshLoop() {
        if (pendingAiRefreshInterval) return;
        pendingAiRefreshInterval = setInterval(function () {
            try {
                if (!booted) return;
                if (hasOpenLightbox()) return;
                if (!hasPendingAiCardsInDom()) return;
                refreshPendingAiCards();
            } catch (e) {}
        }, 60 * 1000);
    }

    function relayoutForElement(cardEl) {
        if (!cardEl) return;
        for (var gi = 0; gi < columnGrids.length; gi++) {
            var g = columnGrids[gi];
            var items = g.getItems();
            for (var i = 0; i < items.length; i++) {
                if (items[i].getElement() === cardEl) {
                    if (typeof g.refreshItems === 'function') g.refreshItems();
                    g.layout();
                    return;
                }
            }
        }
    }

    function syncArchivedToggleLabel() {
        var p = qs('[data-archived-panel]', root);
        var b = qs('[data-toggle-archived]', root);
        if (!b) return;
        var labelEl = b.querySelector && b.querySelector('[data-toggle-archived-label]');
        if (!p) {
            if (labelEl) labelEl.textContent = 'Mostra archiviate';
            else b.innerHTML = '<span aria-hidden="true">🗄️</span> <span data-toggle-archived-label>Mostra archiviate</span>';
            return;
        }
        var open = !p.hasAttribute('hidden');
        var txt = open ? 'Nascondi archiviate' : 'Mostra archiviate';
        if (labelEl) labelEl.textContent = txt;
        else b.innerHTML = '<span aria-hidden="true">🗄️</span> <span data-toggle-archived-label>' + escapeHtml(txt) + '</span>';
    }

    function destroyGrids() {
        columnGrids.forEach(function (g) {
            try { g.destroy(true); } catch (e) {}
        });
        columnGrids = [];
    }

    function buildMuuriGrids() {
        var zones = ['to_evaluate', 'ai', 'decision', 'in_progress', 'archived'];
        zones.forEach(function (z) {
            var col = qs('[data-zone="' + z + '"]', root);
            if (!col || col.hasAttribute('hidden')) return;
            var container = qs('.vg-kanban-items', col);
            if (!container) return;
            var grid = new Muuri(container, {
                items: '.muuri-item',
                layout: {
                    fillGaps: true,
                    horizontal: false,
                    alignRight: false,
                    alignBottom: false,
                    rounding: false
                },
                layoutDuration: 200,
                dragEnabled: true,
                dragSort: function () {
                    return columnGrids;
                },
                /* default dragContainer = grid: evita reparent su body (l’item diventerebbe ~100vw con width:100% sul content) */
                dragStartPredicate: function (item, event) {
                    var el = item.getElement();
                    if (!el || el.getAttribute('data-state') === 'ai_processing') {
                        if (event && event.isFinal && Muuri.ItemDrag && Muuri.ItemDrag.defaultStartPredicate) {
                            Muuri.ItemDrag.defaultStartPredicate(item, event);
                        }
                        return false;
                    }
                    if (
                        event &&
                        event.target &&
                        event.target.closest &&
                        event.target.closest('[data-kanban-no-drag]')
                    ) {
                        if (event && event.isFinal && Muuri.ItemDrag && Muuri.ItemDrag.defaultStartPredicate) {
                            Muuri.ItemDrag.defaultStartPredicate(item, event);
                        }
                        return false;
                    }
                    if (Muuri.ItemDrag && Muuri.ItemDrag.defaultStartPredicate) {
                        return Muuri.ItemDrag.defaultStartPredicate(item, event, {
                            distance: 8,
                            delay: 0
                        });
                    }
                    return true;
                },
                dragAutoScroll: { targets: function () {
                    return [window];
                } }
            });
            grid.on('dragReleaseEnd', function (item) {
                handleDragEnd(item, grid);
            });
            columnGrids.push(grid);
        });
        requestAnimationFrame(function () {
            columnGrids.forEach(function (g) {
                try {
                    g.refreshItems();
                    g.layout();
                } catch (e) {}
            });
        });
    }

    function handleDragEnd(item /* , grid */) {
        var el = item.getElement();
        if (!el) return;
        var id = parseInt(el.getAttribute('data-item-id'), 10);
        var fromState = el.getAttribute('data-state') || '';
        var col = el.closest('[data-zone]');
        if (!col) return;
        var newZone = col.getAttribute('data-zone') || '';
        var target = inferTargetState(fromState, newZone);
        if (!target || target === fromState) {
            refresh();
            return;
        }
        confirmTransition(fromState, target).then(function (ok) {
            if (!ok) {
                // Revert UI to server state.
                refresh();
                return;
            }
            return apiJson('/kanban/items/' + encodeURIComponent(id), {
                method: 'PATCH',
                body: { state: target }
            }).then(function () {
                el.setAttribute('data-state', target);
                setStatus('');
                return refresh();
            });
        }).catch(function (err) {
            if (!maybeShowProfileIncompleteDialog(err)) {
                setStatus((err && err.message) ? err.message : 'Errore');
            }
            return refresh();
        });
    }

    function kanbanItemKind(item) {
        if (!item) return 'tender';
        if (item.item_kind === 'funding') return 'funding';
        var pid = String(item.procedure_id || '');
        if (pid.indexOf('funding:') === 0) return 'funding';
        return 'tender';
    }

    function readKindFilter() {
        var fundingCb = qs('[data-kanban-filter-kind="funding"]', root);
        var tenderCb = qs('[data-kanban-filter-kind="tender"]', root);
        return {
            showFunding: fundingCb ? !!fundingCb.checked : true,
            showTender: tenderCb ? !!tenderCb.checked : true
        };
    }

    function persistKindFilter() {
        var f = readKindFilter();
        try {
            localStorage.setItem(
                KIND_FILTER_KEY,
                JSON.stringify({ funding: f.showFunding, tender: f.showTender })
            );
        } catch (e) {}
        syncKindFilterButtonStyles();
    }

    function syncKindFilterButtonStyles() {
        ['funding', 'tender'].forEach(function (kind) {
            var cb = qs('[data-kanban-filter-kind="' + kind + '"]', root);
            if (!cb) return;
            var wrap = cb.closest ? cb.closest('.vg-kanban-kind-toggle') : null;
            if (!wrap) return;
            var on = !!cb.checked;
            wrap.classList.toggle('is-active', on);
            wrap.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
    }

    function applyKindFilterPreference() {
        var fundingCb = qs('[data-kanban-filter-kind="funding"]', root);
        var tenderCb = qs('[data-kanban-filter-kind="tender"]', root);
        if (!fundingCb || !tenderCb) return;
        var showFunding = true;
        var showTender = true;
        try {
            var raw = localStorage.getItem(KIND_FILTER_KEY);
            if (raw) {
                var o = JSON.parse(raw);
                if (typeof o.funding === 'boolean') showFunding = o.funding;
                if (typeof o.tender === 'boolean') showTender = o.tender;
            }
        } catch (e2) {}
        if (!showFunding && !showTender) {
            showFunding = true;
            showTender = true;
        }
        fundingCb.checked = showFunding;
        tenderCb.checked = showTender;
        syncKindFilterButtonStyles();
    }

    function enforceAtLeastOneKindFilter(changedCb) {
        var fundingCb = qs('[data-kanban-filter-kind="funding"]', root);
        var tenderCb = qs('[data-kanban-filter-kind="tender"]', root);
        if (!fundingCb || !tenderCb) return;
        if (fundingCb.checked || tenderCb.checked) return;
        if (changedCb === fundingCb) {
            tenderCb.checked = true;
        } else {
            fundingCb.checked = true;
        }
    }

    function filterItemsByKind(items) {
        var f = readKindFilter();
        return (items || []).filter(function (item) {
            var k = kanbanItemKind(item);
            if (k === 'funding') return f.showFunding;
            return f.showTender;
        });
    }

    function placeItems(items) {
        destroyGrids();
        items = filterItemsByKind(items);
        var showArchived = qs('[data-archived-panel]', root) && !qs('[data-archived-panel]', root).hasAttribute('hidden');
        ['to_evaluate', 'ai', 'decision', 'in_progress', 'archived'].forEach(function (z) {
            var col = qs('[data-zone="' + z + '"]', root);
            if (!col) return;
            if (z === 'archived' && !showArchived) return;
            var container = qs('.vg-kanban-items', col);
            if (!container) return;
            container.innerHTML = '';
        });
        items.forEach(function (item) {
            var z = zoneForState(item.state);
            if (z === 'archived' && !showArchived) return;
            var col = qs('[data-zone="' + z + '"]', root);
            if (!col) return;
            var container = qs('.vg-kanban-items', col);
            if (!container) return;
            container.appendChild(buildCardEl(item));
        });
        buildMuuriGrids();
        // After DOM is ready, hydrate missing CPV labels from gateway CPV table.
        hydrateCpvLabels();
    }

    function applyArchivedPanelPreference() {
        var p = qs('[data-archived-panel]', root);
        if (!p) return;
        var want = false;
        try { want = localStorage.getItem(SHOW_ARCHIVED_KEY) === '1'; } catch (e) {}
        if (want) {
            p.removeAttribute('hidden');
            p.classList.remove('is-hidden');
        } else {
            p.setAttribute('hidden', 'hidden');
            p.classList.add('is-hidden');
        }
        syncArchivedToggleLabel();
    }

    function refresh() {
        return apiKanbanItemsWithRelogin().then(function (res) {
            var items = (res && res.items) ? res.items : [];
            lastItemsSnapshot = items;
            placeItems(items);
            qs('[data-kanban-board]', root).hidden = false;
            syncArchivedToggleLabel();
            hydrateDocsLists();
            ensurePendingAiRefreshLoop();
            return items;
        });
    }

    function hydrateDocsLists() {
        if (!root.querySelectorAll) return;
        function loadDocsForCard(cardEl, force) {
            if (!cardEl) return;
            if (!force && cardEl.getAttribute('data-docs-loaded') === '1') return;
            var panel = cardEl.querySelector && cardEl.querySelector('[data-kanban-docs-panel]');
            if (!panel) return;
            var id = parseInt(cardEl.getAttribute('data-item-id'), 10);
            if (!id) return;
            cardEl.setAttribute('data-docs-loaded', '1');
            panel.innerHTML = 'Caricamento documenti…';

            apiJson('/kanban/items/' + encodeURIComponent(id) + '/downloads').then(function (res) {
                    var files = (res && res.files) ? res.files : [];
                    var ok = filterKanbanDownloadFiles(files);
                    var bad = [];
                    for (var j = 0; j < files.length; j++) {
                        var f = files[j] || {};
                        if (isHiddenKanbanDownloadFile(f)) continue;
                        if (!f.stored_relpath) bad.push(f);
                    }

                    function fmtBytes(n) {
                        var x = parseInt(n, 10);
                        if (!x || x < 1) return '';
                        if (x < 1024) return x + ' B';
                        if (x < 1024 * 1024) return Math.round(x / 1024) + ' KB';
                        return (Math.round((x / (1024 * 1024)) * 10) / 10) + ' MB';
                    }
                    function hostFromUrl(u) {
                        try { return (new URL(String(u))).host; } catch (eU) { return ''; }
                    }
                    function docCatHtml(f) {
                        var state = cardEl.getAttribute('data-state') || '';
                        var badges = docBadgesHtml(f, state);
                        var slug = (f && f.doc_category) ? String(f.doc_category) : '';
                        if (!slug) return badges;
                        var lab = (f && f.doc_category_label) ? String(f.doc_category_label) : slug;
                        var safe = slug.replace(/[^a-z0-9_]/gi, '');
                        if (!safe) safe = 'altro';
                        return ' <span class="vg-kanban-doc-cat vg-kanban-doc-cat--' + escapeHtml(safe) + '">' + escapeHtml(lab) + '</span>' +
                            badges;
                    }

                    if (!ok.length && !bad.length) {
                        panel.innerHTML = '<div class="vg-kanban-card__docs-empty">Nessun documento disponibile.</div>';
                        try { updateKanbanCardDocCautionBorder(cardEl, 0); } catch (eC0) {}
                        relayoutForElement(cardEl);
                        return;
                    }

                    ok.sort(function (a, b) {
                        var ia = parseInt(a.doc_importance, 10);
                        var ib = parseInt(b.doc_importance, 10);
                        if (isNaN(ia)) ia = 0;
                        if (isNaN(ib)) ib = 0;
                        if (ia !== ib) return ib - ia;
                        var an = String(a.filename || '').toLowerCase();
                        var bn = String(b.filename || '').toLowerCase();
                        return an < bn ? -1 : an > bn ? 1 : 0;
                    });

                    var html = '';
                    if (ok.length) {
                        html += '<ul class="vg-kanban-card__docs-list">';
                        ok.forEach(function (f2) {
                            var fn = f2.filename ? String(f2.filename) : 'documento';
                            var href = f2.download_url ? String(f2.download_url) : '';
                            // Gateway is mounted under apiBase (e.g. /api). `download_url` comes from the gateway router
                            // and is typically "/kanban/...". If we don't prefix it, the browser will hit Ghost instead.
                            if (href && href.indexOf('/kanban/') === 0) {
                                var baseStr = '';
                                try {
                                    baseStr = (typeof apiBase === 'function') ? apiBase() : String(apiBase || '');
                                } catch (eB) { baseStr = ''; }
                                baseStr = String(baseStr || '').trim();
                                if (!baseStr) baseStr = '/api';
                                baseStr = baseStr.replace(/\/+$/, '');
                                if (baseStr && baseStr !== '/') href = baseStr + href;
                            }
                            var bytes = fmtBytes(f2.bytes);
                            var host = hostFromUrl(f2.source_url || f2.url || '');
                            var depth = (typeof f2.depth === 'number') ? ('d' + f2.depth) : '';
                            var metaBits = [];
                            if (bytes) metaBits.push(bytes);
                            if (host) metaBits.push(host);
                            if (depth) metaBits.push(depth);
                            html += '<li class="vg-kanban-card__docs-item">' +
                                (href
                                    ? ('<a href="' + escapeHtml(href) + '" data-kanban-doc-open data-doc-url="' + escapeHtml(href) + '" data-doc-filename="' + escapeHtml(fn) + '" data-doc-ct="' + escapeHtml(String(f2.content_type || '')) + '" data-kanban-no-drag>' + escapeHtml(fn) + '</a>' + docCatHtml(f2))
                                    : (escapeHtml(fn) + docCatHtml(f2))) +
                                (metaBits.length ? ('<div class="vg-kanban-card__docs-meta">' + escapeHtml(metaBits.join(' · ')) + '</div>') : '') +
                                '</li>';
                        });
                        html += '</ul>';
                    }
                    if (bad.length) {
                        html += '<details class="vg-kanban-card__docs-failed"><summary> Tentativi falliti (' + bad.length + ')</summary>';
                        html += '<ul class="vg-kanban-card__docs-list">';
                        bad.forEach(function (f3) {
                            var u = f3 && (f3.source_url || f3.url) ? String(f3.source_url || f3.url) : '';
                            var host = hostFromUrl(u);
                            var err = f3 && (f3.error || f3.detail) ? String(f3.error || f3.detail) : 'errore';
                            html += '<li class="vg-kanban-card__docs-item">' +
                                (u ? ('<a href="' + escapeHtml(u) + '" target="_blank" rel="noopener" data-kanban-no-drag>' + escapeHtml(host || u) + '</a>') : 'URL') +
                                '<div class="vg-kanban-card__docs-meta">' + escapeHtml(err) + '</div>' +
                                '</li>';
                        });
                        html += '</ul></details>';
                    }
                    panel.innerHTML = html;
                    try { updateKanbanCardDocCautionBorder(cardEl, ok.length); } catch (eC1) {}
                    relayoutForElement(cardEl);
                }).catch(function () {
                    panel.innerHTML = '<div class="vg-kanban-card__docs-empty">Errore caricamento documenti.</div>';
                    try { updateKanbanCardDocCautionBorder(cardEl, 0); } catch (eC2) {}
                    relayoutForElement(cardEl);
                });
        }
        // Autoload: ai_ready e incentivi in Da valutare (scheda PDF Ghost).
        var cards = root.querySelectorAll(
            '.vg-kanban-card[data-state="ai_ready"], .vg-kanban-card--funding[data-state="to_evaluate"]'
        );
        for (var i = 0; i < cards.length; i++) {
            var cardEl = cards[i];
            if (!cardEl) continue;
            var panel = cardEl.querySelector && cardEl.querySelector('[data-kanban-docs-panel][data-kanban-docs-autoload]');
            if (!panel) continue;
            loadDocsForCard(cardEl, false);
        }
        // Expose for other handlers (expand / upload).
        root._vgLoadDocsForCard = loadDocsForCard;
    }

    function openPortalSignin() {
        var a = qs('[data-kanban-portal-signin]', root) || document.querySelector('[data-portal="signin"]');
        if (a && a.click) try { a.click(); } catch (e) {}
    }

    async function boot() {
        setStatus('Caricamento…');
        try {
            applyArchivedPanelPreference();
            applyKindFilterPreference();
            var tok = await fetchGhostSessionToken();
            if (!tok) {
                setStatus('Accedi per continuare.');
                openPortalSignin();
                return;
            }
            await loginOnGateway(tok);
            await refresh();
            booted = true;
            root.setAttribute('data-kanban-ready', '1');
            setStatus('');
        } catch (e) {
            setStatus((e && e.message) ? e.message : 'Errore avvio');
        }
    }

    root.addEventListener('change', function (e) {
        var kindCb = e.target && e.target.closest ? e.target.closest('[data-kanban-filter-kind]') : null;
        if (!kindCb || !root.contains(kindCb)) return;
        enforceAtLeastOneKindFilter(kindCb);
        persistKindFilter();
        if (lastItemsSnapshot) {
            placeItems(lastItemsSnapshot);
        }
    });

    root.addEventListener('click', function (e) {
        var manualBtn = e.target.closest && e.target.closest('[data-create-manual]');
        if (manualBtn) {
            e.preventDefault();
            openManualCreateModal();
            return;
        }
        var docLink = e.target.closest && e.target.closest('[data-kanban-doc-open]');
        if (docLink) {
            e.preventDefault();
            openDocbox({
                title: docLink.getAttribute('data-doc-filename') || 'Documento',
                filename: docLink.getAttribute('data-doc-filename') || '',
                url: docLink.getAttribute('data-doc-url') || docLink.getAttribute('href') || '',
                contentType: docLink.getAttribute('data-doc-ct') || ''
            });
            return;
        }
        var retryBtn = e.target.closest && e.target.closest('[data-kanban-retry]');
        if (retryBtn) {
            e.preventDefault();
            var cardEl = retryBtn.closest('.vg-kanban-card');
            if (!cardEl) return;
            var id = parseInt(cardEl.getAttribute('data-item-id'), 10);
            if (!id) return;
            setStatus('Rilancio analisi AI…');
            apiJson('/kanban/items/' + encodeURIComponent(id), {
                method: 'PATCH',
                body: { state: 'ai_queued' }
            }).then(function () {
                setStatus('');
                return refresh();
            }).catch(function (err) {
                if (!maybeShowProfileIncompleteDialog(err)) {
                    setStatus((err && err.message) ? err.message : 'Errore');
                }
                return refresh();
            });
            return;
        }
        if (e.target.closest && e.target.closest('[data-toggle-archived]')) {
            var p = qs('[data-archived-panel]', root);
            if (!p) return;
            e.preventDefault();
            if (p.hasAttribute('hidden')) {
                p.removeAttribute('hidden');
                p.classList.remove('is-hidden');
                try { localStorage.setItem(SHOW_ARCHIVED_KEY, '1'); } catch (e2) {}
            } else {
                p.setAttribute('hidden', 'hidden');
                p.classList.add('is-hidden');
                try { localStorage.setItem(SHOW_ARCHIVED_KEY, '0'); } catch (e3) {}
            }
            syncArchivedToggleLabel();
            refresh();
            return;
        }
        if (e.target.closest && e.target.closest('[data-archive-expired]')) {
            e.preventDefault();
            archiveExpiredKanbanItemsPrompt();
            return;
        }
        var cbtn = e.target.closest && e.target.closest('[data-kanban-toggle]');
        if (cbtn) {
            e.preventDefault();
            var card = cbtn.closest('.vg-kanban-card');
            if (!card) return;
            var collapsed = card.classList.toggle('is-collapsed');
            cbtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
            relayoutForElement(card);
            // Lazy-load docs when expanding, so manual uploads show on non-AI cards too.
            if (!collapsed) {
                try {
                    if (root._vgLoadDocsForCard) root._vgLoadDocsForCard(card, false);
                } catch (eLD) {}
            }
        }

        var fbtn = e.target.closest && e.target.closest('[data-kanban-focus]');
        if (fbtn) {
            e.preventDefault();
            var card2 = fbtn.closest('.vg-kanban-card');
            if (!card2) return;
            var buyer2 = '';
            try {
                var t = card2.querySelector('.vg-kanban-card__windowbar-title');
                buyer2 = t ? (t.textContent || '').trim() : '';
            } catch (eT) {}
            openCardFocus(card2, { title: buyer2 || 'Dettaglio' });
            return;
        }

        // Docs list is auto-loaded; no click handler.
    });

    // Focus modal lives outside #vg-kanban-root (appended to document.body),
    // so clicks inside it won't reach the handler above.
    document.addEventListener('click', function (e) {
        var compilaBtn = e.target && e.target.closest ? e.target.closest('[data-kanban-compila]') : null;
        if (compilaBtn) {
            e.preventDefault();
            openCompila({
                itemId: compilaBtn.getAttribute('data-item-id'),
                origin: compilaBtn.getAttribute('data-origin') || 'ai',
                fileId: compilaBtn.getAttribute('data-file-id') || '',
                uploadId: compilaBtn.getAttribute('data-upload-id') || '',
                filename: compilaBtn.getAttribute('data-filename') || 'documento',
                contentType: compilaBtn.getAttribute('data-doc-ct') || ''
            });
            return;
        }
                var docLink = e.target && e.target.closest ? e.target.closest('[data-kanban-doc-open]') : null;
        if (!docLink) return;
        // avoid double-handling when click is inside root (root handler already ran)
        try { if (root && root.contains && root.contains(docLink)) return; } catch (eC) {}
        e.preventDefault();
        openDocbox({
            title: docLink.getAttribute('data-doc-filename') || 'Documento',
            filename: docLink.getAttribute('data-doc-filename') || '',
            url: docLink.getAttribute('data-doc-url') || docLink.getAttribute('href') || '',
            contentType: docLink.getAttribute('data-doc-ct') || ''
        });
    });

    document.addEventListener('vg-kanban-updated', function () {
        if (!booted) return;
        refresh().catch(function () {});
    });

    document.addEventListener('vg-kanban-compile-saved', function (ev) {
        try {
            if (typeof _vgFocusRefreshDocsCb === 'function') _vgFocusRefreshDocsCb();
        } catch (eCs) {}
        try {
            var itemId = ev && ev.detail && ev.detail.itemId;
            if (!itemId || !root || !root.querySelector) return;
            var card = root.querySelector('.vg-kanban-card[data-item-id="' + String(itemId) + '"]');
            if (card && root._vgLoadDocsForCard) root._vgLoadDocsForCard(card, true);
        } catch (eCard) {}
    });

    document.addEventListener('visibilitychange', function () {
        try {
            if (!booted) return;
            if (document.visibilityState !== 'visible') return;
            if (hasOpenLightbox()) return;
            if (!hasPendingAiCardsInDom()) return;
            ensurePendingAiRefreshLoop();
            refreshPendingAiCards();
        } catch (e) {}
    });

    boot();
    }

    injectNoIndexIfMissing();
    ensureMuuriThen(function (err) {
        if (err || typeof Muuri === 'undefined') {
            setStatusEarly((err && err.message) ? err.message : 'Muuri non disponibile');
            return;
        }
        initBoard();
    });
})(window, document);
